import "./src691146790.c716230a.js";
import "./src691146790.7cdb9b4c.js";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3e1a"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3e1a"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5N0Bk", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; });

var $5UIir = parcelRequire("5UIir");
function isNodeEnv() {
    return !(0, $5UIir.isBrowserBundle)() && Object.prototype.toString.call(0) === "[object process]";
}
function dynamicRequire(mod, request) {
    return mod.require(request);
}
function loadModule(moduleName, existingModule = module) {
    let mod;
    try {
        mod = dynamicRequire(existingModule, moduleName);
    } catch  {}
    if (!mod) try {
        const { cwd } = dynamicRequire(existingModule, "process");
        mod = dynamicRequire(existingModule, `${cwd()}/node_modules/${moduleName}`);
    } catch  {}
    return mod;
}

});
parcelRegister("5UIir", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", function () { return $44e48b16239d933c$export$2928c40372e623c0; });
function $44e48b16239d933c$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function $44e48b16239d933c$export$8ad33f488b1ab046() {
    /*! __SENTRY_SDK_SOURCE__ */ return "npm";
}

});



var $gaxBK = parcelRequire("gaxBK");

var $e3Llk = parcelRequire("e3Llk");
var $7Y1KN = parcelRequire("7Y1KN");
var $w8bd7 = parcelRequire("w8bd7");
var $2vdTp = parcelRequire("2vdTp");

var $2vdTp = parcelRequire("2vdTp");

var $hv7EP = parcelRequire("hv7EP");

var $h9p4m = parcelRequire("h9p4m");

var $7Y1KN = parcelRequire("7Y1KN");
function $0b08dfe1f7a400f1$export$14a186326edbb264(context) {
    const startingTime = (0, $7Y1KN.timestampInSeconds)();
    const session = {
        sid: (0, $h9p4m.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$0b08dfe1f7a400f1$var$sessionToJSON(session)
    };
    if (context) $0b08dfe1f7a400f1$export$531818e825e774db(session, context);
    return session;
}
function $0b08dfe1f7a400f1$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $7Y1KN.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) session.sid = context.sid.length === 32 ? context.sid : (0, $h9p4m.uuid4)();
    if (context.init !== void 0) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = void 0;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
function $0b08dfe1f7a400f1$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $0b08dfe1f7a400f1$export$531818e825e774db(session, context);
}
function $0b08dfe1f7a400f1$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1e3).toISOString(),
        timestamp: new Date(session.timestamp * 1e3).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}



var $w8bd7 = parcelRequire("w8bd7");

var $9ISAs = parcelRequire("9ISAs");
function $679ef7acd798ab4f$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    if (!mergeObj || typeof mergeObj !== "object" || levels <= 0) return mergeObj;
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    const output = {
        ...initialObj
    };
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $679ef7acd798ab4f$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}



var $h9p4m = parcelRequire("h9p4m");

var $h9p4m = parcelRequire("h9p4m");
function $79bbaa211fcfeb5f$export$dc6d7ea554bcce10() {
    return (0, $h9p4m.uuid4)();
}
function $79bbaa211fcfeb5f$export$295213bc4d0c54ad() {
    return (0, $h9p4m.uuid4)().substring(16);
}



var $4S04j = parcelRequire("4S04j");

var $4zVoD = parcelRequire("4zVoD");

var $bZENS = parcelRequire("bZENS");
function $bad34d468ab0dd71$export$f0b98edec95fcb33(value) {
    try {
        const WeakRefImpl = (0, $bZENS.GLOBAL_OBJ).WeakRef;
        if (typeof WeakRefImpl === "function") return new WeakRefImpl(value);
    } catch  {}
    return value;
}
function $bad34d468ab0dd71$export$a0592ad8c3586cf(ref) {
    if (!ref) return void 0;
    if (typeof ref === "object" && "deref" in ref && typeof ref.deref === "function") try {
        return ref.deref();
    } catch  {
        return void 0;
    }
    return ref;
}


const $376e868a0a8b0a7f$var$SCOPE_SPAN_FIELD = "_sentrySpan";
function $376e868a0a8b0a7f$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $4zVoD.addNonEnumerableProperty)(scope, $376e868a0a8b0a7f$var$SCOPE_SPAN_FIELD, (0, $bad34d468ab0dd71$export$f0b98edec95fcb33)(span));
    else delete scope[$376e868a0a8b0a7f$var$SCOPE_SPAN_FIELD];
}
function $376e868a0a8b0a7f$export$91f063ebb8eff307(scope) {
    return (0, $bad34d468ab0dd71$export$a0592ad8c3586cf)(scope[$376e868a0a8b0a7f$var$SCOPE_SPAN_FIELD]);
}



var $kWdMm = parcelRequire("kWdMm");

var $7Y1KN = parcelRequire("7Y1KN");
const $ef63688041cb6965$var$DEFAULT_MAX_BREADCRUMBS = 100;
class $ef63688041cb6965$export$775b6bb06e53a214 {
    // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $79bbaa211fcfeb5f$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $4S04j.safeMathRandom)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $ef63688041cb6965$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $376e868a0a8b0a7f$export$3f25fa50c18e20ca)(newScope, (0, $376e868a0a8b0a7f$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        this._user = user || {
            email: void 0,
            id: void 0,
            ip_address: void 0,
            username: void 0
        };
        if (this._session) (0, $0b08dfe1f7a400f1$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || void 0;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param newAttributes - The attributes to set on the scope, as key-value pairs.
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: 150,
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are applied to logs, metrics and streamed spans.
   *
   * Supported attribute value types are `string`, `number`, `boolean`, `string[]`, `number[]` and `boolean[]`.
   *
   * @param key - The attribute key.
   * @param value - The attribute value.
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', 150);
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $ef63688041cb6965$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $9ISAs.isPlainObject)(scopeToMerge) ? captureContext : void 0;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._session = void 0;
        this._conversationId = void 0;
        (0, $376e868a0a8b0a7f$export$3f25fa50c18e20ca)(this, void 0);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $79bbaa211fcfeb5f$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $4S04j.safeMathRandom)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $ef63688041cb6965$var$DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $7Y1KN.dateTimestampInSeconds)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $kWdMm.truncate)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent("buffer_overflow", "log_item");
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $376e868a0a8b0a7f$export$91f063ebb8eff307)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $679ef7acd798ab4f$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $h9p4m.uuid4)();
        if (!this._client) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $h9p4m.uuid4)();
        if (!this._client) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = event.event_id || hint?.event_id || (0, $h9p4m.uuid4)();
        if (!this._client) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


function $5899f70749d8aa02$export$6f1b9191db9c4d5() {
    return (0, $2vdTp.getGlobalSingleton)("defaultCurrentScope", ()=>new (0, $ef63688041cb6965$export$775b6bb06e53a214)());
}
function $5899f70749d8aa02$export$de9862929b76bf57() {
    return (0, $2vdTp.getGlobalSingleton)("defaultIsolationScope", ()=>new (0, $ef63688041cb6965$export$775b6bb06e53a214)());
}



const $7d21460bd8c3b8b2$var$isActualPromise = (p)=>p instanceof Promise && !p[$7d21460bd8c3b8b2$var$kChainedCopy];
const $7d21460bd8c3b8b2$var$kChainedCopy = /* @__PURE__ */ Symbol("chained PromiseLike");
const $7d21460bd8c3b8b2$export$64da0f40b0f924ba = (original, onSuccess, onError)=>{
    const chained = original.then((value)=>{
        onSuccess(value);
        return value;
    }, (err)=>{
        onError(err);
        throw err;
    });
    return $7d21460bd8c3b8b2$var$isActualPromise(chained) && $7d21460bd8c3b8b2$var$isActualPromise(original) ? chained : $7d21460bd8c3b8b2$var$copyProps(original, chained);
};
const $7d21460bd8c3b8b2$var$copyProps = (original, chained)=>{
    if (!chained) return original;
    let mutated = false;
    for(const key in original){
        if (key in chained) continue;
        mutated = true;
        const value = original[key];
        if (typeof value === "function") Object.defineProperty(chained, key, {
            value: (...args)=>value.apply(original, args),
            enumerable: true,
            configurable: true,
            writable: true
        });
        else chained[key] = value;
    }
    if (mutated) Object.assign(chained, {
        [$7d21460bd8c3b8b2$var$kChainedCopy]: true
    });
    return chained;
};



var $9ISAs = parcelRequire("9ISAs");

var $2vdTp = parcelRequire("2vdTp");
class $19cd4ce48fbfcace$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $ef63688041cb6965$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $ef63688041cb6965$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $9ISAs.isThenable)(maybePromiseResult)) return (0, $7d21460bd8c3b8b2$export$64da0f40b0f924ba)(maybePromiseResult, ()=>this._popScope(), ()=>this._popScope());
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
function $19cd4ce48fbfcace$var$getAsyncContextStack() {
    const registry = (0, $2vdTp.getMainCarrier)();
    const sentry = (0, $2vdTp.getSentryCarrier)(registry);
    return sentry.stack = sentry.stack || new $19cd4ce48fbfcace$export$d36ec451f120cfba((0, $5899f70749d8aa02$export$6f1b9191db9c4d5)(), (0, $5899f70749d8aa02$export$de9862929b76bf57)());
}
function $19cd4ce48fbfcace$var$withScope(callback) {
    return $19cd4ce48fbfcace$var$getAsyncContextStack().withScope(callback);
}
function $19cd4ce48fbfcace$var$withSetScope(scope, callback) {
    const stack = $19cd4ce48fbfcace$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $19cd4ce48fbfcace$var$withIsolationScope(callback) {
    return $19cd4ce48fbfcace$var$getAsyncContextStack().withScope(()=>{
        return callback($19cd4ce48fbfcace$var$getAsyncContextStack().getIsolationScope());
    });
}
function $19cd4ce48fbfcace$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $19cd4ce48fbfcace$var$withIsolationScope,
        withScope: $19cd4ce48fbfcace$var$withScope,
        withSetScope: $19cd4ce48fbfcace$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $19cd4ce48fbfcace$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$19cd4ce48fbfcace$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$19cd4ce48fbfcace$var$getAsyncContextStack().getIsolationScope()
    };
}


function $a0d67ab23fb41d37$export$774ae0e6b6e444ca(strategy) {
    const registry = (0, $2vdTp.getMainCarrier)();
    const sentry = (0, $2vdTp.getSentryCarrier)(registry);
    sentry.acs = strategy;
}
function $a0d67ab23fb41d37$export$f639b0c2752203be(carrier) {
    const sentry = (0, $2vdTp.getSentryCarrier)(carrier);
    if (sentry.acs) return sentry.acs;
    return (0, $19cd4ce48fbfcace$export$329d4d4d54e42710)();
}



var $9ISAs = parcelRequire("9ISAs");
function $2153622a95889374$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === "object" && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes("value");
}
function $2153622a95889374$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $2153622a95889374$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: void 0
    };
    const attributeValue = $2153622a95889374$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === "string" ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === "skip-undefined" && value === void 0) return;
    let stringValue = "";
    try {
        stringValue = JSON.stringify(value) ?? "";
    } catch  {}
    return {
        value: stringValue,
        type: "string",
        ...checkedUnit
    };
}
function $2153622a95889374$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $2153622a95889374$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
function $2153622a95889374$export$97341f7cd97c59f(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    for (const [key, attr] of Object.entries(attributes)){
        weight += key.length * 2;
        weight += attr.type.length * 2;
        weight += (attr.unit?.length ?? 0) * 2;
        const val = attr.value;
        if (Array.isArray(val)) weight += $2153622a95889374$var$estimatePrimitiveSizeInBytes(val[0]) * val.length;
        else if ((0, $9ISAs.isPrimitive)(val)) weight += $2153622a95889374$var$estimatePrimitiveSizeInBytes(val);
        else weight += 100;
    }
    return weight;
}
function $2153622a95889374$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === "string") return value.length * 2;
    else if (typeof value === "boolean") return 4;
    else if (typeof value === "number") return 8;
    return 0;
}
function $2153622a95889374$var$getTypedAttributeValue(value) {
    if (Array.isArray(value)) return {
        value: value,
        type: "array"
    };
    const primitiveType = typeof value === "string" ? "string" : typeof value === "boolean" ? "boolean" : typeof value === "number" && !Number.isNaN(value) ? Number.isInteger(value) ? "integer" : "double" : null;
    if (primitiveType) return {
        value: value,
        type: primitiveType
    };
}



var $2vdTp = parcelRequire("2vdTp");


var $2vdTp = parcelRequire("2vdTp");


let $9f9f083568f3177b$var$_externalPropagationContextProvider;
function $9f9f083568f3177b$export$b5defb3466e9689b(fn) {
    $9f9f083568f3177b$var$_externalPropagationContextProvider = fn;
}
function $9f9f083568f3177b$export$92547f779c920a71() {
    return $9f9f083568f3177b$var$_externalPropagationContextProvider?.();
}
function $9f9f083568f3177b$export$53f0ae651a1c4298() {
    return $9f9f083568f3177b$var$_externalPropagationContextProvider !== void 0;
}
function $9f9f083568f3177b$export$c7be4b0125a10cba() {
    const carrier = (0, $2vdTp.getMainCarrier)();
    const acs = (0, $a0d67ab23fb41d37$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
function $9f9f083568f3177b$export$68f3af03034c9e90() {
    const carrier = (0, $2vdTp.getMainCarrier)();
    const acs = (0, $a0d67ab23fb41d37$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
function $9f9f083568f3177b$export$aa55d5ab8e05984f() {
    return (0, $2vdTp.getGlobalSingleton)("globalScope", ()=>new (0, $ef63688041cb6965$export$775b6bb06e53a214)());
}
function $9f9f083568f3177b$export$ec58d9285c204497(...rest) {
    const carrier = (0, $2vdTp.getMainCarrier)();
    const acs = (0, $a0d67ab23fb41d37$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
function $9f9f083568f3177b$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $2vdTp.getMainCarrier)();
    const acs = (0, $a0d67ab23fb41d37$export$f639b0c2752203be)(carrier);
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
function $9f9f083568f3177b$export$6bb76d6eba7e258c() {
    return $9f9f083568f3177b$export$c7be4b0125a10cba().getClient();
}
function $9f9f083568f3177b$export$1e83db7ee4876dc4(scope) {
    const externalContext = $9f9f083568f3177b$export$92547f779c920a71();
    if (externalContext) return {
        trace_id: externalContext.traceId,
        span_id: externalContext.spanId
    };
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $79bbaa211fcfeb5f$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}


const $c30a0c8ed977cb48$export$d7a7d984b0791405 = "sentry.source";
const $c30a0c8ed977cb48$export$ccfe0a40627cc34b = "sentry.sample_rate";
const $c30a0c8ed977cb48$export$889fb736668e1ecc = "sentry.previous_trace_sample_rate";
const $c30a0c8ed977cb48$export$1a413bd9a88fdb09 = "sentry.op";
const $c30a0c8ed977cb48$export$cca8dd30f57f805e = "sentry.origin";
const $c30a0c8ed977cb48$export$d9e02c0285078f88 = "sentry.status.message";
const $c30a0c8ed977cb48$export$ba73f34502b7a3b3 = "sentry.idle_span_finish_reason";
const $c30a0c8ed977cb48$export$f5f95cff026507b5 = "sentry.measurement_unit";
const $c30a0c8ed977cb48$export$69cd5c610c7bb96a = "sentry.measurement_value";
const $c30a0c8ed977cb48$export$f5cefb258679b29e = "sentry.release";
const $c30a0c8ed977cb48$export$d1b1dbb47f5ba57c = "sentry.environment";
const $c30a0c8ed977cb48$export$4626f2be16112c1c = "sentry.segment.name";
const $c30a0c8ed977cb48$export$25fa4a1832d3736a = "sentry.segment.id";
const $c30a0c8ed977cb48$export$87a4807042e1f1bb = "sentry.sdk.name";
const $c30a0c8ed977cb48$export$301ebe936458e291 = "sentry.sdk.version";
const $c30a0c8ed977cb48$export$bd847b1cc92ae587 = "sentry.sdk.integrations";
const $c30a0c8ed977cb48$export$1f9cc1d34ea098a0 = "user.id";
const $c30a0c8ed977cb48$export$b7466609ef46c07e = "user.email";
const $c30a0c8ed977cb48$export$8d592bdaea63b930 = "user.ip_address";
const $c30a0c8ed977cb48$export$c05ee933d3f74b2b = "user.name";
const $c30a0c8ed977cb48$export$165ce9a229f6f050 = "sentry.custom_span_name";
const $c30a0c8ed977cb48$export$1efec95406bbe327 = "sentry.profile_id";
const $c30a0c8ed977cb48$export$fea48ba9f4550879 = "sentry.exclusive_time";
const $c30a0c8ed977cb48$export$b016f89ac1066ec = "cache.hit";
const $c30a0c8ed977cb48$export$3110e4c3f4386399 = "cache.key";
const $c30a0c8ed977cb48$export$86be76deee227ff2 = "cache.item_size";
const $c30a0c8ed977cb48$export$be7a251980e7e946 = "http.request.method";
const $c30a0c8ed977cb48$export$25dfd73e0e32c6e1 = "url.full";
const $c30a0c8ed977cb48$export$ff77b5fd5b2d627b = "sentry.link.type";
const $c30a0c8ed977cb48$export$71a4a707257f2774 = "gen_ai.conversation.id";


const $93490f49a9d2f84d$export$136e25984ba4a383 = 0;
const $93490f49a9d2f84d$export$58f7963109c806fc = 1;
const $93490f49a9d2f84d$export$f966a0446ece71e = 2;
function $93490f49a9d2f84d$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $93490f49a9d2f84d$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: "unauthenticated"
            };
        case 403:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: "permission_denied"
            };
        case 404:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: "not_found"
            };
        case 409:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: "already_exists"
            };
        case 413:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: "failed_precondition"
            };
        case 429:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: "resource_exhausted"
            };
        case 499:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: "cancelled"
            };
        default:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: "invalid_argument"
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: "unimplemented"
            };
        case 503:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: "unavailable"
            };
        case 504:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: "deadline_exceeded"
            };
        default:
            return {
                code: $93490f49a9d2f84d$export$f966a0446ece71e,
                message: "internal_error"
            };
    }
    return {
        code: $93490f49a9d2f84d$export$f966a0446ece71e,
        message: "internal_error"
    };
}
function $93490f49a9d2f84d$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute("http.response.status_code", httpStatus);
    const spanStatus = $93490f49a9d2f84d$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== "unknown_error") span.setStatus(spanStatus);
}



var $4zVoD = parcelRequire("4zVoD");

const $6a7ac6221a05ac94$var$SCOPE_ON_START_SPAN_FIELD = "_sentryScope";
const $6a7ac6221a05ac94$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = "_sentryIsolationScope";
const $6a7ac6221a05ac94$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceInference");
const $6a7ac6221a05ac94$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.otelSourceExplicitlySet");
const $6a7ac6221a05ac94$var$TRACER_PROVIDER_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.tracerProviderSpan");
function $6a7ac6221a05ac94$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $4zVoD.addNonEnumerableProperty)(span, $6a7ac6221a05ac94$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, (0, $bad34d468ab0dd71$export$f0b98edec95fcb33)(isolationScope));
        (0, $4zVoD.addNonEnumerableProperty)(span, $6a7ac6221a05ac94$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
function $6a7ac6221a05ac94$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$6a7ac6221a05ac94$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: (0, $bad34d468ab0dd71$export$a0592ad8c3586cf)(spanWithScopes[$6a7ac6221a05ac94$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}
function $6a7ac6221a05ac94$export$d135494e80cbbcae(span) {
    (0, $4zVoD.addNonEnumerableProperty)(span, $6a7ac6221a05ac94$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD, true);
}
function $6a7ac6221a05ac94$export$2e69b79005fc86eb(span) {
    return span[$6a7ac6221a05ac94$var$OTEL_SOURCE_INFERENCE_SPAN_FIELD] === true;
}
function $6a7ac6221a05ac94$export$c45f16c039fb5033(span) {
    (0, $4zVoD.addNonEnumerableProperty)(span, $6a7ac6221a05ac94$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD, true);
}
function $6a7ac6221a05ac94$export$aceb4106f395d20e(span) {
    return span[$6a7ac6221a05ac94$var$OTEL_SOURCE_EXPLICITLY_SET_SPAN_FIELD] === true;
}
function $6a7ac6221a05ac94$export$6ba79447c0a2d852(span) {
    (0, $4zVoD.addNonEnumerableProperty)(span, $6a7ac6221a05ac94$var$TRACER_PROVIDER_SPAN_FIELD, true);
}
function $6a7ac6221a05ac94$export$a9ba2a501dbf6a56(span) {
    return span[$6a7ac6221a05ac94$var$TRACER_PROVIDER_SPAN_FIELD] === true;
}



var $4zVoD = parcelRequire("4zVoD");


var $7Y1KN = parcelRequire("7Y1KN");

var $w8bd7 = parcelRequire("w8bd7");

var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");

var $9ISAs = parcelRequire("9ISAs");
const $595633d6b82db2c0$export$6e69537d67fa20f = "sentry-";
const $595633d6b82db2c0$export$eb0401070c617ea5 = /^sentry-/;
const $595633d6b82db2c0$export$bdd844ddb2def819 = 8192;
function $595633d6b82db2c0$export$5b96ee2c8421f107(baggageHeader) {
    const baggageObject = $595633d6b82db2c0$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return void 0;
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.startsWith($595633d6b82db2c0$export$6e69537d67fa20f)) {
            const nonPrefixedKey = key.slice($595633d6b82db2c0$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return void 0;
}
function $595633d6b82db2c0$export$56766feef403f365(dynamicSamplingContext) {
    if (!dynamicSamplingContext) return void 0;
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$595633d6b82db2c0$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $595633d6b82db2c0$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
function $595633d6b82db2c0$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $9ISAs.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return void 0;
    if (Array.isArray(baggageHeader)) return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $595633d6b82db2c0$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $595633d6b82db2c0$var$baggageHeaderToObject(baggageHeader);
}
function $595633d6b82db2c0$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf("=");
        if (eqIdx === -1) return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $595633d6b82db2c0$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) return void 0;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $595633d6b82db2c0$export$bdd844ddb2def819) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}
function $595633d6b82db2c0$export$7b8640b7baaa3922(existing, incoming) {
    if (!existing) return incoming;
    const existingEntries = $595633d6b82db2c0$export$397de414d189db00(existing);
    const incomingEntries = $595633d6b82db2c0$export$397de414d189db00(incoming);
    if (!incomingEntries) return existing;
    const merged = {};
    let hasNewSentryEntries = false;
    const newSentryEntries = {};
    const newNonSentryEntries = {};
    for (const [key, value] of Object.entries(incomingEntries))if (key.startsWith($595633d6b82db2c0$export$6e69537d67fa20f)) {
        newSentryEntries[key] = value;
        hasNewSentryEntries = true;
    } else newNonSentryEntries[key] = value;
    if (existingEntries) {
        for (const [key, value] of Object.entries(existingEntries))if (!hasNewSentryEntries || !key.startsWith($595633d6b82db2c0$export$6e69537d67fa20f)) merged[key] = value;
    }
    if (hasNewSentryEntries) Object.assign(merged, newSentryEntries);
    for (const [key, value] of Object.entries(newNonSentryEntries))merged[key] ?? (merged[key] = value);
    return $595633d6b82db2c0$export$12a7349a29a6e3c2(merged);
}



var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");
const $4038a06ed5b23254$var$ORG_ID_REGEX = /^o(\d+)\./;
const $4038a06ed5b23254$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $4038a06ed5b23254$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
function $4038a06ed5b23254$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function $4038a06ed5b23254$export$b892860177f70a30(str) {
    const match = $4038a06ed5b23254$var$DSN_REGEX.exec(str);
    if (!match) {
        (0, $w8bd7.consoleSandbox)(()=>{
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return void 0;
    }
    const [protocol, publicKey, pass = "", host = "", port = "", lastPath = ""] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $4038a06ed5b23254$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $4038a06ed5b23254$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $4038a06ed5b23254$var$validateDsn(dsn) {
    if (!(0, $hv7EP.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $w8bd7.debug).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $w8bd7.debug).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$4038a06ed5b23254$var$isValidProtocol(protocol)) {
        (0, $w8bd7.debug).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $w8bd7.debug).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
function $4038a06ed5b23254$export$5914f4e7748c29c9(host) {
    const match = host.match($4038a06ed5b23254$var$ORG_ID_REGEX);
    return match?.[1];
}
function $4038a06ed5b23254$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $4038a06ed5b23254$export$5914f4e7748c29c9(host);
    return org_id;
}
function $4038a06ed5b23254$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $4038a06ed5b23254$export$b892860177f70a30(from) : $4038a06ed5b23254$var$dsnFromComponents(from);
    if (!components || !$4038a06ed5b23254$var$validateDsn(components)) return void 0;
    return components;
}


function $75813448dd2615ee$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === "boolean") return Number(sampleRate);
    const rate = typeof sampleRate === "string" ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== "number" || isNaN(rate) || rate < 0 || rate > 1) return void 0;
    return rate;
}




var $4S04j = parcelRequire("4S04j");
const $e00f06df584cff55$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
function $e00f06df584cff55$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return void 0;
    const matches = traceparent.match($e00f06df584cff55$export$394a210812ba3012);
    if (!matches) return void 0;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
function $e00f06df584cff55$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $e00f06df584cff55$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $595633d6b82db2c0$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $79bbaa211fcfeb5f$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $4S04j.safeMathRandom)()
    };
    const sampleRand = $e00f06df584cff55$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
        sampleRand
    };
}
function $e00f06df584cff55$export$f35d907436da45cf(traceId = (0, $79bbaa211fcfeb5f$export$dc6d7ea554bcce10)(), spanId = (0, $79bbaa211fcfeb5f$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = "";
    if (sampled !== void 0) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}
function $e00f06df584cff55$export$1aff3752542747dd(traceId = (0, $79bbaa211fcfeb5f$export$dc6d7ea554bcce10)(), spanId = (0, $79bbaa211fcfeb5f$export$295213bc4d0c54ad)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? "01" : "00"}`;
}
function $e00f06df584cff55$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    const parsedSampleRand = (0, $75813448dd2615ee$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== void 0) return parsedSampleRand;
    const parsedSampleRate = (0, $75813448dd2615ee$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== void 0) return traceparentData.parentSampled ? // Returns a sample rand with positive sampling decision [0, sampleRate)
    (0, $4S04j.safeMathRandom)() * parsedSampleRate : // Returns a sample rand with negative sampling decision [sampleRate, 1)
    parsedSampleRate + (0, $4S04j.safeMathRandom)() * (1 - parsedSampleRate);
    else return (0, $4S04j.safeMathRandom)();
}
function $e00f06df584cff55$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $4038a06ed5b23254$export$b7ac9b8efa4bb595)(client);
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $w8bd7.debug).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false;
    if (strictTraceContinuation) {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $w8bd7.debug).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}



var $w8bd7 = parcelRequire("w8bd7");

const $d3a61c536a2d1d8c$export$208d5b368507fb8b = 0;
const $d3a61c536a2d1d8c$export$eb571cd9b5d98de8 = 1;
let $d3a61c536a2d1d8c$var$hasShownSpanDropWarning = false;
function $d3a61c536a2d1d8c$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $d3a61c536a2d1d8c$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
function $d3a61c536a2d1d8c$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    const parent_span_id = isRemote ? spanId : $d3a61c536a2d1d8c$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $6a7ac6221a05ac94$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $79bbaa211fcfeb5f$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
function $d3a61c536a2d1d8c$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $d3a61c536a2d1d8c$export$5caecac1caaf3a71(span);
    return (0, $e00f06df584cff55$export$f35d907436da45cf)(traceId, spanId, sampled);
}
function $d3a61c536a2d1d8c$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $d3a61c536a2d1d8c$export$5caecac1caaf3a71(span);
    return (0, $e00f06df584cff55$export$1aff3752542747dd)(traceId, spanId, sampled);
}
function $d3a61c536a2d1d8c$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $d3a61c536a2d1d8c$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return void 0;
}
function $d3a61c536a2d1d8c$export$9015adcf158ef3a5(links) {
    if (links?.length) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $d3a61c536a2d1d8c$export$eb571cd9b5d98de8,
            attributes: attributes
        }));
    else return void 0;
}
function $d3a61c536a2d1d8c$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $d3a61c536a2d1d8c$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $d3a61c536a2d1d8c$var$ensureTimestampInSeconds(input.getTime());
    return (0, $7Y1KN.timestampInSeconds)();
}
function $d3a61c536a2d1d8c$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1e3 : timestamp;
}
function $d3a61c536a2d1d8c$export$92d8c23565496537(span) {
    if ($d3a61c536a2d1d8c$export$50882270da12d911(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($d3a61c536a2d1d8c$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: $d3a61c536a2d1d8c$var$getOtelParentSpanId(span),
            start_timestamp: $d3a61c536a2d1d8c$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $d3a61c536a2d1d8c$export$3f7581298f56c6d7(endTime) || void 0,
            status: $d3a61c536a2d1d8c$export$e238a77ea3a8cd66(status),
            op: attributes[0, $c30a0c8ed977cb48$export$1a413bd9a88fdb09],
            origin: attributes[0, $c30a0c8ed977cb48$export$cca8dd30f57f805e],
            links: $d3a61c536a2d1d8c$export$cb3e3a12e0eec16c(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $d3a61c536a2d1d8c$export$db0cad9e44f67af8(span) {
    if ($d3a61c536a2d1d8c$export$50882270da12d911(span)) return span.getStreamedSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    if ($d3a61c536a2d1d8c$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        return {
            name: name,
            span_id: span_id,
            trace_id: trace_id,
            parent_span_id: $d3a61c536a2d1d8c$var$getOtelParentSpanId(span),
            start_timestamp: $d3a61c536a2d1d8c$export$3f7581298f56c6d7(startTime),
            end_timestamp: $d3a61c536a2d1d8c$export$3f7581298f56c6d7(endTime),
            is_segment: span === $d3a61c536a2d1d8c$export$7a3106f345d83bb6(span),
            status: $d3a61c536a2d1d8c$export$d3856a3187d34821(status),
            attributes: $d3a61c536a2d1d8c$export$1464a9cb828ba99f(attributes, status),
            links: $d3a61c536a2d1d8c$export$9015adcf158ef3a5(links)
        };
    }
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        name: "",
        end_timestamp: 0,
        status: "ok",
        is_segment: span === $d3a61c536a2d1d8c$export$7a3106f345d83bb6(span)
    };
}
function $d3a61c536a2d1d8c$var$getOtelParentSpanId(span) {
    return "parentSpanId" in span ? span.parentSpanId : "parentSpanContext" in span ? span.parentSpanContext?.spanId : void 0;
}
function $d3a61c536a2d1d8c$export$5402aa553bcf35f3(spanJson) {
    return {
        ...spanJson,
        attributes: (0, $2153622a95889374$export$4954cae66e755861)(spanJson.attributes),
        links: spanJson.links?.map((link)=>({
                ...link,
                attributes: (0, $2153622a95889374$export$4954cae66e755861)(link.attributes)
            }))
    };
}
function $d3a61c536a2d1d8c$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
function $d3a61c536a2d1d8c$export$50882270da12d911(span) {
    return typeof span.getSpanJSON === "function";
}
function $d3a61c536a2d1d8c$export$5caecac1caaf3a71(span) {
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $d3a61c536a2d1d8c$export$eb571cd9b5d98de8;
}
function $d3a61c536a2d1d8c$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $93490f49a9d2f84d$export$136e25984ba4a383)) return void 0;
    if (status.code === (0, $93490f49a9d2f84d$export$58f7963109c806fc)) return "ok";
    return status.message || "internal_error";
}
function $d3a61c536a2d1d8c$export$d3856a3187d34821(status) {
    return !status || status.code === (0, $93490f49a9d2f84d$export$58f7963109c806fc) || status.code === (0, $93490f49a9d2f84d$export$136e25984ba4a383) || status.message === "cancelled" ? "ok" : "error";
}
function $d3a61c536a2d1d8c$export$1464a9cb828ba99f(attributes, status) {
    const statusMessage = $d3a61c536a2d1d8c$export$d3856a3187d34821(status) === "error" ? status?.message : void 0;
    return {
        ...statusMessage && {
            [(0, $c30a0c8ed977cb48$export$d9e02c0285078f88)]: statusMessage
        },
        ...attributes
    };
}
const $d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD = "_sentryChildSpans";
const $d3a61c536a2d1d8c$var$ROOT_SPAN_FIELD = "_sentryRootSpan";
function $d3a61c536a2d1d8c$export$81397d924722cc65(span, childSpan) {
    const rootSpan = span[$d3a61c536a2d1d8c$var$ROOT_SPAN_FIELD] || span;
    (0, $4zVoD.addNonEnumerableProperty)(childSpan, $d3a61c536a2d1d8c$var$ROOT_SPAN_FIELD, rootSpan);
    if (span[$d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD]) span[$d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $4zVoD.addNonEnumerableProperty)(span, $d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD, /* @__PURE__ */ new Set([
        childSpan
    ]));
}
function $d3a61c536a2d1d8c$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD]) span[$d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD].delete(childSpan);
}
function $d3a61c536a2d1d8c$export$340c5c8a13ffc680(span) {
    const resultSet = /* @__PURE__ */ new Set();
    function addSpanChildren(span2) {
        if (resultSet.has(span2)) return;
        else if ($d3a61c536a2d1d8c$export$5caecac1caaf3a71(span2)) {
            resultSet.add(span2);
            const childSpans = span2[$d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD] ? Array.from(span2[$d3a61c536a2d1d8c$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
const $d3a61c536a2d1d8c$export$c4c6a79b1260ca1b = $d3a61c536a2d1d8c$export$7a3106f345d83bb6;
function $d3a61c536a2d1d8c$export$7a3106f345d83bb6(span) {
    return span[$d3a61c536a2d1d8c$var$ROOT_SPAN_FIELD] || span;
}
function $d3a61c536a2d1d8c$export$1be426a8e585c83e() {
    const carrier = (0, $2vdTp.getMainCarrier)();
    const acs = (0, $a0d67ab23fb41d37$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $376e868a0a8b0a7f$export$91f063ebb8eff307)((0, $9f9f083568f3177b$export$c7be4b0125a10cba)());
}
function $d3a61c536a2d1d8c$export$d11691ff45a3e535() {
    if (!$d3a61c536a2d1d8c$var$hasShownSpanDropWarning) {
        (0, $w8bd7.consoleSandbox)(()=>{
            console.warn("[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.");
        });
        $d3a61c536a2d1d8c$var$hasShownSpanDropWarning = true;
    }
}
function $d3a61c536a2d1d8c$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $c30a0c8ed977cb48$export$d7a7d984b0791405)]: "custom",
        [(0, $c30a0c8ed977cb48$export$165ce9a229f6f050)]: name
    });
}


var $9ISAs = parcelRequire("9ISAs");

var $bZENS = parcelRequire("bZENS");
const $a125234a7f829168$var$WINDOW = (0, $bZENS.GLOBAL_OBJ);
const $a125234a7f829168$var$DEFAULT_MAX_STRING_LENGTH = 80;
function $a125234a7f829168$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $a125234a7f829168$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $a125234a7f829168$var$_htmlElementAsString(currentElem, keyAttrs);
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return "<unknown>";
    }
}
function $a125234a7f829168$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return "";
    if ($a125234a7f829168$var$WINDOW.HTMLElement) {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
            if (elem.dataset["sentryElement"]) return elem.dataset["sentryElement"];
        }
    }
    out.push(elem.tagName.toLowerCase());
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $9ISAs.isString)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    for (const k of [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ]){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join("");
}
function $a125234a7f829168$export$1cfafeee2987818b() {
    try {
        return $a125234a7f829168$var$WINDOW.document.location.href;
    } catch  {
        return "";
    }
}
function $a125234a7f829168$export$26727cfcc4d7e0fc(elem, maxTraverseHeight = 5) {
    if (!$a125234a7f829168$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    for(let i = 0; i < maxTraverseHeight; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
            if (currentElem.dataset["sentryElement"]) return currentElem.dataset["sentryElement"];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}


var $9ISAs = parcelRequire("9ISAs");
const $b039a86df453775d$var$DEFAULT_BASE_URL = "thismessage:/";
function $b039a86df453775d$export$e258e13805402ba7(url) {
    return "isRelative" in url;
}
function $b039a86df453775d$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf("://") <= 0 && url.indexOf("//") !== 0;
    const base = urlBase ?? (isRelative ? $b039a86df453775d$var$DEFAULT_BASE_URL : void 0);
    try {
        if ("canParse" in URL && !URL.canParse(url, base)) return void 0;
        const fullUrlObject = new URL(url, base);
        if (isRelative) return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {}
    return void 0;
}
function $b039a86df453775d$export$5339fcdc8e2a427c(url) {
    if ($b039a86df453775d$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = "";
    newUrl.hash = "";
    if ([
        "80",
        "443"
    ].includes(newUrl.port)) newUrl.port = "";
    if (newUrl.password) newUrl.password = "%filtered%";
    if (newUrl.username) newUrl.username = "%filtered%";
    return newUrl.toString();
}
function $b039a86df453775d$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? "GET";
    const route = routeName ? routeName : urlObject ? kind === "client" ? $b039a86df453775d$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : "/";
    return `${method} ${route}`;
}
function $b039a86df453775d$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $c30a0c8ed977cb48$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $c30a0c8ed977cb48$export$d7a7d984b0791405)]: "url"
    };
    if (routeName) {
        attributes[kind === "server" ? "http.route" : "url.template"] = routeName;
        attributes[0, $c30a0c8ed977cb48$export$d7a7d984b0791405] = "route";
    }
    if (request?.method) attributes[0, $c30a0c8ed977cb48$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes["url.query"] = urlObject.search;
        if (urlObject.hash) attributes["url.fragment"] = urlObject.hash;
        if (urlObject.pathname) {
            attributes["url.path"] = urlObject.pathname;
            if (urlObject.pathname === "/") attributes[0, $c30a0c8ed977cb48$export$d7a7d984b0791405] = "route";
        }
        if (!$b039a86df453775d$export$e258e13805402ba7(urlObject)) {
            attributes[0, $c30a0c8ed977cb48$export$25dfd73e0e32c6e1] = urlObject.href;
            if (urlObject.port) attributes["url.port"] = urlObject.port;
            if (urlObject.protocol) attributes["url.scheme"] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === "server" ? "server.address" : "url.domain"] = urlObject.hostname;
        }
    }
    return [
        $b039a86df453775d$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
function $b039a86df453775d$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
function $b039a86df453775d$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
function $b039a86df453775d$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, "[filtered]:[filtered]@").replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}
function $b039a86df453775d$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith("data:")) {
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : "text/plain";
        const isBase64 = url.includes(";base64,");
        const dataStart = url.indexOf(",");
        let dataPrefix = "";
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ",base64" : ""}${dataPrefix ? `,${dataPrefix}` : ""}`;
    }
    return url;
}


var $hv7EP = parcelRequire("hv7EP");


var $w8bd7 = parcelRequire("w8bd7");

function $2174c183125e1337$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $d3a61c536a2d1d8c$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $d3a61c536a2d1d8c$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $c30a0c8ed977cb48$export$69cd5c610c7bb96a)]: value,
            [(0, $c30a0c8ed977cb48$export$f5f95cff026507b5)]: unit
        });
    }
}
function $2174c183125e1337$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return void 0;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $c30a0c8ed977cb48$export$f5f95cff026507b5];
        const value = attributes[0, $c30a0c8ed977cb48$export$69cd5c610c7bb96a];
        if (typeof unit === "string" && typeof value === "number") measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}


var $kWdMm = parcelRequire("kWdMm");

var $1rNqq = parcelRequire("1rNqq");

var $gWPaa = parcelRequire("gWPaa");

var $7Y1KN = parcelRequire("7Y1KN");
var $w8bd7 = parcelRequire("w8bd7");

var $9yfTK = parcelRequire("9yfTK");

var $1rNqq = parcelRequire("1rNqq");

var $w8bd7 = parcelRequire("w8bd7");
var $iFp2j = parcelRequire("iFp2j");

var $9yfTK = parcelRequire("9yfTK");

var $gWPaa = parcelRequire("gWPaa");
const $fad92f97e697697e$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return "poor";
    if (value > thresholds[0]) return "needs-improvement";
    return "good";
};
const $fad92f97e697697e$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue ?? 0);
                if (delta || prevValue === void 0) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $fad92f97e697697e$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};



var $gWPaa = parcelRequire("gWPaa");

var $gWPaa = parcelRequire("gWPaa");
const $83c5af87602f1470$export$6431553786c94949 = (checkResponseStart = true)=>{
    const navigationEntry = (0, $gWPaa.WINDOW).performance?.getEntriesByType?.("navigation")[0];
    if (// sentry-specific change:
    // We don't want to check for responseStart for our own use of `getNavigationEntry`
    !checkResponseStart || navigationEntry && navigationEntry.responseStart > 0 && navigationEntry.responseStart < performance.now()) return navigationEntry;
};


const $bc726a4d4c88cc5c$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $83c5af87602f1470$export$6431553786c94949)();
    return navEntry?.activationStart ?? 0;
};



var $8xeDY = parcelRequire("8xeDY");
let $2c37c13e89983912$var$firstHiddenTime = -1;
const $2c37c13e89983912$var$onHiddenFunctions = /* @__PURE__ */ new Set();
const $2c37c13e89983912$var$initHiddenTime = ()=>{
    return (0, $gWPaa.WINDOW).document?.visibilityState === "hidden" && !(0, $gWPaa.WINDOW).document?.prerendering ? 0 : Infinity;
};
const $2c37c13e89983912$var$onVisibilityUpdate = (event)=>{
    if ($2c37c13e89983912$var$isPageHidden(event) && $2c37c13e89983912$var$firstHiddenTime > -1) {
        if (event.type === "visibilitychange" || event.type === "pagehide") for (const onHiddenFunction of $2c37c13e89983912$var$onHiddenFunctions)onHiddenFunction();
        if (!isFinite($2c37c13e89983912$var$firstHiddenTime)) {
            $2c37c13e89983912$var$firstHiddenTime = event.type === "visibilitychange" ? event.timeStamp : 0;
            (0, $8xeDY.removePageListener)("prerenderingchange", $2c37c13e89983912$var$onVisibilityUpdate, true);
        }
    }
};
const $2c37c13e89983912$export$443f86b2c77012c4 = ()=>{
    if ((0, $gWPaa.WINDOW).document && $2c37c13e89983912$var$firstHiddenTime < 0) {
        const activationStart = (0, $bc726a4d4c88cc5c$export$d3e828b3c7b5b845)();
        const firstVisibilityStateHiddenTime = !(0, $gWPaa.WINDOW).document.prerendering ? globalThis.performance.getEntriesByType("visibility-state").filter((e)=>e.name === "hidden" && e.startTime > activationStart)[0]?.startTime : void 0;
        $2c37c13e89983912$var$firstHiddenTime = firstVisibilityStateHiddenTime ?? $2c37c13e89983912$var$initHiddenTime();
        (0, $8xeDY.addPageListener)("visibilitychange", $2c37c13e89983912$var$onVisibilityUpdate, true);
        (0, $8xeDY.addPageListener)("pagehide", $2c37c13e89983912$var$onVisibilityUpdate, true);
        (0, $8xeDY.addPageListener)("prerenderingchange", $2c37c13e89983912$var$onVisibilityUpdate, true);
    }
    return {
        get firstHiddenTime () {
            return $2c37c13e89983912$var$firstHiddenTime;
        },
        onHidden (cb) {
            $2c37c13e89983912$var$onHiddenFunctions.add(cb);
        }
    };
};
function $2c37c13e89983912$var$isPageHidden(event) {
    return event.type === "pagehide" || (0, $gWPaa.WINDOW).document?.visibilityState === "hidden";
}



var $gWPaa = parcelRequire("gWPaa");
const $d5570ea18b6c8c4c$export$407ea409d1f3b539 = ()=>{
    return `v5-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};




const $80975bcc3e2762c3$export$3c29b44508a0612b = (name, value = -1)=>{
    const navEntry = (0, $83c5af87602f1470$export$6431553786c94949)();
    let navigationType = "navigate";
    if (navEntry) {
        if ((0, $gWPaa.WINDOW).document?.prerendering || (0, $bc726a4d4c88cc5c$export$d3e828b3c7b5b845)() > 0) navigationType = "prerender";
        else if ((0, $gWPaa.WINDOW).document?.wasDiscarded) navigationType = "restore";
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, "-");
    }
    const entries = [];
    return {
        name: name,
        value: value,
        rating: "good",
        // If needed, will be updated when reported. `const` to keep the type from widening to `string`.
        delta: 0,
        entries: entries,
        id: (0, $d5570ea18b6c8c4c$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


const $eeb3a289c22e4636$var$instanceMap = /* @__PURE__ */ new WeakMap();
function $eeb3a289c22e4636$export$7c74c9b2462ddb3c(identityObj, ClassObj) {
    try {
        if (!$eeb3a289c22e4636$var$instanceMap.get(identityObj)) $eeb3a289c22e4636$var$instanceMap.set(identityObj, new ClassObj());
        return $eeb3a289c22e4636$var$instanceMap.get(identityObj);
    } catch (_e) {
        return new ClassObj();
    }
}


class $321c0060bdb4250b$export$4050f7f955e19aa0 {
    constructor(){
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionValue = 0;
        // oxlint-disable-next-line sdk/no-class-field-initializers
        this._sessionEntries = [];
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        if (entry.hadRecentInput) return;
        const firstSessionEntry = this._sessionEntries[0];
        const lastSessionEntry = this._sessionEntries[this._sessionEntries.length - 1];
        if (this._sessionValue && firstSessionEntry && lastSessionEntry && entry.startTime - lastSessionEntry.startTime < 1e3 && entry.startTime - firstSessionEntry.startTime < 5e3) {
            this._sessionValue += entry.value;
            this._sessionEntries.push(entry);
        } else {
            this._sessionValue = entry.value;
            this._sessionEntries = [
                entry
            ];
        }
        this._onAfterProcessingUnexpectedShift?.(entry);
    }
}


const $7afd934057bd9035$export$d1203567a167490e = (type, callback, opts = {})=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe({
                type: type,
                buffered: true,
                ...opts
            });
            return po;
        }
    } catch  {}
    return;
};



var $k4o6c = parcelRequire("k4o6c");






var $gWPaa = parcelRequire("gWPaa");
const $9806141c9429aa5b$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $gWPaa.WINDOW).document?.prerendering) addEventListener("prerenderingchange", ()=>callback(), true);
    else callback();
};


const $b719fb46f30c659a$export$e610c735b5510cec = [
    1800,
    3e3
];
const $b719fb46f30c659a$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $9806141c9429aa5b$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $2c37c13e89983912$export$443f86b2c77012c4)();
        const metric = (0, $80975bcc3e2762c3$export$3c29b44508a0612b)("FCP");
        let report;
        const handleEntries = (entries)=>{
            for (const entry of entries)if (entry.name === "first-contentful-paint") {
                po.disconnect();
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $bc726a4d4c88cc5c$export$d3e828b3c7b5b845)(), 0);
                    metric.entries.push(entry);
                    report(true);
                }
            }
        };
        const po = (0, $7afd934057bd9035$export$d1203567a167490e)("paint", handleEntries);
        if (po) report = (0, $fad92f97e697697e$export$17679dccdd551979)(onReport, metric, $b719fb46f30c659a$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


const $00ac6c84bfe1a6df$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
const $00ac6c84bfe1a6df$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    (0, $b719fb46f30c659a$export$fe3c86b74e15d5de)((0, $k4o6c.runOnce)(()=>{
        const metric = (0, $80975bcc3e2762c3$export$3c29b44508a0612b)("CLS", 0);
        let report;
        const visibilityWatcher = (0, $2c37c13e89983912$export$443f86b2c77012c4)();
        const layoutShiftManager = (0, $eeb3a289c22e4636$export$7c74c9b2462ddb3c)(opts, (0, $321c0060bdb4250b$export$4050f7f955e19aa0));
        const handleEntries = (entries)=>{
            for (const entry of entries)layoutShiftManager._processEntry(entry);
            if (layoutShiftManager._sessionValue > metric.value) {
                metric.value = layoutShiftManager._sessionValue;
                metric.entries = layoutShiftManager._sessionEntries;
                report();
            }
        };
        const po = (0, $7afd934057bd9035$export$d1203567a167490e)("layout-shift", handleEntries);
        if (po) {
            report = (0, $fad92f97e697697e$export$17679dccdd551979)(onReport, metric, $00ac6c84bfe1a6df$export$3f20d8e089ac35b2, opts.reportAllChanges);
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            (0, $gWPaa.WINDOW)?.setTimeout?.(report);
        }
    }));
};







let $011adf04433ec3dc$var$interactionCountEstimate = 0;
let $011adf04433ec3dc$var$minKnownInteractionId = Infinity;
let $011adf04433ec3dc$var$maxKnownInteractionId = 0;
const $011adf04433ec3dc$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $011adf04433ec3dc$var$minKnownInteractionId = Math.min($011adf04433ec3dc$var$minKnownInteractionId, e.interactionId);
            $011adf04433ec3dc$var$maxKnownInteractionId = Math.max($011adf04433ec3dc$var$maxKnownInteractionId, e.interactionId);
            $011adf04433ec3dc$var$interactionCountEstimate = $011adf04433ec3dc$var$maxKnownInteractionId ? ($011adf04433ec3dc$var$maxKnownInteractionId - $011adf04433ec3dc$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $011adf04433ec3dc$var$po;
const $011adf04433ec3dc$export$8a962f2683a476d1 = ()=>{
    return $011adf04433ec3dc$var$po ? $011adf04433ec3dc$var$interactionCountEstimate : performance.interactionCount || 0;
};
const $011adf04433ec3dc$export$67d90cda6b78a2eb = ()=>{
    if ("interactionCount" in performance || $011adf04433ec3dc$var$po) return;
    $011adf04433ec3dc$var$po = (0, $7afd934057bd9035$export$d1203567a167490e)("event", $011adf04433ec3dc$var$updateEstimate, {
        type: "event",
        buffered: true,
        durationThreshold: 0
    });
};


const $acada5aed09f327e$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
let $acada5aed09f327e$var$prevInteractionCount = 0;
const $acada5aed09f327e$var$getInteractionCountForNavigation = ()=>{
    return (0, $011adf04433ec3dc$export$8a962f2683a476d1)() - $acada5aed09f327e$var$prevInteractionCount;
};
class $acada5aed09f327e$export$aaa80641d584351c {
    constructor(){
        /**
     * A list of longest interactions on the page (by latency) sorted so the
     * longest one is first. The list is at most MAX_INTERACTIONS_TO_CONSIDER
     * long.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionList = [];
        /**
     * A mapping of longest interactions by their interaction ID.
     * This is used for faster lookup.
     */ // oxlint-disable-next-line sdk/no-class-field-initializers
        this._longestInteractionMap = /* @__PURE__ */ new Map();
    }
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _resetInteractions() {
        $acada5aed09f327e$var$prevInteractionCount = (0, $011adf04433ec3dc$export$8a962f2683a476d1)();
        this._longestInteractionList.length = 0;
        this._longestInteractionMap.clear();
    }
    /**
   * Returns the estimated p98 longest interaction based on the stored
   * interaction candidates and the interaction count for the current page.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _estimateP98LongestInteraction() {
        const candidateInteractionIndex = Math.min(this._longestInteractionList.length - 1, Math.floor($acada5aed09f327e$var$getInteractionCountForNavigation() / 50));
        return this._longestInteractionList[candidateInteractionIndex];
    }
    /**
   * Takes a performance entry and adds it to the list of worst interactions
   * if its duration is long enough to make it among the worst. If the
   * entry is part of an existing interaction, it is merged and the latency
   * and entries list is updated as needed.
   */ // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
        if (!(entry.interactionId || entry.entryType === "first-input")) return;
        const minLongestInteraction = this._longestInteractionList.at(-1);
        let interaction = this._longestInteractionMap.get(entry.interactionId);
        if (interaction || this._longestInteractionList.length < $acada5aed09f327e$var$MAX_INTERACTIONS_TO_CONSIDER || // If the above conditions are false, `minLongestInteraction` will be set.
        entry.duration > minLongestInteraction._latency) {
            if (interaction) {
                if (entry.duration > interaction._latency) {
                    interaction.entries = [
                        entry
                    ];
                    interaction._latency = entry.duration;
                } else if (entry.duration === interaction._latency && entry.startTime === interaction.entries[0].startTime) interaction.entries.push(entry);
            } else {
                interaction = {
                    id: entry.interactionId,
                    entries: [
                        entry
                    ],
                    _latency: entry.duration
                };
                this._longestInteractionMap.set(interaction.id, interaction);
                this._longestInteractionList.push(interaction);
            }
            this._longestInteractionList.sort((a, b)=>b._latency - a._latency);
            if (this._longestInteractionList.length > $acada5aed09f327e$var$MAX_INTERACTIONS_TO_CONSIDER) {
                const removedInteractions = this._longestInteractionList.splice($acada5aed09f327e$var$MAX_INTERACTIONS_TO_CONSIDER);
                for (const interaction2 of removedInteractions)this._longestInteractionMap.delete(interaction2.id);
            }
            this._onAfterProcessingINPCandidate?.(interaction);
        }
    }
}






var $wwz0G = parcelRequire("wwz0G");
const $ee7ce786df7215e6$export$7f4cb060ded9173c = [
    200,
    500
];
const $ee7ce786df7215e6$var$DEFAULT_DURATION_THRESHOLD = 40;
const $ee7ce786df7215e6$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    if (!(globalThis.PerformanceEventTiming && "interactionId" in PerformanceEventTiming.prototype)) return;
    const visibilityWatcher = (0, $2c37c13e89983912$export$443f86b2c77012c4)();
    (0, $9806141c9429aa5b$export$8bdb38a5671b594e)(()=>{
        (0, $011adf04433ec3dc$export$67d90cda6b78a2eb)();
        const metric = (0, $80975bcc3e2762c3$export$3c29b44508a0612b)("INP");
        let report;
        const interactionManager = (0, $eeb3a289c22e4636$export$7c74c9b2462ddb3c)(opts, (0, $acada5aed09f327e$export$aaa80641d584351c));
        const handleEntries = (entries)=>{
            (0, $wwz0G.whenIdleOrHidden)(()=>{
                for (const entry of entries)interactionManager._processEntry(entry);
                const inp = interactionManager._estimateP98LongestInteraction();
                if (inp && inp._latency !== metric.value) {
                    metric.value = inp._latency;
                    metric.entries = inp.entries;
                    report();
                }
            });
        };
        const po = (0, $7afd934057bd9035$export$d1203567a167490e)("event", handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold ?? $ee7ce786df7215e6$var$DEFAULT_DURATION_THRESHOLD
        });
        report = (0, $fad92f97e697697e$export$17679dccdd551979)(onReport, metric, $ee7ce786df7215e6$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            po.observe({
                type: "first-input",
                buffered: true
            });
            visibilityWatcher.onHidden(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
        }
    });
};






var $8xeDY = parcelRequire("8xeDY");


class $57226111635bdc52$export$6a641ef2a067ec62 {
    // eslint-disable-next-line @typescript-eslint/explicit-member-accessibility, jsdoc/require-jsdoc
    _processEntry(entry) {
        this._onBeforeProcessingEntry?.(entry);
    }
}




var $k4o6c = parcelRequire("k4o6c");


var $wwz0G = parcelRequire("wwz0G");
const $23acbeeeba660e36$export$948521ca5b0e1b17 = [
    2500,
    4e3
];
const $23acbeeeba660e36$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $9806141c9429aa5b$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $2c37c13e89983912$export$443f86b2c77012c4)();
        const metric = (0, $80975bcc3e2762c3$export$3c29b44508a0612b)("LCP");
        let report;
        const lcpEntryManager = (0, $eeb3a289c22e4636$export$7c74c9b2462ddb3c)(opts, (0, $57226111635bdc52$export$6a641ef2a067ec62));
        const handleEntries = (entries)=>{
            if (!opts.reportAllChanges) entries = entries.slice(-1);
            for (const entry of entries){
                lcpEntryManager._processEntry(entry);
                if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(entry.startTime - (0, $bc726a4d4c88cc5c$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        entry
                    ];
                    report();
                }
            }
        };
        const po = (0, $7afd934057bd9035$export$d1203567a167490e)("largest-contentful-paint", handleEntries);
        if (po) {
            report = (0, $fad92f97e697697e$export$17679dccdd551979)(onReport, metric, $23acbeeeba660e36$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $k4o6c.runOnce)(()=>{
                handleEntries(po.takeRecords());
                po.disconnect();
                report(true);
            });
            const stopListeningWrapper = (event)=>{
                if (event.isTrusted) {
                    (0, $wwz0G.whenIdleOrHidden)(stopListening);
                    (0, $8xeDY.removePageListener)(event.type, stopListeningWrapper, {
                        capture: true
                    });
                }
            };
            for (const type of [
                "keydown",
                "click",
                "visibilitychange"
            ])(0, $8xeDY.addPageListener)(type, stopListeningWrapper, {
                capture: true
            });
        }
    });
};




var $gWPaa = parcelRequire("gWPaa");





const $73412365d3eeee94$export$65c59ea8064668fc = [
    800,
    1800
];
const $73412365d3eeee94$var$whenReady = (callback)=>{
    if ((0, $gWPaa.WINDOW).document?.prerendering) (0, $9806141c9429aa5b$export$8bdb38a5671b594e)(()=>$73412365d3eeee94$var$whenReady(callback));
    else if ((0, $gWPaa.WINDOW).document?.readyState !== "complete") addEventListener("load", ()=>$73412365d3eeee94$var$whenReady(callback), true);
    else setTimeout(callback);
};
const $73412365d3eeee94$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $80975bcc3e2762c3$export$3c29b44508a0612b)("TTFB");
    const report = (0, $fad92f97e697697e$export$17679dccdd551979)(onReport, metric, $73412365d3eeee94$export$65c59ea8064668fc, opts.reportAllChanges);
    $73412365d3eeee94$var$whenReady(()=>{
        const navigationEntry = (0, $83c5af87602f1470$export$6431553786c94949)();
        if (navigationEntry) {
            metric.value = Math.max(navigationEntry.responseStart - (0, $bc726a4d4c88cc5c$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navigationEntry
            ];
            report(true);
        }
    });
};


const $e40b9efaa71f0411$var$handlers = {};
const $e40b9efaa71f0411$var$instrumented = {};
let $e40b9efaa71f0411$var$_previousCls;
let $e40b9efaa71f0411$var$_previousLcp;
let $e40b9efaa71f0411$var$_previousTtfb;
let $e40b9efaa71f0411$var$_previousInp;
function $e40b9efaa71f0411$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $e40b9efaa71f0411$var$addMetricObserver("cls", callback, $e40b9efaa71f0411$var$instrumentCls, $e40b9efaa71f0411$var$_previousCls, stopOnCallback);
}
function $e40b9efaa71f0411$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $e40b9efaa71f0411$var$addMetricObserver("lcp", callback, $e40b9efaa71f0411$var$instrumentLcp, $e40b9efaa71f0411$var$_previousLcp, stopOnCallback);
}
function $e40b9efaa71f0411$export$699d9529c099a797(callback) {
    return $e40b9efaa71f0411$var$addMetricObserver("ttfb", callback, $e40b9efaa71f0411$var$instrumentTtfb, $e40b9efaa71f0411$var$_previousTtfb);
}
function $e40b9efaa71f0411$export$da3b76aa2022cbd7(callback) {
    return $e40b9efaa71f0411$var$addMetricObserver("inp", callback, $e40b9efaa71f0411$var$instrumentInp, $e40b9efaa71f0411$var$_previousInp);
}
function $e40b9efaa71f0411$export$69816c1a049f8db6(type, callback) {
    $e40b9efaa71f0411$var$addHandler(type, callback);
    if (!$e40b9efaa71f0411$var$instrumented[type]) {
        $e40b9efaa71f0411$var$instrumentPerformanceObserver(type);
        $e40b9efaa71f0411$var$instrumented[type] = true;
    }
    return $e40b9efaa71f0411$var$getCleanupCallback(type, callback);
}
function $e40b9efaa71f0411$var$triggerHandlers(type, data) {
    const typeHandlers = $e40b9efaa71f0411$var$handlers[type];
    if (!typeHandlers?.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $9yfTK.DEBUG_BUILD) && (0, $w8bd7.debug).error(`Error while triggering instrumentation handler.
Type: ${type}
Name: ${(0, $iFp2j.getFunctionName)(handler)}
Error:`, e);
    }
}
function $e40b9efaa71f0411$var$instrumentCls() {
    return (0, $00ac6c84bfe1a6df$export$a7873055838e5ad8)((metric)=>{
        $e40b9efaa71f0411$var$triggerHandlers("cls", {
            metric: metric
        });
        $e40b9efaa71f0411$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $e40b9efaa71f0411$var$instrumentLcp() {
    return (0, $23acbeeeba660e36$export$947b1626ab8d5632)((metric)=>{
        $e40b9efaa71f0411$var$triggerHandlers("lcp", {
            metric: metric
        });
        $e40b9efaa71f0411$var$_previousLcp = metric;
    }, // We want the callback to be called whenever the LCP value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $e40b9efaa71f0411$var$instrumentTtfb() {
    return (0, $73412365d3eeee94$export$33a01e6c5f2c7e33)((metric)=>{
        $e40b9efaa71f0411$var$triggerHandlers("ttfb", {
            metric: metric
        });
        $e40b9efaa71f0411$var$_previousTtfb = metric;
    });
}
function $e40b9efaa71f0411$var$instrumentInp() {
    return (0, $ee7ce786df7215e6$export$7df4b36ecaed99e1)((metric)=>{
        $e40b9efaa71f0411$var$triggerHandlers("inp", {
            metric: metric
        });
        $e40b9efaa71f0411$var$_previousInp = metric;
    });
}
function $e40b9efaa71f0411$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $e40b9efaa71f0411$var$addHandler(type, callback);
    let stopListening;
    if (!$e40b9efaa71f0411$var$instrumented[type]) {
        stopListening = instrumentFn();
        $e40b9efaa71f0411$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $e40b9efaa71f0411$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : void 0);
}
function $e40b9efaa71f0411$var$instrumentPerformanceObserver(type) {
    const options = {};
    if (type === "event") options.durationThreshold = 0;
    (0, $7afd934057bd9035$export$d1203567a167490e)(type, (entries)=>{
        $e40b9efaa71f0411$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $e40b9efaa71f0411$var$addHandler(type, handler) {
    $e40b9efaa71f0411$var$handlers[type] = $e40b9efaa71f0411$var$handlers[type] || [];
    $e40b9efaa71f0411$var$handlers[type].push(handler);
}
function $e40b9efaa71f0411$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $e40b9efaa71f0411$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}
function $e40b9efaa71f0411$export$7affb50b622d8714(entry) {
    return "duration" in entry;
}




var $2vdTp = parcelRequire("2vdTp");


var $hv7EP = parcelRequire("hv7EP");



var $w8bd7 = parcelRequire("w8bd7");


var $9ISAs = parcelRequire("9ISAs");
function $261c8bf6b2834624$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $261c8bf6b2834624$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
function $261c8bf6b2834624$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $9ISAs.isThenable)(value)) return (0, $7d21460bd8c3b8b2$export$64da0f40b0f924ba)(value, (result)=>{
        onFinally();
        onSuccess(result);
    }, (err)=>{
        onError(err);
        onFinally();
    });
    onFinally();
    onSuccess(value);
    return value;
}



function $06f9ffb0ac5b9d0a$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === "boolean" && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $9f9f083568f3177b$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}



var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");

var $kWdMm = parcelRequire("kWdMm");
function $73b4d053d3a4847d$var$logIgnoredSpan(droppedSpan) {
    (0, $w8bd7.debug).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
function $73b4d053d3a4847d$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length) return false;
    for (const pattern of ignoreSpans){
        if ($73b4d053d3a4847d$var$isStringOrRegExp(pattern)) {
            if (span.description && (0, $kWdMm.isMatchingPattern)(span.description, pattern)) {
                (0, $hv7EP.DEBUG_BUILD) && $73b4d053d3a4847d$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        const hasAttributes = !!pattern.attributes && Object.keys(pattern.attributes).length > 0;
        if (!pattern.name && !pattern.op && !hasAttributes) continue;
        const nameMatches = pattern.name ? span.description && (0, $kWdMm.isMatchingPattern)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $kWdMm.isMatchingPattern)(span.op, pattern.op) : true;
        const attrsMatch = pattern.attributes ? Object.entries(pattern.attributes).every(([key, valuePattern])=>$73b4d053d3a4847d$var$_matchesAttributeValue(span.attributes?.[key], valuePattern)) : true;
        if (nameMatches && opMatches && attrsMatch) {
            (0, $hv7EP.DEBUG_BUILD) && $73b4d053d3a4847d$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
function $73b4d053d3a4847d$var$_matchesAttributeValue(actual, pat) {
    if (typeof actual === "string" && (typeof pat === "string" || pat instanceof RegExp)) return (0, $kWdMm.isMatchingPattern)(actual, pat);
    if (Array.isArray(actual) && Array.isArray(pat)) return actual.length === pat.length && actual.every((v, i)=>v === pat[i]);
    return actual === pat;
}
function $73b4d053d3a4847d$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $73b4d053d3a4847d$var$isStringOrRegExp(value) {
    return typeof value === "string" || value instanceof RegExp;
}


function $c1b1ae53e76d5da5$export$6ea47215d699c04a(client) {
    return client.getOptions().traceLifecycle === "stream";
}





var $4S04j = parcelRequire("4S04j");



const $9d62f32dd646eccc$export$849dbeeeda01ae98 = "production";
const $9d62f32dd646eccc$export$6829f580e78306fa = "development";








var $4zVoD = parcelRequire("4zVoD");


var $4zVoD = parcelRequire("4zVoD");


const $427ccfee27d19206$var$NON_RECORDING_SPAN_FIELD = /* @__PURE__ */ Symbol.for("sentry.nonRecordingSpan");
class $427ccfee27d19206$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $79bbaa211fcfeb5f$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $79bbaa211fcfeb5f$export$295213bc4d0c54ad)();
        this.dropReason = spanContext.dropReason;
        (0, $4zVoD.addNonEnumerableProperty)(this, $427ccfee27d19206$var$NON_RECORDING_SPAN_FIELD, true);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $d3a61c536a2d1d8c$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
}
function $427ccfee27d19206$export$61cc547d99783aa7(span) {
    return !!span && span[$427ccfee27d19206$var$NON_RECORDING_SPAN_FIELD] === true;
}



const $562d1947906178e8$var$FROZEN_DSC_FIELD = "_frozenDsc";
function $562d1947906178e8$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $4zVoD.addNonEnumerableProperty)(spanWithMaybeDsc, $562d1947906178e8$var$FROZEN_DSC_FIELD, dsc);
}
function $562d1947906178e8$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = {
        environment: options.environment || (0, $9d62f32dd646eccc$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $4038a06ed5b23254$export$b7ac9b8efa4bb595)(client)
    };
    client.emit("createDsc", dsc);
    return dsc;
}
function $562d1947906178e8$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $562d1947906178e8$export$366bad00d6815eed(propagationContext.traceId, client);
}
function $562d1947906178e8$export$a117f995597e25df(span) {
    const client = (0, $9f9f083568f3177b$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $d3a61c536a2d1d8c$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $d3a61c536a2d1d8c$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    const rootSpanSampleRate = traceState?.get("sentry.sample_rate") ?? rootSpanAttributes[0, $c30a0c8ed977cb48$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $c30a0c8ed977cb48$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc2) {
        if (typeof rootSpanSampleRate === "number" || typeof rootSpanSampleRate === "string") dsc2.sample_rate = `${rootSpanSampleRate}`;
        return dsc2;
    }
    const frozenDsc = rootSpan[$562d1947906178e8$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    const isNonRecordingRoot = (0, $427ccfee27d19206$export$61cc547d99783aa7)(rootSpan);
    const isIgnoredRoot = isNonRecordingRoot && rootSpan.dropReason === "ignored";
    if (isNonRecordingRoot && (!(0, $06f9ffb0ac5b9d0a$export$1f70765132c3c225)(client.getOptions()) || isIgnoredRoot)) {
        const capturedScope = (0, $6a7ac6221a05ac94$export$c08fbc656a245d03)(rootSpan).scope;
        if (capturedScope) {
            const dsc2 = {
                ...$562d1947906178e8$export$89ef1736f08c6b2b(client, capturedScope)
            };
            if (isIgnoredRoot) dsc2.sampled = "false";
            return applyLocalSampleRateToDsc(dsc2);
        }
    }
    const traceStateDsc = traceState?.get("sentry.dsc");
    const dscOnTraceState = traceStateDsc && (0, $595633d6b82db2c0$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    const dsc = $562d1947906178e8$export$366bad00d6815eed(span.spanContext().traceId, client);
    const source = rootSpanAttributes[0, $c30a0c8ed977cb48$export$d7a7d984b0791405] ?? rootSpanAttributes["sentry.segment.name.source"];
    const name = rootSpanJson.description;
    if (source !== "url" && name) dsc.transaction = name;
    if ((0, $06f9ffb0ac5b9d0a$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $d3a61c536a2d1d8c$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get("sentry.sample_rand") ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $6a7ac6221a05ac94$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit("createDsc", dsc, rootSpan);
    return dsc;
}
function $562d1947906178e8$export$95cf936fdacaff7b(span) {
    const dsc = $562d1947906178e8$export$a117f995597e25df(span);
    return (0, $595633d6b82db2c0$export$56766feef403f365)(dsc);
}



var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");

function $e20ae7490e3c1b73$export$2f3d84e767c9592b(span) {
    if (!(0, $hv7EP.DEBUG_BUILD)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >", parent_span_id: parentSpanId } = (0, $d3a61c536a2d1d8c$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $d3a61c536a2d1d8c$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $d3a61c536a2d1d8c$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? "sampled" : "unsampled"} ${isRootSpan ? "root " : ""}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op2, description: description2 } = (0, $d3a61c536a2d1d8c$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op2) infoParts.push(`root op: ${op2}`);
        if (description2) infoParts.push(`root description: ${description2}`);
    }
    (0, $w8bd7.debug).log(`${header}
  ${infoParts.join("\n  ")}`);
}
function $e20ae7490e3c1b73$export$b77c830667a4d630(span) {
    if (!(0, $hv7EP.DEBUG_BUILD)) return;
    const { description: description = "< unknown name >", op: op = "< unknown op >" } = (0, $d3a61c536a2d1d8c$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $d3a61c536a2d1d8c$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? "root " : ""}span "${description}" with ID ${spanId}`;
    (0, $w8bd7.debug).log(msg);
}



var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");


function $a8771da3c090f948$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    if (!(0, $06f9ffb0ac5b9d0a$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = void 0;
    let sampleRate;
    if (typeof options.tracesSampler === "function") {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                if (typeof samplingContext.parentSampleRate === "number") return samplingContext.parentSampleRate;
                if (typeof samplingContext.parentSampled === "boolean") return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== void 0) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== "undefined") {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    const parsedSampleRate = (0, $75813448dd2615ee$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === void 0) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    if (!parsedSampleRate) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === "function" ? "tracesSampler returned 0 or false" : "a negative sampling decision was inherited or tracesSampleRate is set to 0"}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    const shouldSample = sampleRand < parsedSampleRate;
    if (!shouldSample) (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}





var $hv7EP = parcelRequire("hv7EP");


var $4zVoD = parcelRequire("4zVoD");
function $1e1c355dc7cc6646$export$d3f49b33a1f44720(callback) {
    (0, $4zVoD.addNonEnumerableProperty)(callback, "_streamed", true);
    return callback;
}
function $1e1c355dc7cc6646$export$ca3e1ec3cdcc76ac(callback) {
    return !!callback && typeof callback === "function" && "_streamed" in callback && !!callback._streamed;
}




var $2vdTp = parcelRequire("2vdTp");


var $7viyI = parcelRequire("7viyI");

var $4S04j = parcelRequire("4S04j");

var $bZENS = parcelRequire("bZENS");
function $92b251ff2d014359$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
function $92b251ff2d014359$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
function $92b251ff2d014359$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
function $92b251ff2d014359$export$604a45d95a155e2b(envelope, types) {
    return $92b251ff2d014359$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
function $92b251ff2d014359$var$encodeUTF8(input) {
    const carrier = (0, $2vdTp.getSentryCarrier)((0, $bZENS.GLOBAL_OBJ));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
function $92b251ff2d014359$var$decodeUTF8(input) {
    const carrier = (0, $2vdTp.getSentryCarrier)((0, $bZENS.GLOBAL_OBJ));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
function $92b251ff2d014359$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $92b251ff2d014359$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === "string" ? $92b251ff2d014359$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`
${JSON.stringify(itemHeaders)}
`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                stringifiedPayload = JSON.stringify((0, $7viyI.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $92b251ff2d014359$var$concatBuffers(parts);
}
function $92b251ff2d014359$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
function $92b251ff2d014359$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === "string" ? $92b251ff2d014359$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(10);
        if (i < 0) i = buffer.length;
        return JSON.parse($92b251ff2d014359$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : void 0;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
function $92b251ff2d014359$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: "span"
    };
    return [
        spanHeaders,
        spanJson
    ];
}
function $92b251ff2d014359$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === "string" ? $92b251ff2d014359$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $92b251ff2d014359$var$DATA_CATEGORY_OVERRIDES = {
    sessions: "session",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile_chunk: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    raw_security: "security",
    log: "log_item",
    trace_metric: "metric"
};
function $92b251ff2d014359$var$_isOverriddenType(type) {
    return type in $92b251ff2d014359$var$DATA_CATEGORY_OVERRIDES;
}
function $92b251ff2d014359$export$b11169581eeaf237(type) {
    return $92b251ff2d014359$var$_isOverriddenType(type) ? $92b251ff2d014359$var$DATA_CATEGORY_OVERRIDES[type] : type;
}
function $92b251ff2d014359$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
function $92b251ff2d014359$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date((0, $4S04j.safeDateNow)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $4038a06ed5b23254$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}



var $4S04j = parcelRequire("4S04j");


function $27b8b052dd77f94f$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : void 0
    };
    return event;
}
function $27b8b052dd77f94f$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $92b251ff2d014359$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date((0, $4S04j.safeDateNow)()).toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $4038a06ed5b23254$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $92b251ff2d014359$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
function $27b8b052dd77f94f$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $92b251ff2d014359$export$d369f3b2758f6743)(metadata);
    const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $27b8b052dd77f94f$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $92b251ff2d014359$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $92b251ff2d014359$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
function $27b8b052dd77f94f$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc2) {
        return !!dsc2.trace_id && !!dsc2.public_key;
    }
    const dsc = (0, $562d1947906178e8$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date((0, $4S04j.safeDateNow)()).toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $4038a06ed5b23254$export$44d472fbb931a776)(dsn)
        }
    };
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>{
        const json = (0, $d3a61c536a2d1d8c$export$92d8c23565496537)(span);
        return !(0, $73b4d053d3a4847d$export$5d569ac97c389400)({
            description: json.description,
            op: json.op,
            attributes: json.data
        }, ignoreSpans);
    }) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent("before_send", "span", droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $d3a61c536a2d1d8c$export$92d8c23565496537)(span);
        const processedSpan = !(0, $1e1c355dc7cc6646$export$ca3e1ec3cdcc76ac)(beforeSendSpan) ? beforeSendSpan(spanJson) : spanJson;
        if (!processedSpan) {
            (0, $d3a61c536a2d1d8c$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $d3a61c536a2d1d8c$export$92d8c23565496537);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $92b251ff2d014359$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $92b251ff2d014359$export$f93f7f385160c44e)(headers, items);
}




var $w8bd7 = parcelRequire("w8bd7");



var $7Y1KN = parcelRequire("7Y1KN");




var $2vdTp = parcelRequire("2vdTp");
function $c403356dfd434802$export$39f842ff1b89e918(strategy) {
    (0, $2vdTp.getSentryCarrier)((0, $2vdTp.getMainCarrier)()).segmentSpanCaptureStrategy = strategy;
}
function $c403356dfd434802$export$ccd123f3ffd8eb3() {
    return (0, $2vdTp.getSentryCarrier)((0, $2vdTp.getMainCarrier)()).segmentSpanCaptureStrategy;
}




const $0d91138d8cb41446$var$MAX_SPAN_COUNT = 1e3;
class $0d91138d8cb41446$export$a92149b045260d9f {
    /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $79bbaa211fcfeb5f$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $79bbaa211fcfeb5f$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $7Y1KN.timestampInSeconds)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $c30a0c8ed977cb48$export$cca8dd30f57f805e)]: "manual",
            [(0, $c30a0c8ed977cb48$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        if ("sampled" in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._frozen) return this;
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._frozen) return this;
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {}
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $d3a61c536a2d1d8c$export$eb571cd9b5d98de8) : (0, $d3a61c536a2d1d8c$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (this._frozen) return this;
        if (value === void 0) delete this._attributes[key];
        else this._attributes[key] = value;
        if (key === (0, $c30a0c8ed977cb48$export$d7a7d984b0791405) && value !== void 0 && (0, $6a7ac6221a05ac94$export$2e69b79005fc86eb)(this)) (0, $6a7ac6221a05ac94$export$c45f16c039fb5033)(this);
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        if (this._frozen) return;
        this._startTime = (0, $d3a61c536a2d1d8c$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        if (this._frozen) return this;
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        if (this._frozen) return this;
        this._name = name;
        if (!(0, $6a7ac6221a05ac94$export$2e69b79005fc86eb)(this)) this.setAttribute((0, $c30a0c8ed977cb48$export$d7a7d984b0791405), "custom");
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        if (this._endTime) {
            this._frozen = (0, $6a7ac6221a05ac94$export$a9ba2a501dbf6a56)(this);
            return;
        }
        this._endTime = (0, $d3a61c536a2d1d8c$export$3f7581298f56c6d7)(endTimestamp);
        (0, $e20ae7490e3c1b73$export$b77c830667a4d630)(this);
        this._onSpanEnded();
        this._frozen = (0, $6a7ac6221a05ac94$export$a9ba2a501dbf6a56)(this);
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $c30a0c8ed977cb48$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $d3a61c536a2d1d8c$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $c30a0c8ed977cb48$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $c30a0c8ed977cb48$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $c30a0c8ed977cb48$export$fea48ba9f4550879],
            measurements: (0, $2174c183125e1337$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $d3a61c536a2d1d8c$export$c4c6a79b1260ca1b)(this) === this || void 0,
            segment_id: this._isStandaloneSpan ? (0, $d3a61c536a2d1d8c$export$c4c6a79b1260ca1b)(this).spanContext().spanId : void 0,
            links: (0, $d3a61c536a2d1d8c$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /**
   * Get {@link StreamedSpanJSON} representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToStreamedSpanJSON(span)` instead.
   */ getStreamedSpanJSON() {
        return {
            name: this._name ?? "",
            span_id: this._spanId,
            trace_id: this._traceId,
            parent_span_id: this._parentSpanId,
            start_timestamp: this._startTime,
            // just in case _endTime is not set, we use the start time (i.e. duration 0)
            end_timestamp: this._endTime ?? this._startTime,
            is_segment: this._isStandaloneSpan || this === (0, $d3a61c536a2d1d8c$export$c4c6a79b1260ca1b)(this),
            status: (0, $d3a61c536a2d1d8c$export$d3856a3187d34821)(this._status),
            attributes: (0, $d3a61c536a2d1d8c$export$1464a9cb828ba99f)(this._attributes, this._status),
            links: (0, $d3a61c536a2d1d8c$export$9015adcf158ef3a5)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        if (this._frozen) return this;
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log("[Tracing] Adding an event to span:", name);
        const time = $0d91138d8cb41446$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $7Y1KN.timestampInSeconds)();
        const attributes = $0d91138d8cb41446$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $d3a61c536a2d1d8c$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $9f9f083568f3177b$export$6bb76d6eba7e258c)();
        if (client) {
            client.emit("spanEnd", this);
            if (!this._isStandaloneSpan) client.emit("afterSpanEnd", this);
        }
        const rootSpan = (0, $d3a61c536a2d1d8c$export$c4c6a79b1260ca1b)(this);
        const isSegmentSpan = this._isStandaloneSpan || this === rootSpan;
        if (this._isStandaloneSpan) {
            if (this._sampled) $0d91138d8cb41446$var$sendSpanEnvelope((0, $27b8b052dd77f94f$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log("[Tracing] Discarding standalone span because its trace was not chosen to be sampled.");
                if (client) client.recordDroppedEvent("sample_rate", "span");
            }
            return;
        }
        if (!isSegmentSpan) {
            const strategy2 = (0, $c403356dfd434802$export$ccd123f3ffd8eb3)();
            if (strategy2) {
                const scope2 = (0, $6a7ac6221a05ac94$export$c08fbc656a245d03)(this).scope || (0, $9f9f083568f3177b$export$c7be4b0125a10cba)();
                strategy2.onChildSpanEnded(this, rootSpan, (options)=>this._convertSpanToTransaction(options), scope2);
            }
            return;
        }
        if (client && (0, $c1b1ae53e76d5da5$export$6ea47215d699c04a)(client)) {
            client.emit("afterSegmentSpanEnd", this);
            return;
        }
        const scope = (0, $6a7ac6221a05ac94$export$c08fbc656a245d03)(this).scope || (0, $9f9f083568f3177b$export$c7be4b0125a10cba)();
        const strategy = (0, $c403356dfd434802$export$ccd123f3ffd8eb3)();
        if (strategy) strategy.onSegmentSpanEnded((options)=>this._convertSpanToTransaction(options), scope);
        else {
            const transactionEvent = this._convertSpanToTransaction();
            if (transactionEvent) scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction(options = {}) {
        if (!$0d91138d8cb41446$var$isFullFinishedSpan((0, $d3a61c536a2d1d8c$export$92d8c23565496537)(this))) return void 0;
        if (!this._name) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn("Transaction has no name, falling back to `<unlabeled transaction>`.");
            this._name = "<unlabeled transaction>";
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $6a7ac6221a05ac94$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return void 0;
        options.onSpanCaptured?.(this);
        const spans = [];
        for (const descendant of (0, $d3a61c536a2d1d8c$export$340c5c8a13ffc680)(this)){
            if (descendant === this || $0d91138d8cb41446$var$isStandaloneSpan(descendant) || options.isSpanAlreadyCaptured?.(descendant)) continue;
            const spanJSON = (0, $d3a61c536a2d1d8c$export$92d8c23565496537)(descendant);
            if (!$0d91138d8cb41446$var$isFullFinishedSpan(spanJSON)) continue;
            options.onSpanCaptured?.(descendant);
            spans.push(spanJSON);
        }
        const source = this._attributes[0, $c30a0c8ed977cb48$export$d7a7d984b0791405];
        delete this._attributes[0, $c30a0c8ed977cb48$export$165ce9a229f6f050];
        let hasGenAiSpans = false;
        spans.forEach((span)=>{
            delete span.data[0, $c30a0c8ed977cb48$export$165ce9a229f6f050];
            if (span.op?.startsWith("gen_ai.")) hasGenAiSpans = true;
        });
        const transaction = {
            contexts: {
                trace: (0, $d3a61c536a2d1d8c$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $0d91138d8cb41446$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $0d91138d8cb41446$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: "transaction",
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $562d1947906178e8$export$a117f995597e25df)(this),
                hasGenAiSpans: hasGenAiSpans
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $2174c183125e1337$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log("[Measurements] Adding measurements to transaction event", JSON.stringify(measurements, void 0, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $0d91138d8cb41446$var$isSpanTimeInput(value) {
    return value && typeof value === "number" || value instanceof Date || Array.isArray(value);
}
function $0d91138d8cb41446$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
function $0d91138d8cb41446$var$isStandaloneSpan(span) {
    return span instanceof $0d91138d8cb41446$export$a92149b045260d9f && span.isStandaloneSpan();
}
function $0d91138d8cb41446$var$sendSpanEnvelope(envelope) {
    const client = (0, $9f9f083568f3177b$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent("before_send", "span");
        return;
    }
    client.sendEnvelope(envelope);
}




const $07238d64f16b4415$export$61ab4e30f2201736 = "__SENTRY_SUPPRESS_TRACING__";
function $07238d64f16b4415$export$a1bd95187356f372(options, callback) {
    const acs = $07238d64f16b4415$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $07238d64f16b4415$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $9f9f083568f3177b$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $07238d64f16b4415$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $9f9f083568f3177b$export$c7be4b0125a10cba)();
            const parentSpan = $07238d64f16b4415$var$getParentSpan(scope, customParentSpan);
            const client = (0, $9f9f083568f3177b$export$6bb76d6eba7e258c)();
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $07238d64f16b4415$var$startMissingRequiredParentSpan(scope, client) : $07238d64f16b4415$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$07238d64f16b4415$export$b0b1bd7d4bdbd54e(activeSpan) || !parentSpan) (0, $376e868a0a8b0a7f$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $261c8bf6b2834624$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                const { status: status } = (0, $d3a61c536a2d1d8c$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $93490f49a9d2f84d$export$f966a0446ece71e),
                    message: "internal_error"
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
function $07238d64f16b4415$export$c10292ad04b92aea(options, callback) {
    const acs = $07238d64f16b4415$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $07238d64f16b4415$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $9f9f083568f3177b$export$ec58d9285c204497)(customForkedScope, ()=>{
        const wrapper = $07238d64f16b4415$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $9f9f083568f3177b$export$c7be4b0125a10cba)();
            const parentSpan = $07238d64f16b4415$var$getParentSpan(scope, customParentSpan);
            const missingRequiredParent = options.onlyIfParent && !parentSpan;
            const activeSpan = missingRequiredParent ? $07238d64f16b4415$var$startMissingRequiredParentSpan(scope, (0, $9f9f083568f3177b$export$6bb76d6eba7e258c)()) : $07238d64f16b4415$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            if (!$07238d64f16b4415$export$b0b1bd7d4bdbd54e(activeSpan) || !parentSpan) (0, $376e868a0a8b0a7f$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $261c8bf6b2834624$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                const { status: status } = (0, $d3a61c536a2d1d8c$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === "ok")) activeSpan.setStatus({
                    code: (0, $93490f49a9d2f84d$export$f966a0446ece71e),
                    message: "internal_error"
                });
            });
        });
    });
}
function $07238d64f16b4415$export$63dbba021a6b4047(options) {
    const acs = $07238d64f16b4415$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    return $07238d64f16b4415$var$_startInactiveSpanImpl(options);
}
function $07238d64f16b4415$export$8672cc6c19af377a(options) {
    return $07238d64f16b4415$var$_startInactiveSpanImpl(options);
}
function $07238d64f16b4415$var$_startInactiveSpanImpl(options) {
    const spanArguments = $07238d64f16b4415$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    const wrapper = options.scope ? (callback)=>(0, $9f9f083568f3177b$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== void 0 ? (callback)=>$07238d64f16b4415$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $9f9f083568f3177b$export$c7be4b0125a10cba)();
        const parentSpan = $07238d64f16b4415$var$getParentSpan(scope, customParentSpan);
        const client = (0, $9f9f083568f3177b$export$6bb76d6eba7e258c)();
        const missingRequiredParent = options.onlyIfParent && !parentSpan;
        if (missingRequiredParent) return $07238d64f16b4415$var$startMissingRequiredParentSpan(scope, client);
        return $07238d64f16b4415$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
const $07238d64f16b4415$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $2vdTp.getMainCarrier)();
    const acs = (0, $a0d67ab23fb41d37$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $9f9f083568f3177b$export$6bb76d6eba7e258c)();
    const incomingDsc = (0, $595633d6b82db2c0$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $e00f06df584cff55$export$18811bc99eefceaa)(client, incomingDsc?.org_id)) return $07238d64f16b4415$export$f90b03291402f553(callback);
    return (0, $9f9f083568f3177b$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $e00f06df584cff55$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $376e868a0a8b0a7f$export$3f25fa50c18e20ca)(scope, void 0);
        return callback();
    });
};
function $07238d64f16b4415$export$e57ac09b143d92a2(span, callback) {
    const acs = $07238d64f16b4415$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $9f9f083568f3177b$export$ec58d9285c204497)((scope)=>{
        (0, $376e868a0a8b0a7f$export$3f25fa50c18e20ca)(scope, span || void 0);
        return callback(scope);
    });
}
function $07238d64f16b4415$export$869298f9835abc68(callback) {
    const acs = $07238d64f16b4415$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $9f9f083568f3177b$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$07238d64f16b4415$export$61ab4e30f2201736]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$07238d64f16b4415$export$61ab4e30f2201736]: void 0
        });
        return res;
    });
}
function $07238d64f16b4415$export$7d5f2376f7cf513(scope = (0, $9f9f083568f3177b$export$c7be4b0125a10cba)()) {
    const acs = $07238d64f16b4415$var$getAcs();
    if (acs.isTracingSuppressed) return acs.isTracingSuppressed(scope);
    return scope.getScopeData().sdkProcessingMetadata[$07238d64f16b4415$export$61ab4e30f2201736] === true;
}
function $07238d64f16b4415$export$f90b03291402f553(callback) {
    const acs = $07238d64f16b4415$var$getAcs();
    if (acs.startNewTrace) return acs.startNewTrace(callback);
    return (0, $9f9f083568f3177b$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $79bbaa211fcfeb5f$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $4S04j.safeMathRandom)()
        });
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $07238d64f16b4415$export$e57ac09b143d92a2(null, callback);
    });
}
function $07238d64f16b4415$var$startMissingRequiredParentSpan(scope, client) {
    client?.recordDroppedEvent("no_parent_span", "span");
    const span = new (0, $427ccfee27d19206$export$d6636b700b76c516)({
        traceId: scope.getPropagationContext().traceId
    });
    (0, $6a7ac6221a05ac94$export$cddb4027e3b0dd66)(span, scope, (0, $9f9f083568f3177b$export$68f3af03034c9e90)());
    return span;
}
function $07238d64f16b4415$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    const isolationScope = (0, $9f9f083568f3177b$export$68f3af03034c9e90)();
    if (!(0, $06f9ffb0ac5b9d0a$export$1f70765132c3c225)()) {
        const scopePropagationContext = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        const traceId = parentSpan ? parentSpan.spanContext().traceId : scopePropagationContext.traceId;
        const span2 = new (0, $427ccfee27d19206$export$d6636b700b76c516)({
            traceId: traceId
        });
        if (parentSpan && !forceTransaction) (0, $d3a61c536a2d1d8c$export$81397d924722cc65)(parentSpan, span2);
        (0, $6a7ac6221a05ac94$export$cddb4027e3b0dd66)(span2, scope, isolationScope);
        return span2;
    }
    const client = (0, $9f9f083568f3177b$export$6bb76d6eba7e258c)();
    if ($07238d64f16b4415$var$_shouldIgnoreStreamedSpan(client, spanArguments)) {
        if (!$07238d64f16b4415$export$7d5f2376f7cf513(scope)) client?.recordDroppedEvent("ignored", "span");
        const ignoredSpan = new (0, $427ccfee27d19206$export$d6636b700b76c516)({
            dropReason: "ignored",
            traceId: parentSpan?.spanContext().traceId ?? scope.getPropagationContext().traceId
        });
        if (parentSpan && !forceTransaction) (0, $d3a61c536a2d1d8c$export$81397d924722cc65)(parentSpan, ignoredSpan);
        (0, $6a7ac6221a05ac94$export$cddb4027e3b0dd66)(ignoredSpan, scope, isolationScope);
        return ignoredSpan;
    }
    let span;
    if (parentSpan && !forceTransaction) {
        span = $07238d64f16b4415$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope);
        (0, $d3a61c536a2d1d8c$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        const dsc = (0, $562d1947906178e8$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $d3a61c536a2d1d8c$export$5caecac1caaf3a71)(parentSpan);
        span = $07238d64f16b4415$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        (0, $562d1947906178e8$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $07238d64f16b4415$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, isolationScope, parentSampled);
        if (dsc) (0, $562d1947906178e8$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $e20ae7490e3c1b73$export$2f3d84e767c9592b)(span);
    return span;
}
function $07238d64f16b4415$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $d3a61c536a2d1d8c$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $07238d64f16b4415$var$getAcs() {
    const carrier = (0, $2vdTp.getMainCarrier)();
    return (0, $a0d67ab23fb41d37$export$f639b0c2752203be)(carrier);
}
function $07238d64f16b4415$var$_startRootSpan(spanArguments, scope, isolationScope, parentSampled) {
    const client = (0, $9f9f083568f3177b$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = "" } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    client?.emit("beforeSampling", mutableSpanSamplingData, {
        decision: false
    });
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const _isTracingSuppressed = $07238d64f16b4415$export$7d5f2376f7cf513(scope);
    const [sampled, sampleRate, localSampleRateWasApplied] = _isTracingSuppressed ? [
        false
    ] : (0, $a8771da3c090f948$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        normalizedRequest: isolationScope.getScopeData().sdkProcessingMetadata.normalizedRequest,
        parentSampleRate: (0, $75813448dd2615ee$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $0d91138d8cb41446$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $c30a0c8ed977cb48$export$d7a7d984b0791405)]: "custom",
            [(0, $c30a0c8ed977cb48$export$ccfe0a40627cc34b)]: sampleRate !== void 0 && localSampleRateWasApplied ? sampleRate : void 0,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client && !_isTracingSuppressed) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log("[Tracing] Discarding root span because its trace was not chosen to be sampled.");
        client.recordDroppedEvent("sample_rate", (0, $c1b1ae53e76d5da5$export$6ea47215d699c04a)(client) ? "span" : "transaction");
    }
    (0, $6a7ac6221a05ac94$export$cddb4027e3b0dd66)(rootSpan, scope, isolationScope);
    if (client) client.emit("spanStart", rootSpan);
    return rootSpan;
}
function $07238d64f16b4415$var$_startChildSpan(parentSpan, scope, spanArguments, isolationScope) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const _isTracingSuppressed = $07238d64f16b4415$export$7d5f2376f7cf513(scope);
    const sampled = _isTracingSuppressed ? false : (0, $d3a61c536a2d1d8c$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $0d91138d8cb41446$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $427ccfee27d19206$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $d3a61c536a2d1d8c$export$81397d924722cc65)(parentSpan, childSpan);
    (0, $6a7ac6221a05ac94$export$cddb4027e3b0dd66)(childSpan, scope, isolationScope);
    const client = (0, $9f9f083568f3177b$export$6bb76d6eba7e258c)();
    if (!client) return childSpan;
    if ((0, $c1b1ae53e76d5da5$export$6ea47215d699c04a)(client) && (0, $427ccfee27d19206$export$61cc547d99783aa7)(childSpan)) {
        if ((0, $427ccfee27d19206$export$61cc547d99783aa7)(parentSpan) && parentSpan.dropReason) {
            childSpan.dropReason = parentSpan.dropReason;
            client.recordDroppedEvent(parentSpan.dropReason, "span");
        } else if (!_isTracingSuppressed) {
            childSpan.dropReason = "sample_rate";
            client.recordDroppedEvent("sample_rate", "span");
        }
    }
    client.emit("spanStart", childSpan);
    if (spanArguments.endTimestamp) {
        client.emit("spanEnd", childSpan);
        client.emit("afterSpanEnd", childSpan);
    }
    return childSpan;
}
function $07238d64f16b4415$var$getParentSpan(scope, customParentSpan) {
    if (customParentSpan) return customParentSpan;
    if (customParentSpan === null) return void 0;
    const span = (0, $376e868a0a8b0a7f$export$91f063ebb8eff307)(scope);
    if (!span) return void 0;
    const client = (0, $9f9f083568f3177b$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $d3a61c536a2d1d8c$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $07238d64f16b4415$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== void 0 ? (callback)=>{
        return $07238d64f16b4415$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}
function $07238d64f16b4415$var$_shouldIgnoreStreamedSpan(client, spanArguments) {
    const ignoreSpans = client?.getOptions().ignoreSpans;
    if (!client || !(0, $c1b1ae53e76d5da5$export$6ea47215d699c04a)(client) || !ignoreSpans?.length) return false;
    return (0, $73b4d053d3a4847d$export$5d569ac97c389400)({
        description: spanArguments.name || "",
        op: spanArguments.attributes?.[0, $c30a0c8ed977cb48$export$1a413bd9a88fdb09] || spanArguments.op,
        attributes: spanArguments.attributes
    }, ignoreSpans);
}
function $07238d64f16b4415$export$b0b1bd7d4bdbd54e(span) {
    return (0, $427ccfee27d19206$export$61cc547d99783aa7)(span) && span.dropReason === "ignored";
}



var $gWPaa = parcelRequire("gWPaa");

var $gWPaa = parcelRequire("gWPaa");

var $8xeDY = parcelRequire("8xeDY");
const $652a900710a0cc41$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === "pagehide" || (0, $gWPaa.WINDOW).document?.visibilityState === "hidden") cb(event);
    };
    (0, $8xeDY.addPageListener)("visibilitychange", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
    (0, $8xeDY.addPageListener)("pagehide", onHiddenOrPageHide, {
        capture: true,
        once: true
    });
};


function $0bd0f3212099db27$export$27169ccae1b439e3(value) {
    return typeof value === "number" && isFinite(value);
}
function $0bd0f3212099db27$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $d3a61c536a2d1d8c$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) {
        if (typeof parentSpan.updateStartTime === "function") parentSpan.updateStartTime(startTimeInSeconds);
    }
    return (0, $07238d64f16b4415$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $07238d64f16b4415$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
function $0bd0f3212099db27$export$b71b9c7b60c5a4aa(options) {
    const client = (0, $9f9f083568f3177b$export$6bb76d6eba7e258c)();
    if (!client) return;
    const { name: name, transaction: transaction, attributes: passedAttributes, startTime: startTime } = options;
    const { release: release, environment: environment } = client.getOptions();
    const { userInfo: userInfo } = client.getDataCollectionOptions();
    const replay = client.getIntegrationByName("Replay");
    const replayId = replay?.getReplayId();
    const scope = (0, $9f9f083568f3177b$export$c7be4b0125a10cba)();
    const user = scope.getUser();
    const userDisplay = user !== void 0 ? user.email || user.id || user.ip_address : void 0;
    let profileId;
    try {
        profileId = scope.getScopeData().contexts.profile.profile_id;
    } catch  {}
    const attributes = {
        release: release,
        environment: environment,
        user: userDisplay || void 0,
        profile_id: profileId || void 0,
        replay_id: replayId || void 0,
        transaction: transaction,
        // Web vital score calculation relies on the user agent to account for different
        // browsers setting different thresholds for what is considered a good/meh/bad value.
        // For example: Chrome vs. Chrome Mobile
        "user_agent.original": (0, $gWPaa.WINDOW).navigator?.userAgent,
        // This tells Sentry to infer the IP address from the request
        "client.address": userInfo ? "{{auto}}" : void 0,
        ...passedAttributes
    };
    return (0, $07238d64f16b4415$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        experimental: {
            standalone: true
        }
    });
}
function $0bd0f3212099db27$export$f72a13c439a30cab() {
    return (0, $gWPaa.WINDOW).addEventListener && (0, $gWPaa.WINDOW).performance;
}
function $0bd0f3212099db27$export$b4785dbd4a81b33f(time) {
    return time / 1e3;
}
function $0bd0f3212099db27$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = "unknown";
    let version = "unknown";
    let _name = "";
    for (const char of nextHopProtocol){
        if (char === "/") {
            [name, version] = nextHopProtocol.split("/");
            break;
        }
        if (!isNaN(Number(char))) {
            name = _name === "h" ? "http" : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) name = _name;
    return {
        name: name,
        version: version
    };
}
function $0bd0f3212099db27$export$c7533a7b4a9f2e94(entryType) {
    try {
        return PerformanceObserver.supportedEntryTypes.includes(entryType);
    } catch  {
        return false;
    }
}
function $0bd0f3212099db27$export$382ad360b45665ab(client, collectorCallback) {
    let pageloadSpan;
    let collected = false;
    function _runCollectorCallbackOnce(event) {
        if (!collected && pageloadSpan) collectorCallback(event, pageloadSpan.spanContext().spanId, pageloadSpan);
        collected = true;
    }
    (0, $652a900710a0cc41$export$91ec2be6fdd8f1b4)(()=>{
        _runCollectorCallbackOnce("pagehide");
    });
    const unsubscribeStartNavigation = client.on("beforeStartNavigationSpan", (_, options)=>{
        if (!options?.isRedirect) {
            _runCollectorCallbackOnce("navigation");
            unsubscribeStartNavigation();
            unsubscribeAfterStartPageLoadSpan();
        }
    });
    const unsubscribeAfterStartPageLoadSpan = client.on("afterStartPageLoadSpan", (span)=>{
        pageloadSpan = span;
        unsubscribeAfterStartPageLoadSpan();
    });
}


function $b63715e52ba23274$export$585bab03c6c18c45(client) {
    let standaloneCLsValue = 0;
    let standaloneClsEntry;
    if (!(0, $0bd0f3212099db27$export$c7533a7b4a9f2e94)("layout-shift")) return;
    const cleanupClsHandler = (0, $e40b9efaa71f0411$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        standaloneCLsValue = metric.value;
        standaloneClsEntry = entry;
    }, true);
    (0, $0bd0f3212099db27$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $b63715e52ba23274$export$910bd4e865129f07(standaloneCLsValue, standaloneClsEntry, pageloadSpanId, reportEvent);
        cleanupClsHandler();
    });
}
function $b63715e52ba23274$export$910bd4e865129f07(clsValue, entry, pageloadSpanId, reportEvent) {
    (0, $9yfTK.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(((0, $7Y1KN.browserPerformanceTimeOrigin)() || 0) + entry.startTime) : (0, $7Y1KN.timestampInSeconds)();
    const routeName = (0, $9f9f083568f3177b$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $1rNqq.htmlTreeAsString)(entry.sources[0]?.node) : "Layout shift";
    const attributes = {
        [(0, $c30a0c8ed977cb48$export$cca8dd30f57f805e)]: "auto.http.browser.cls",
        [(0, $c30a0c8ed977cb48$export$1a413bd9a88fdb09)]: "ui.webvital.cls",
        [(0, $c30a0c8ed977cb48$export$fea48ba9f4550879)]: 0,
        // attach the pageload span id to the CLS span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId,
        // describes what triggered the web vital to be reported
        "sentry.report_event": reportEvent
    };
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`cls.source.${index + 1}`] = (0, $1rNqq.htmlTreeAsString)(source.node);
    });
    const span = (0, $0bd0f3212099db27$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("cls", {
            [(0, $c30a0c8ed977cb48$export$f5f95cff026507b5)]: "",
            [(0, $c30a0c8ed977cb48$export$69cd5c610c7bb96a)]: clsValue
        });
        span.end(startTime);
    }
}




var $7Y1KN = parcelRequire("7Y1KN");
var $w8bd7 = parcelRequire("w8bd7");

var $9yfTK = parcelRequire("9yfTK");

var $1rNqq = parcelRequire("1rNqq");


const $c6e850f332a60fd8$export$ccce4d286bdc973b = 6e4;
function $c6e850f332a60fd8$export$e59775b7d17699ba(lcpValue) {
    return lcpValue != null && lcpValue > 0 && lcpValue <= $c6e850f332a60fd8$export$ccce4d286bdc973b;
}
function $c6e850f332a60fd8$export$485112b2cb5f79dc(client) {
    let standaloneLcpValue = 0;
    let standaloneLcpEntry;
    if (!(0, $0bd0f3212099db27$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    const cleanupLcpHandler = (0, $e40b9efaa71f0411$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !$c6e850f332a60fd8$export$e59775b7d17699ba(metric.value)) return;
        standaloneLcpValue = metric.value;
        standaloneLcpEntry = entry;
    }, true);
    (0, $0bd0f3212099db27$export$382ad360b45665ab)(client, (reportEvent, pageloadSpanId)=>{
        $c6e850f332a60fd8$export$1c28dab7ad4ec937(standaloneLcpValue, standaloneLcpEntry, pageloadSpanId, reportEvent);
        cleanupLcpHandler();
    });
}
function $c6e850f332a60fd8$export$1c28dab7ad4ec937(lcpValue, entry, pageloadSpanId, reportEvent) {
    if (!$c6e850f332a60fd8$export$e59775b7d17699ba(lcpValue)) return;
    (0, $9yfTK.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Sending LCP span (${lcpValue})`);
    const startTime = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(((0, $7Y1KN.browserPerformanceTimeOrigin)() || 0) + (entry?.startTime || 0));
    const routeName = (0, $9f9f083568f3177b$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = entry ? (0, $1rNqq.htmlTreeAsString)(entry.element) : "Largest contentful paint";
    const attributes = {
        [(0, $c30a0c8ed977cb48$export$cca8dd30f57f805e)]: "auto.http.browser.lcp",
        [(0, $c30a0c8ed977cb48$export$1a413bd9a88fdb09)]: "ui.webvital.lcp",
        [(0, $c30a0c8ed977cb48$export$fea48ba9f4550879)]: 0,
        // LCP is a point-in-time metric
        // attach the pageload span id to the LCP span so that we can link them in the UI
        "sentry.pageload.span_id": pageloadSpanId,
        // describes what triggered the web vital to be reported
        "sentry.report_event": reportEvent
    };
    if (entry) {
        entry.element && (attributes["lcp.element"] = (0, $1rNqq.htmlTreeAsString)(entry.element));
        entry.id && (attributes["lcp.id"] = entry.id);
        entry.url && (attributes["lcp.url"] = entry.url);
        entry.loadTime != null && (attributes["lcp.loadTime"] = entry.loadTime);
        entry.renderTime != null && (attributes["lcp.renderTime"] = entry.renderTime);
        entry.size != null && (attributes["lcp.size"] = entry.size);
    }
    const span = (0, $0bd0f3212099db27$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("lcp", {
            [(0, $c30a0c8ed977cb48$export$f5f95cff026507b5)]: "millisecond",
            [(0, $c30a0c8ed977cb48$export$69cd5c610c7bb96a)]: lcpValue
        });
        span.end(startTime);
    }
}



var $7Y1KN = parcelRequire("7Y1KN");

function $0c308a4211d266ec$var$getAbsoluteTime(time) {
    return time ? (((0, $7Y1KN.browserPerformanceTimeOrigin)() || performance.timeOrigin) + time) / 1e3 : time;
}
function $0c308a4211d266ec$export$ec50b091612e7e00(resourceTiming) {
    const timingSpanData = {};
    if (resourceTiming.nextHopProtocol != void 0) {
        const { name: name, version: version } = (0, $0bd0f3212099db27$export$57c6f824442f9fe1)(resourceTiming.nextHopProtocol);
        timingSpanData["network.protocol.version"] = version;
        timingSpanData["network.protocol.name"] = name;
    }
    if (!((0, $7Y1KN.browserPerformanceTimeOrigin)() || (0, $0bd0f3212099db27$export$f72a13c439a30cab)()?.timeOrigin)) return timingSpanData;
    return $0c308a4211d266ec$var$dropUndefinedKeysFromObject({
        ...timingSpanData,
        "http.request.redirect_start": $0c308a4211d266ec$var$getAbsoluteTime(resourceTiming.redirectStart),
        "http.request.redirect_end": $0c308a4211d266ec$var$getAbsoluteTime(resourceTiming.redirectEnd),
        "http.request.worker_start": $0c308a4211d266ec$var$getAbsoluteTime(resourceTiming.workerStart),
        "http.request.fetch_start": $0c308a4211d266ec$var$getAbsoluteTime(resourceTiming.fetchStart),
        "http.request.domain_lookup_start": $0c308a4211d266ec$var$getAbsoluteTime(resourceTiming.domainLookupStart),
        "http.request.domain_lookup_end": $0c308a4211d266ec$var$getAbsoluteTime(resourceTiming.domainLookupEnd),
        "http.request.connect_start": $0c308a4211d266ec$var$getAbsoluteTime(resourceTiming.connectStart),
        "http.request.secure_connection_start": $0c308a4211d266ec$var$getAbsoluteTime(resourceTiming.secureConnectionStart),
        "http.request.connection_end": $0c308a4211d266ec$var$getAbsoluteTime(resourceTiming.connectEnd),
        "http.request.request_start": $0c308a4211d266ec$var$getAbsoluteTime(resourceTiming.requestStart),
        "http.request.response_start": $0c308a4211d266ec$var$getAbsoluteTime(resourceTiming.responseStart),
        "http.request.response_end": $0c308a4211d266ec$var$getAbsoluteTime(resourceTiming.responseEnd),
        // For TTFB we actually want the relative time from timeOrigin to responseStart
        // This way, TTFB always measures the "first page load" experience.
        // see: https://web.dev/articles/ttfb#measure-resource-requests
        "http.request.time_to_first_byte": resourceTiming.responseStart != null ? resourceTiming.responseStart / 1e3 : void 0
    });
}
function $0c308a4211d266ec$var$dropUndefinedKeysFromObject(attrs) {
    return Object.fromEntries(Object.entries(attrs).filter(([, value])=>value != null));
}







var $9yfTK = parcelRequire("9yfTK");
const $0069c1a6632705ed$var$MAX_INT_AS_BYTES = 2147483647;
let $0069c1a6632705ed$var$_performanceCursor = 0;
let $0069c1a6632705ed$var$_measurements = {};
let $0069c1a6632705ed$var$_lcpEntry;
let $0069c1a6632705ed$var$_clsEntry;
function $0069c1a6632705ed$export$7c69f0412d101b88({ recordClsStandaloneSpans: recordClsStandaloneSpans, recordLcpStandaloneSpans: recordLcpStandaloneSpans, client: client }) {
    const performance = (0, $0bd0f3212099db27$export$f72a13c439a30cab)();
    if (performance && (0, $7Y1KN.browserPerformanceTimeOrigin)()) {
        if (performance.mark) (0, $gWPaa.WINDOW).performance.mark("sentry-tracing-init");
        const lcpCleanupCallback = recordLcpStandaloneSpans ? (0, $c6e850f332a60fd8$export$485112b2cb5f79dc)(client) : recordLcpStandaloneSpans === false ? $0069c1a6632705ed$var$_trackLCP() : void 0;
        const clsCleanupCallback = recordClsStandaloneSpans ? (0, $b63715e52ba23274$export$585bab03c6c18c45)(client) : recordClsStandaloneSpans === false ? $0069c1a6632705ed$var$_trackCLS() : void 0;
        const ttfbCleanupCallback = $0069c1a6632705ed$var$_trackTtfb();
        const fpFcpCleanupCallback = $0069c1a6632705ed$var$_trackFpFcp();
        return ()=>{
            ttfbCleanupCallback();
            fpFcpCleanupCallback();
            lcpCleanupCallback?.();
            clsCleanupCallback?.();
        };
    }
    return ()=>void 0;
}
function $0069c1a6632705ed$export$f396d19077034ad2() {
    (0, $e40b9efaa71f0411$export$69816c1a049f8db6)("longtask", ({ entries: entries })=>{
        const parent = (0, $d3a61c536a2d1d8c$export$1be426a8e585c83e)();
        if (!parent) return;
        const { op: parentOp, start_timestamp: parentStartTimestamp } = (0, $d3a61c536a2d1d8c$export$92d8c23565496537)(parent);
        for (const entry of entries){
            const startTime = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)((0, $7Y1KN.browserPerformanceTimeOrigin)() + entry.startTime);
            const duration = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(entry.duration);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            (0, $0bd0f3212099db27$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-task",
                attributes: {
                    [(0, $c30a0c8ed977cb48$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            });
        }
    });
}
function $0069c1a6632705ed$export$5b823ab2ccbc801d() {
    const observer = new PerformanceObserver((list)=>{
        const parent = (0, $d3a61c536a2d1d8c$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of list.getEntries()){
            if (!entry.scripts[0]) continue;
            const startTime = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)((0, $7Y1KN.browserPerformanceTimeOrigin)() + entry.startTime);
            const { start_timestamp: parentStartTimestamp, op: parentOp } = (0, $d3a61c536a2d1d8c$export$92d8c23565496537)(parent);
            if (parentOp === "navigation" && parentStartTimestamp && startTime < parentStartTimestamp) continue;
            const duration = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(entry.duration);
            const attributes = {
                [(0, $c30a0c8ed977cb48$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            };
            const initialScript = entry.scripts[0];
            const { invoker: invoker, invokerType: invokerType, sourceURL: sourceURL, sourceFunctionName: sourceFunctionName, sourceCharPosition: sourceCharPosition } = initialScript;
            attributes["browser.script.invoker"] = invoker;
            attributes["browser.script.invoker_type"] = invokerType;
            if (sourceURL) attributes["code.filepath"] = sourceURL;
            if (sourceFunctionName) attributes["code.function"] = sourceFunctionName;
            if (sourceCharPosition !== -1) attributes["browser.script.source_char_position"] = sourceCharPosition;
            (0, $0bd0f3212099db27$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, {
                name: "Main UI thread blocked",
                op: "ui.long-animation-frame",
                attributes: attributes
            });
        }
    });
    observer.observe({
        type: "long-animation-frame",
        buffered: true
    });
}
function $0069c1a6632705ed$export$e27543e0976315e4() {
    (0, $e40b9efaa71f0411$export$69816c1a049f8db6)("event", ({ entries: entries })=>{
        const parent = (0, $d3a61c536a2d1d8c$export$1be426a8e585c83e)();
        if (!parent) return;
        for (const entry of entries)if (entry.name === "click") {
            const startTime = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)((0, $7Y1KN.browserPerformanceTimeOrigin)() + entry.startTime);
            const duration = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(entry.duration);
            const spanOptions = {
                name: (0, $1rNqq.htmlTreeAsString)(entry.target),
                op: `ui.interaction.${entry.name}`,
                startTime: startTime,
                attributes: {
                    [(0, $c30a0c8ed977cb48$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
                }
            };
            const componentName = (0, $a125234a7f829168$export$26727cfcc4d7e0fc)(entry.target);
            if (componentName) spanOptions.attributes["ui.component_name"] = componentName;
            (0, $0bd0f3212099db27$export$7567a67bdb69a23d)(parent, startTime, startTime + duration, spanOptions);
        }
    });
}
function $0069c1a6632705ed$var$_trackCLS() {
    return (0, $e40b9efaa71f0411$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $0069c1a6632705ed$var$_measurements["cls"] = {
            value: metric.value,
            unit: ""
        };
        $0069c1a6632705ed$var$_clsEntry = entry;
    }, true);
}
function $0069c1a6632705ed$var$_trackLCP() {
    return (0, $e40b9efaa71f0411$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $c6e850f332a60fd8$export$e59775b7d17699ba)(metric.value)) return;
        $0069c1a6632705ed$var$_measurements["lcp"] = {
            value: metric.value,
            unit: "millisecond"
        };
        $0069c1a6632705ed$var$_lcpEntry = entry;
    }, true);
}
function $0069c1a6632705ed$var$_trackTtfb() {
    return (0, $e40b9efaa71f0411$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        $0069c1a6632705ed$var$_measurements["ttfb"] = {
            value: metric.value,
            unit: "millisecond"
        };
    });
}
function $0069c1a6632705ed$var$_trackFpFcp() {
    return (0, $e40b9efaa71f0411$export$69816c1a049f8db6)("paint", ({ entries: entries })=>{
        const firstHidden = (0, $2c37c13e89983912$export$443f86b2c77012c4)();
        for (const entry of entries){
            const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
            if (entry.name === "first-paint" && shouldRecord) $0069c1a6632705ed$var$_measurements["fp"] = {
                value: entry.startTime,
                unit: "millisecond"
            };
            if (entry.name === "first-contentful-paint" && shouldRecord) $0069c1a6632705ed$var$_measurements["fcp"] = {
                value: entry.startTime,
                unit: "millisecond"
            };
        }
    });
}
function $0069c1a6632705ed$export$5f8fa6b3467a7443(span, options) {
    const performance = (0, $0bd0f3212099db27$export$f72a13c439a30cab)();
    const origin = (0, $7Y1KN.browserPerformanceTimeOrigin)();
    if (!performance?.getEntries || !origin) return;
    const { spanStreamingEnabled: spanStreamingEnabled, ignorePerformanceApiSpans: ignorePerformanceApiSpans, ignoreResourceSpans: ignoreResourceSpans } = options;
    const timeOrigin = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(origin);
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $d3a61c536a2d1d8c$export$92d8c23565496537)(span);
    performanceEntries.slice($0069c1a6632705ed$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(// Inexplicably, Chrome sometimes emits a negative duration. We need to work around this.
        // There is a SO post attempting to explain this, but it leaves one with open questions: https://stackoverflow.com/questions/23191918/peformance-getentries-and-negative-duration-display
        // The way we clamp the value is probably not accurate, since we have observed this happen for things that may take a while to load, like for example the replay worker.
        // TODO: Investigate why this happens and how to properly mitigate. For now, this is a workaround to prevent transactions being dropped due to negative duration spans.
        Math.max(0, entry.duration));
        if (op === "navigation" && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case "navigation":
                $0069c1a6632705ed$export$90a8fd571ed9a1bc(span, entry, timeOrigin);
                break;
            case "mark":
            case "paint":
            case "measure":
                $0069c1a6632705ed$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans);
                break;
            case "resource":
                $0069c1a6632705ed$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin, ignoreResourceSpans);
                break;
        }
    });
    $0069c1a6632705ed$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $0069c1a6632705ed$var$_trackNavigator(span, spanStreamingEnabled);
}
function $0069c1a6632705ed$export$d14e394b690acc17(span, options) {
    const origin = (0, $7Y1KN.browserPerformanceTimeOrigin)();
    if (!(0, $0bd0f3212099db27$export$f72a13c439a30cab)()?.getEntries || !origin) {
        $0069c1a6632705ed$var$resetWebVitalState();
        return;
    }
    const { spanStreamingEnabled: spanStreamingEnabled, recordClsOnPageloadSpan: recordClsOnPageloadSpan, recordLcpOnPageloadSpan: recordLcpOnPageloadSpan } = options;
    const timeOrigin = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(origin);
    if ((0, $d3a61c536a2d1d8c$export$92d8c23565496537)(span).op === "pageload") {
        $0069c1a6632705ed$var$_addTtfbRequestTimeToMeasurements($0069c1a6632705ed$var$_measurements);
        if (spanStreamingEnabled) {
            const setAttr = (shortWebVitalName, value, customAttrName)=>{
                const attrKey = customAttrName ?? `browser.web_vital.${shortWebVitalName}.value`;
                span.setAttribute(attrKey, value);
                (0, $9yfTK.DEBUG_BUILD) && (0, $w8bd7.debug).log("Setting web vital attribute", {
                    [attrKey]: value
                }, "on pageload span");
            };
            [
                "ttfb",
                "fp",
                "fcp"
            ].forEach((measurementName)=>{
                if ($0069c1a6632705ed$var$_measurements[measurementName]) setAttr(measurementName, $0069c1a6632705ed$var$_measurements[measurementName].value);
            });
            if ($0069c1a6632705ed$var$_measurements["ttfb.requestTime"]) setAttr("ttfb.requestTime", $0069c1a6632705ed$var$_measurements["ttfb.requestTime"].value, "browser.web_vital.ttfb.request_time");
        } else {
            if (!recordClsOnPageloadSpan) delete $0069c1a6632705ed$var$_measurements.cls;
            if (!recordLcpOnPageloadSpan) delete $0069c1a6632705ed$var$_measurements.lcp;
            Object.entries($0069c1a6632705ed$var$_measurements).forEach(([measurementName, measurement])=>{
                (0, $2174c183125e1337$export$7cc31b475d33a706)(measurementName, measurement.value, measurement.unit, span);
            });
            $0069c1a6632705ed$var$_setWebVitalAttributes(span, options);
        }
        span.setAttribute(spanStreamingEnabled ? "browser.performance.time_origin" : "performance.timeOrigin", timeOrigin);
        span.setAttribute(spanStreamingEnabled ? "browser.performance.navigation.activation_start" : "performance.activationStart", (0, $bc726a4d4c88cc5c$export$d3e828b3c7b5b845)());
    }
    $0069c1a6632705ed$var$resetWebVitalState();
}
function $0069c1a6632705ed$var$resetWebVitalState() {
    $0069c1a6632705ed$var$_lcpEntry = void 0;
    $0069c1a6632705ed$var$_clsEntry = void 0;
    $0069c1a6632705ed$var$_measurements = {};
}
function $0069c1a6632705ed$var$isReact19MeasureEntry(entry) {
    if (entry?.entryType !== "measure") return;
    try {
        return entry.detail.devtools.track === "Components \u269B";
    } catch  {
        return;
    }
}
function $0069c1a6632705ed$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin, ignorePerformanceApiSpans) {
    if ($0069c1a6632705ed$var$isReact19MeasureEntry(entry)) return;
    if ([
        "mark",
        "measure"
    ].includes(entry.entryType) && (0, $kWdMm.stringMatchesSomePattern)(entry.name, ignorePerformanceApiSpans)) return;
    const navEntry = (0, $83c5af87602f1470$export$6431553786c94949)(false);
    const requestTime = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(navEntry ? navEntry.requestStart : 0);
    const measureStartTimestamp = timeOrigin + Math.max(startTime, requestTime);
    const startTimeStamp = timeOrigin + startTime;
    const measureEndTimestamp = startTimeStamp + duration;
    const attributes = {
        [(0, $c30a0c8ed977cb48$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    if (measureStartTimestamp !== startTimeStamp) {
        attributes["sentry.browser.measure_happened_before_request"] = true;
        attributes["sentry.browser.measure_start_time"] = measureStartTimestamp;
    }
    $0069c1a6632705ed$var$_addDetailToSpanAttributes(attributes, entry);
    if (measureStartTimestamp <= measureEndTimestamp) (0, $0bd0f3212099db27$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: attributes
    });
}
function $0069c1a6632705ed$var$_addDetailToSpanAttributes(attributes, performanceMeasure) {
    try {
        const detail = performanceMeasure.detail;
        if (!detail) return;
        if (typeof detail === "object") {
            for (const [key, value] of Object.entries(detail)){
                if (value && (0, $9ISAs.isPrimitive)(value)) attributes[`sentry.browser.measure.detail.${key}`] = value;
                else if (value !== void 0) try {
                    attributes[`sentry.browser.measure.detail.${key}`] = JSON.stringify(value);
                } catch  {}
            }
            return;
        }
        if ((0, $9ISAs.isPrimitive)(detail)) {
            attributes["sentry.browser.measure.detail"] = detail;
            return;
        }
        try {
            attributes["sentry.browser.measure.detail"] = JSON.stringify(detail);
        } catch  {}
    } catch  {}
}
function $0069c1a6632705ed$export$90a8fd571ed9a1bc(span, entry, timeOrigin) {
    [
        "unloadEvent",
        "redirect",
        "domContentLoadedEvent",
        "loadEvent",
        "connect"
    ].forEach((event)=>{
        $0069c1a6632705ed$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $0069c1a6632705ed$var$_addPerformanceNavigationTiming(span, entry, "secureConnection", timeOrigin, "TLS/SSL");
    $0069c1a6632705ed$var$_addPerformanceNavigationTiming(span, entry, "fetch", timeOrigin, "cache");
    $0069c1a6632705ed$var$_addPerformanceNavigationTiming(span, entry, "domainLookup", timeOrigin, "DNS");
    $0069c1a6632705ed$var$_addRequest(span, entry, timeOrigin);
}
function $0069c1a6632705ed$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin, name = event) {
    const eventEnd = $0069c1a6632705ed$var$_getEndPropertyNameForNavigationTiming(event);
    const end = entry[eventEnd];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $0bd0f3212099db27$export$7567a67bdb69a23d)(span, timeOrigin + (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(end), {
        op: `browser.${name}`,
        name: entry.name,
        attributes: {
            [(0, $c30a0c8ed977cb48$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics",
            ...event === "redirect" && entry.redirectCount != null ? {
                "http.redirect_count": entry.redirectCount
            } : {}
        }
    });
}
function $0069c1a6632705ed$var$_getEndPropertyNameForNavigationTiming(event) {
    if (event === "secureConnection") return "connectEnd";
    if (event === "fetch") return "domainLookupStart";
    return `${event}End`;
}
function $0069c1a6632705ed$var$_addRequest(span, entry, timeOrigin) {
    const requestStartTimestamp = timeOrigin + (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(entry.requestStart);
    const responseEndTimestamp = timeOrigin + (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(entry.responseEnd);
    const responseStartTimestamp = timeOrigin + (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(entry.responseStart);
    if (entry.responseEnd) {
        (0, $0bd0f3212099db27$export$7567a67bdb69a23d)(span, requestStartTimestamp, responseEndTimestamp, {
            op: "browser.request",
            name: entry.name,
            attributes: {
                [(0, $c30a0c8ed977cb48$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
        (0, $0bd0f3212099db27$export$7567a67bdb69a23d)(span, responseStartTimestamp, responseEndTimestamp, {
            op: "browser.response",
            name: entry.name,
            attributes: {
                [(0, $c30a0c8ed977cb48$export$cca8dd30f57f805e)]: "auto.ui.browser.metrics"
            }
        });
    }
}
function $0069c1a6632705ed$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin, ignoredResourceSpanOps) {
    if (entry.initiatorType === "xmlhttprequest" || entry.initiatorType === "fetch") return;
    const op = entry.initiatorType ? `resource.${entry.initiatorType}` : "resource.other";
    if (ignoredResourceSpanOps?.includes(op)) return;
    const attributes = {
        [(0, $c30a0c8ed977cb48$export$cca8dd30f57f805e)]: "auto.resource.browser.metrics"
    };
    const parsedUrl = (0, $b039a86df453775d$export$7a5253c0f62e0150)(resourceUrl);
    if (parsedUrl.protocol) attributes["url.scheme"] = parsedUrl.protocol.split(":").pop();
    if (parsedUrl.host) attributes["server.address"] = parsedUrl.host;
    attributes["url.same_origin"] = resourceUrl.includes((0, $gWPaa.WINDOW).location.origin);
    attributes[0, $c30a0c8ed977cb48$export$25dfd73e0e32c6e1] = resourceUrl;
    $0069c1a6632705ed$export$6ce741ceee01ab2f(entry, attributes, [
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/responseStatus
        [
            "responseStatus",
            "http.response.status_code"
        ],
        [
            "transferSize",
            "http.response_transfer_size"
        ],
        [
            "encodedBodySize",
            "http.response_content_length"
        ],
        [
            "decodedBodySize",
            "http.decoded_response_content_length"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/renderBlockingStatus
        [
            "renderBlockingStatus",
            "resource.render_blocking_status"
        ],
        // https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/deliveryType
        [
            "deliveryType",
            "http.response_delivery_type"
        ]
    ]);
    const attributesWithResourceTiming = {
        ...attributes,
        ...(0, $0c308a4211d266ec$export$ec50b091612e7e00)(entry)
    };
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $0bd0f3212099db27$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $gWPaa.WINDOW).location.origin, ""),
        op: op,
        attributes: attributesWithResourceTiming
    });
}
function $0069c1a6632705ed$var$_trackNavigator(span, spanStreamingEnabled) {
    const navigator = (0, $gWPaa.WINDOW).navigator;
    if (!navigator) return;
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute(spanStreamingEnabled ? "network.connection.effective_type" : "effectiveConnectionType", connection.effectiveType);
        if (connection.type) span.setAttribute(spanStreamingEnabled ? "network.connection.type" : "connectionType", connection.type);
        if ((0, $0bd0f3212099db27$export$27169ccae1b439e3)(connection.rtt)) {
            if (spanStreamingEnabled) span.setAttribute("network.connection.rtt", connection.rtt);
            else if ((0, $d3a61c536a2d1d8c$export$92d8c23565496537)(span).op === "pageload") (0, $2174c183125e1337$export$7cc31b475d33a706)("connection.rtt", connection.rtt, "millisecond");
        }
    }
    if ((0, $0bd0f3212099db27$export$27169ccae1b439e3)(navigator.deviceMemory)) {
        if (spanStreamingEnabled) span.setAttribute("device.memory.estimated_capacity", navigator.deviceMemory);
        else span.setAttribute("deviceMemory", `${navigator.deviceMemory} GB`);
    }
    if ((0, $0bd0f3212099db27$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) {
        if (spanStreamingEnabled) span.setAttribute("device.processor_count", navigator.hardwareConcurrency);
        else span.setAttribute("hardwareConcurrency", String(navigator.hardwareConcurrency));
    }
}
function $0069c1a6632705ed$var$_setWebVitalAttributes(span, options) {
    if ($0069c1a6632705ed$var$_lcpEntry && options.recordLcpOnPageloadSpan) {
        if ($0069c1a6632705ed$var$_lcpEntry.element) span.setAttribute("lcp.element", (0, $1rNqq.htmlTreeAsString)($0069c1a6632705ed$var$_lcpEntry.element));
        if ($0069c1a6632705ed$var$_lcpEntry.id) span.setAttribute("lcp.id", $0069c1a6632705ed$var$_lcpEntry.id);
        if ($0069c1a6632705ed$var$_lcpEntry.url) span.setAttribute("lcp.url", $0069c1a6632705ed$var$_lcpEntry.url.trim().slice(0, 200));
        if ($0069c1a6632705ed$var$_lcpEntry.loadTime != null) span.setAttribute("lcp.loadTime", $0069c1a6632705ed$var$_lcpEntry.loadTime);
        if ($0069c1a6632705ed$var$_lcpEntry.renderTime != null) span.setAttribute("lcp.renderTime", $0069c1a6632705ed$var$_lcpEntry.renderTime);
        span.setAttribute("lcp.size", $0069c1a6632705ed$var$_lcpEntry.size);
    }
    if ($0069c1a6632705ed$var$_clsEntry?.sources && options.recordClsOnPageloadSpan) $0069c1a6632705ed$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $1rNqq.htmlTreeAsString)(source.node)));
}
function $0069c1a6632705ed$export$6ce741ceee01ab2f(entry, attributes, properties) {
    properties.forEach(([entryKey, attributeKey])=>{
        const entryVal = entry[entryKey];
        if (entryVal != null && (typeof entryVal === "number" && entryVal < $0069c1a6632705ed$var$MAX_INT_AS_BYTES || typeof entryVal === "string")) attributes[attributeKey] = entryVal;
    });
}
function $0069c1a6632705ed$var$_addTtfbRequestTimeToMeasurements(_measurements2) {
    const navEntry = (0, $83c5af87602f1470$export$6431553786c94949)(false);
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) _measurements2["ttfb.requestTime"] = {
        value: responseStart - requestStart,
        unit: "millisecond"
    };
}



var $f67fK = parcelRequire("f67fK");

var $bHKc9 = parcelRequire("bHKc9");


var $9ISAs = parcelRequire("9ISAs");

var $4zVoD = parcelRequire("4zVoD");

var $i0qqg = parcelRequire("i0qqg");

var $7Y1KN = parcelRequire("7Y1KN");

var $bZENS = parcelRequire("bZENS");

var $f5byn = parcelRequire("f5byn");
function $bd42e74f4b5ffd2b$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = "fetch";
    const removeHandler = (0, $f5byn.addHandler)(type, handler);
    (0, $f5byn.maybeInstrument)(type, ()=>$bd42e74f4b5ffd2b$var$instrumentFetch(void 0, skipNativeFetchCheck));
    return removeHandler;
}
function $bd42e74f4b5ffd2b$export$1a79663eb318fe6a(handler) {
    const type = "fetch-body-resolved";
    const removeHandler = (0, $f5byn.addHandler)(type, handler);
    (0, $f5byn.maybeInstrument)(type, ()=>$bd42e74f4b5ffd2b$var$instrumentFetch($bd42e74f4b5ffd2b$var$streamHandler));
    return removeHandler;
}
function $bd42e74f4b5ffd2b$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $i0qqg.supportsNativeFetch)()) return;
    (0, $4zVoD.fill)((0, $bZENS.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            const virtualError = new Error();
            const { method: method, url: url } = $bd42e74f4b5ffd2b$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $7Y1KN.timestampInSeconds)() * 1e3,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $bd42e74f4b5ffd2b$var$getHeadersFromFetchArgs(args)
            };
            if (!onFetchResolved) (0, $f5byn.triggerHandlers)("fetch", {
                ...handlerData
            });
            return originalFetch.apply((0, $bZENS.GLOBAL_OBJ), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $f5byn.triggerHandlers)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $7Y1KN.timestampInSeconds)() * 1e3,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $f5byn.triggerHandlers)("fetch", {
                    ...handlerData,
                    endTimestamp: (0, $7Y1KN.timestampInSeconds)() * 1e3,
                    error: error
                });
                if ((0, $9ISAs.isError)(error) && error.stack === void 0) {
                    error.stack = virtualError.stack;
                    (0, $4zVoD.addNonEnumerableProperty)(error, "framesToPop", 1);
                }
                const client = (0, $9f9f083568f3177b$export$6bb76d6eba7e258c)();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? "always";
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === "Failed to fetch" || error.message === "Load failed" || error.message === "NetworkError when attempting to fetch resource.")) try {
                    const url2 = new URL(handlerData.fetchData.url);
                    const hostname = url2.host;
                    if (enhanceOption === "always") error.message = `${error.message} (${hostname})`;
                    else (0, $4zVoD.addNonEnumerableProperty)(error, "__sentry_fetch_url_host__", hostname);
                } catch  {}
                throw error;
            });
        };
    });
}
async function $bd42e74f4b5ffd2b$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{});
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{});
                }, 5e3);
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{});
    }
}
function $bd42e74f4b5ffd2b$var$streamHandler(response) {
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    $bd42e74f4b5ffd2b$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $f5byn.triggerHandlers)("fetch-body-resolved", {
            endTimestamp: (0, $7Y1KN.timestampInSeconds)() * 1e3,
            response: response
        });
    });
}
function $bd42e74f4b5ffd2b$var$hasProp(obj, prop) {
    return (0, $9ISAs.isObjectLike)(obj) && !!obj[prop];
}
function $bd42e74f4b5ffd2b$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($bd42e74f4b5ffd2b$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
function $bd42e74f4b5ffd2b$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $bd42e74f4b5ffd2b$var$getUrlFromResource(resource),
            method: $bd42e74f4b5ffd2b$var$hasProp(options, "method") ? String(options.method).toUpperCase() : // Request object as first argument
            (0, $9ISAs.isRequest)(resource) && $bd42e74f4b5ffd2b$var$hasProp(resource, "method") ? String(resource.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $bd42e74f4b5ffd2b$var$getUrlFromResource(arg),
        method: $bd42e74f4b5ffd2b$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}
function $bd42e74f4b5ffd2b$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === "object" && optionsArgument !== null && "headers" in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $9ISAs.isRequest)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {}
    return;
}



var $hv7EP = parcelRequire("hv7EP");

var $w8bd7 = parcelRequire("w8bd7");
const $dd99e6d3a0bfc61a$export$b14a8888f80a0b3e = [];
function $dd99e6d3a0bfc61a$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
function $dd99e6d3a0bfc61a$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $dd99e6d3a0bfc61a$var$filterDuplicates(integrations);
}
function $dd99e6d3a0bfc61a$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        if (integration?.beforeSetup) integration.beforeSetup(client);
    });
    integrations.forEach((integration)=>{
        if (integration) $dd99e6d3a0bfc61a$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
function $dd99e6d3a0bfc61a$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
function $dd99e6d3a0bfc61a$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    if (!$dd99e6d3a0bfc61a$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === "function") {
        integration.setupOnce();
        $dd99e6d3a0bfc61a$export$b14a8888f80a0b3e.push(integration.name);
    }
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    [
        "processSpan",
        "processSegmentSpan"
    ].forEach((hook)=>{
        const callback = integration[hook];
        if (typeof callback === "function") client.on(hook, (span)=>callback.call(integration, span, client));
    });
    (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Integration installed: ${integration.name}`);
}
function $dd99e6d3a0bfc61a$export$2d8f5188773bcddd(integration) {
    const client = (0, $9f9f083568f3177b$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $hv7EP.DEBUG_BUILD) && (0, $w8bd7.debug).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
function $dd99e6d3a0bfc61a$export$2323046b9414659f(fn) {
    return fn;
}
function $dd99e6d3a0bfc61a$export$92d0786473d2c0a1(integration, extendedIntegration) {
    const wrappedIntegration = {
        ...integration,
        ...extendedIntegration
    };
    for(const key in extendedIntegration){
        const baseValue = integration[key];
        const extendedValue = extendedIntegration[key];
        if (typeof baseValue === "function" && typeof extendedValue === "function") {
            const wrappedFunction = new Proxy(baseValue, {
                apply: (target, thisArg, args)=>{
                    Reflect.apply(target, thisArg, args);
                    return Reflect.apply(extendedValue, thisArg, args);
                }
            });
            wrappedIntegration[key] = wrappedFunction;
        }
    }
    return wrappedIntegration;
}


const $42bebb1373a50467$var$responseToStreamSpan = /* @__PURE__ */ new WeakMap();
const $42bebb1373a50467$var$responseToFallbackTimeout = /* @__PURE__ */ new WeakMap();
const $42bebb1373a50467$var$STREAM_RESOLVE_FALLBACK_MS = 9e4;
const $42bebb1373a50467$var$STREAMING_CONTENT_TYPES = [
    "text/event-stream",
    "application/x-ndjson",
    "application/stream+json"
];
const $42bebb1373a50467$export$b49e0d1a48dc8754 = (0, $dd99e6d3a0bfc61a$export$2323046b9414659f)(()=>{
    return {
        name: "FetchStreamPerformance",
        setup () {
            (0, $bd42e74f4b5ffd2b$export$1a79663eb318fe6a)((handlerData)=>{
                if (handlerData.response) {
                    const streamSpan = $42bebb1373a50467$var$responseToStreamSpan.get(handlerData.response);
                    if (streamSpan && handlerData.endTimestamp) {
                        streamSpan.end(handlerData.endTimestamp);
                        const fallbackTimeout = $42bebb1373a50467$var$responseToFallbackTimeout.get(handlerData.response);
                        if (fallbackTimeout) clearTimeout(fallbackTimeout);
                    }
                }
            });
            (0, $bd42e74f4b5ffd2b$export$f75d3c772c923df0)((handlerData)=>{
                if (handlerData.endTimestamp && handlerData.response) {
                    const contentType = handlerData.response.headers?.get("content-type") || "";
                    if (handlerData.response.headers?.get("content-length") || !$42bebb1373a50467$var$STREAMING_CONTENT_TYPES.some((t)=>contentType.startsWith(t))) return;
                    const url = handlerData.fetchData?.url || "";
                    const method = handlerData.fetchData?.method || "GET";
                    const parsedUrl = (0, $b039a86df453775d$export$2004d912a9ead694)(url);
                    const sanitizedUrl = url.startsWith("data:") ? (0, $b039a86df453775d$export$8abd806fcaf234fa)(url) : parsedUrl ? (0, $b039a86df453775d$export$5339fcdc8e2a427c)(parsedUrl) : url;
                    const streamSpan = (0, $07238d64f16b4415$export$63dbba021a6b4047)({
                        name: `${method} ${sanitizedUrl}`,
                        startTime: handlerData.endTimestamp,
                        attributes: {
                            url: (0, $b039a86df453775d$export$8abd806fcaf234fa)(url),
                            "http.method": method,
                            type: "fetch",
                            [(0, $c30a0c8ed977cb48$export$1a413bd9a88fdb09)]: "http.client.stream",
                            [(0, $c30a0c8ed977cb48$export$cca8dd30f57f805e)]: "auto.http.browser.stream"
                        }
                    });
                    $42bebb1373a50467$var$responseToStreamSpan.set(handlerData.response, streamSpan);
                    const fallbackTimeout = setTimeout(()=>{
                        if (streamSpan.isRecording()) streamSpan.end();
                    }, $42bebb1373a50467$var$STREAM_RESOLVE_FALLBACK_MS);
                    $42bebb1373a50467$var$responseToFallbackTimeout.set(handlerData.response, fallbackTimeout);
                }
            });
        }
    };
});



var $gaxBK = parcelRequire("gaxBK");

var $7Y1KN = parcelRequire("7Y1KN");
var $5N0Bk = parcelRequire("5N0Bk");

var $bZENS = parcelRequire("bZENS");
function $dd9c23c84930f840$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" && (!(0, $5N0Bk.isNodeEnv)() || $dd9c23c84930f840$var$isElectronNodeRenderer());
}
function $dd9c23c84930f840$var$isElectronNodeRenderer() {
    const process = (0, $bZENS.GLOBAL_OBJ).process;
    return process?.type === "renderer";
}



var $1rNqq = parcelRequire("1rNqq");

var $gWPaa = parcelRequire("gWPaa");


const $a30de91624a38c7a$var$LAST_INTERACTIONS = [];
const $a30de91624a38c7a$var$INTERACTIONS_SPAN_MAP = /* @__PURE__ */ new Map();
const $a30de91624a38c7a$var$ELEMENT_NAME_TIMESTAMP_MAP = /* @__PURE__ */ new Map();
const $a30de91624a38c7a$export$619786413bcce1e1 = 60;
function $a30de91624a38c7a$export$f17d06681a4744a3() {
    const performance = (0, $0bd0f3212099db27$export$f72a13c439a30cab)();
    if (performance && (0, $7Y1KN.browserPerformanceTimeOrigin)()) {
        const inpCallback = $a30de91624a38c7a$export$eeab203db0ed99a9();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>void 0;
}
const $a30de91624a38c7a$export$7cd941f925ded42f = {
    click: "click",
    pointerdown: "click",
    pointerup: "click",
    mousedown: "click",
    mouseup: "click",
    touchstart: "click",
    touchend: "click",
    mouseover: "hover",
    mouseout: "hover",
    mouseenter: "hover",
    mouseleave: "hover",
    pointerover: "hover",
    pointerout: "hover",
    pointerenter: "hover",
    pointerleave: "hover",
    dragstart: "drag",
    dragend: "drag",
    drag: "drag",
    dragenter: "drag",
    dragleave: "drag",
    dragover: "drag",
    drop: "drag",
    keydown: "press",
    keyup: "press",
    keypress: "press",
    input: "press"
};
function $a30de91624a38c7a$export$eeab203db0ed99a9() {
    return (0, $e40b9efaa71f0411$export$da3b76aa2022cbd7)($a30de91624a38c7a$export$7bcb98fe01441521);
}
const $a30de91624a38c7a$export$7bcb98fe01441521 = ({ metric: metric })=>{
    if (metric.value == void 0) return;
    const duration = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(metric.value);
    if (duration > $a30de91624a38c7a$export$619786413bcce1e1) return;
    const entry = metric.entries.find((entry2)=>entry2.duration === metric.value && $a30de91624a38c7a$export$7cd941f925ded42f[entry2.name]);
    if (!entry) return;
    const { interactionId: interactionId } = entry;
    const interactionType = $a30de91624a38c7a$export$7cd941f925ded42f[entry.name];
    const startTime = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)((0, $7Y1KN.browserPerformanceTimeOrigin)() + entry.startTime);
    const activeSpan = (0, $d3a61c536a2d1d8c$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $d3a61c536a2d1d8c$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    const cachedInteractionContext = interactionId != null ? $a30de91624a38c7a$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
    const spanToUse = cachedInteractionContext?.span || rootSpan;
    const routeName = spanToUse ? (0, $d3a61c536a2d1d8c$export$92d8c23565496537)(spanToUse).description : (0, $9f9f083568f3177b$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = cachedInteractionContext?.elementName || (0, $1rNqq.htmlTreeAsString)(entry.target);
    const attributes = {
        [(0, $c30a0c8ed977cb48$export$cca8dd30f57f805e)]: "auto.http.browser.inp",
        [(0, $c30a0c8ed977cb48$export$1a413bd9a88fdb09)]: `ui.interaction.${interactionType}`,
        [(0, $c30a0c8ed977cb48$export$fea48ba9f4550879)]: entry.duration
    };
    const span = (0, $0bd0f3212099db27$export$b71b9c7b60c5a4aa)({
        name: name,
        transaction: routeName,
        attributes: attributes,
        startTime: startTime
    });
    if (span) {
        span.addEvent("inp", {
            [(0, $c30a0c8ed977cb48$export$f5f95cff026507b5)]: "millisecond",
            [(0, $c30a0c8ed977cb48$export$69cd5c610c7bb96a)]: metric.value
        });
        span.end(startTime + duration);
    }
};
function $a30de91624a38c7a$export$e4a670d077ebcfef(interactionId) {
    return interactionId != null ? $a30de91624a38c7a$var$INTERACTIONS_SPAN_MAP.get(interactionId) : void 0;
}
function $a30de91624a38c7a$export$e4e04d43e223cce2() {
    const interactionEvents = Object.keys($a30de91624a38c7a$export$7cd941f925ded42f);
    if ((0, $dd9c23c84930f840$export$4e09c449d6c407f7)()) interactionEvents.forEach((eventType)=>{
        (0, $gWPaa.WINDOW).addEventListener(eventType, captureElementFromEvent, {
            capture: true,
            passive: true
        });
    });
    function captureElementFromEvent(event) {
        const target = event.target;
        if (!target) return;
        const elementName = (0, $1rNqq.htmlTreeAsString)(target);
        const timestamp = Math.round(event.timeStamp);
        $a30de91624a38c7a$var$ELEMENT_NAME_TIMESTAMP_MAP.set(timestamp, elementName);
        if ($a30de91624a38c7a$var$ELEMENT_NAME_TIMESTAMP_MAP.size > 50) {
            const firstKey = $a30de91624a38c7a$var$ELEMENT_NAME_TIMESTAMP_MAP.keys().next().value;
            if (firstKey !== void 0) $a30de91624a38c7a$var$ELEMENT_NAME_TIMESTAMP_MAP.delete(firstKey);
        }
    }
    function resolveElementNameFromEntry(entry) {
        const timestamp = Math.round(entry.startTime);
        let elementName = $a30de91624a38c7a$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp);
        if (!elementName) for(let offset = -5; offset <= 5; offset++){
            const nearbyName = $a30de91624a38c7a$var$ELEMENT_NAME_TIMESTAMP_MAP.get(timestamp + offset);
            if (nearbyName) {
                elementName = nearbyName;
                break;
            }
        }
        return elementName || "<unknown>";
    }
    const handleEntries = ({ entries: entries })=>{
        const activeSpan = (0, $d3a61c536a2d1d8c$export$1be426a8e585c83e)();
        const activeRootSpan = activeSpan && (0, $d3a61c536a2d1d8c$export$c4c6a79b1260ca1b)(activeSpan);
        entries.forEach((entry)=>{
            if (!(0, $e40b9efaa71f0411$export$7affb50b622d8714)(entry)) return;
            const interactionId = entry.interactionId;
            if (interactionId == null) return;
            if ($a30de91624a38c7a$var$INTERACTIONS_SPAN_MAP.has(interactionId)) return;
            const elementName = entry.target ? (0, $1rNqq.htmlTreeAsString)(entry.target) : resolveElementNameFromEntry(entry);
            if ($a30de91624a38c7a$var$LAST_INTERACTIONS.length > 10) {
                const last = $a30de91624a38c7a$var$LAST_INTERACTIONS.shift();
                $a30de91624a38c7a$var$INTERACTIONS_SPAN_MAP.delete(last);
            }
            $a30de91624a38c7a$var$LAST_INTERACTIONS.push(interactionId);
            $a30de91624a38c7a$var$INTERACTIONS_SPAN_MAP.set(interactionId, {
                span: activeRootSpan,
                elementName: elementName
            });
        });
    };
    (0, $e40b9efaa71f0411$export$69816c1a049f8db6)("event", handleEntries);
    (0, $e40b9efaa71f0411$export$69816c1a049f8db6)("first-input", handleEntries);
}


var $7Y1KN = parcelRequire("7Y1KN");
var $w8bd7 = parcelRequire("w8bd7");

var $9yfTK = parcelRequire("9yfTK");

var $1rNqq = parcelRequire("1rNqq");

var $gWPaa = parcelRequire("gWPaa");





var $5Qfaf = parcelRequire("5Qfaf");
function $7f13dacc81ea33ad$export$f4adb23e57c1dac6(options) {
    const { name: name, op: op, origin: origin, metricName: metricName, value: value, attributes: passedAttributes, parentSpan: parentSpan, reportEvent: reportEvent, startTime: startTime, endTime: endTime } = options;
    const routeName = (0, $9f9f083568f3177b$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const attributes = {
        [(0, $c30a0c8ed977cb48$export$cca8dd30f57f805e)]: origin,
        [(0, $c30a0c8ed977cb48$export$1a413bd9a88fdb09)]: op,
        [(0, $c30a0c8ed977cb48$export$fea48ba9f4550879)]: 0,
        [`browser.web_vital.${metricName}.value`]: value,
        // oxlint-disable-next-line typescript-eslint/no-deprecated
        [(0, $5Qfaf.SENTRY_TRANSACTION)]: routeName,
        [(0, $5Qfaf.SENTRY_SEGMENT_NAME)]: routeName,
        // Web vital score calculation relies on the user agent
        "user_agent.original": (0, $gWPaa.WINDOW).navigator?.userAgent,
        ...passedAttributes
    };
    if (parentSpan && (0, $d3a61c536a2d1d8c$export$db0cad9e44f67af8)(parentSpan).attributes?.[0, $c30a0c8ed977cb48$export$1a413bd9a88fdb09] === "pageload") attributes["sentry.pageload.span_id"] = parentSpan.spanContext().spanId;
    if (reportEvent) attributes[`browser.web_vital.${metricName}.report_event`] = reportEvent;
    const span = (0, $07238d64f16b4415$export$63dbba021a6b4047)({
        name: name,
        attributes: attributes,
        startTime: startTime,
        parentSpan: // if we have a pageload span, we let the web vital span start as its parent. This ensures that
        // it is not started as a segment span, without having to manually set it to a "standalone" v2 span
        // that has `segment: false` but no actual parent span.
        parentSpan
    });
    if (span) span.end(endTime ?? startTime);
}
function $7f13dacc81ea33ad$export$73747c030e2325c0(client) {
    let lcpValue = 0;
    let lcpEntry;
    if (!(0, $0bd0f3212099db27$export$c7533a7b4a9f2e94)("largest-contentful-paint")) return;
    const cleanupLcpHandler = (0, $e40b9efaa71f0411$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry || !(0, $c6e850f332a60fd8$export$e59775b7d17699ba)(metric.value)) return;
        lcpValue = metric.value;
        lcpEntry = entry;
    }, true);
    (0, $0bd0f3212099db27$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $7f13dacc81ea33ad$export$1adcb85d073cd594(lcpValue, lcpEntry, pageloadSpan, reportEvent);
        cleanupLcpHandler();
    });
}
function $7f13dacc81ea33ad$export$1adcb85d073cd594(lcpValue, entry, pageloadSpan, reportEvent) {
    if (!(0, $c6e850f332a60fd8$export$e59775b7d17699ba)(lcpValue)) return;
    (0, $9yfTK.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Sending LCP span (${lcpValue})`);
    const performanceTimeOrigin = (0, $7Y1KN.browserPerformanceTimeOrigin)() || 0;
    const timeOrigin = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(performanceTimeOrigin);
    const endTime = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(performanceTimeOrigin + (entry?.startTime || 0));
    const name = entry ? (0, $1rNqq.htmlTreeAsString)(entry.element) : "Largest contentful paint";
    const attributes = {};
    entry?.element && (attributes["browser.web_vital.lcp.element"] = (0, $1rNqq.htmlTreeAsString)(entry.element));
    entry?.id && (attributes["browser.web_vital.lcp.id"] = entry.id);
    entry?.url && (attributes["browser.web_vital.lcp.url"] = entry.url);
    entry?.loadTime != null && (attributes["browser.web_vital.lcp.load_time"] = entry.loadTime);
    entry?.renderTime != null && (attributes["browser.web_vital.lcp.render_time"] = entry.renderTime);
    entry?.size != null && (attributes["browser.web_vital.lcp.size"] = entry.size);
    $7f13dacc81ea33ad$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.lcp",
        origin: "auto.http.browser.lcp",
        metricName: "lcp",
        value: lcpValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: timeOrigin,
        endTime: endTime
    });
}
function $7f13dacc81ea33ad$export$f2ca9ed704743eb2(client) {
    let clsValue = 0;
    let clsEntry;
    if (!(0, $0bd0f3212099db27$export$c7533a7b4a9f2e94)("layout-shift")) return;
    const cleanupClsHandler = (0, $e40b9efaa71f0411$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        clsValue = metric.value;
        clsEntry = entry;
    }, true);
    (0, $0bd0f3212099db27$export$382ad360b45665ab)(client, (reportEvent, _, pageloadSpan)=>{
        $7f13dacc81ea33ad$export$736c846d4f7aff83(clsValue, clsEntry, pageloadSpan, reportEvent);
        cleanupClsHandler();
    });
}
function $7f13dacc81ea33ad$export$736c846d4f7aff83(clsValue, entry, pageloadSpan, reportEvent) {
    (0, $9yfTK.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Sending CLS span (${clsValue})`);
    const startTime = entry ? (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(((0, $7Y1KN.browserPerformanceTimeOrigin)() || 0) + entry.startTime) : (0, $7Y1KN.timestampInSeconds)();
    const name = entry ? (0, $1rNqq.htmlTreeAsString)(entry.sources[0]?.node) : "Layout shift";
    const attributes = {};
    if (entry?.sources) entry.sources.forEach((source, index)=>{
        attributes[`browser.web_vital.cls.source.${index + 1}`] = (0, $1rNqq.htmlTreeAsString)(source.node);
    });
    $7f13dacc81ea33ad$export$f4adb23e57c1dac6({
        name: name,
        op: "ui.webvital.cls",
        origin: "auto.http.browser.cls",
        metricName: "cls",
        value: clsValue,
        attributes: attributes,
        parentSpan: pageloadSpan,
        reportEvent: reportEvent,
        startTime: startTime
    });
}
function $7f13dacc81ea33ad$export$4a8cbc644515d57b() {
    const performance = (0, $0bd0f3212099db27$export$f72a13c439a30cab)();
    if (!performance || !(0, $7Y1KN.browserPerformanceTimeOrigin)()) return;
    const onInp = ({ metric: metric })=>{
        if (metric.value == null) return;
        const duration = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(metric.value);
        if (duration > (0, $a30de91624a38c7a$export$619786413bcce1e1)) return;
        const entry = metric.entries.find((e)=>e.duration === metric.value && (0, $a30de91624a38c7a$export$7cd941f925ded42f)[e.name]);
        if (!entry) return;
        $7f13dacc81ea33ad$export$bd315e549441b68a(metric.value, entry);
    };
    (0, $e40b9efaa71f0411$export$da3b76aa2022cbd7)(onInp);
}
function $7f13dacc81ea33ad$export$bd315e549441b68a(inpValue, entry) {
    (0, $9yfTK.DEBUG_BUILD) && (0, $w8bd7.debug).log(`Sending INP span (${inpValue})`);
    const startTime = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)((0, $7Y1KN.browserPerformanceTimeOrigin)() + entry.startTime);
    const duration = (0, $0bd0f3212099db27$export$b4785dbd4a81b33f)(inpValue);
    const interactionType = (0, $a30de91624a38c7a$export$7cd941f925ded42f)[entry.name];
    const cachedContext = (0, $a30de91624a38c7a$export$e4a670d077ebcfef)(entry.interactionId);
    const activeSpan = (0, $d3a61c536a2d1d8c$export$1be426a8e585c83e)();
    const rootSpan = activeSpan ? (0, $d3a61c536a2d1d8c$export$c4c6a79b1260ca1b)(activeSpan) : void 0;
    const spanToUse = cachedContext?.span || rootSpan;
    const routeName = spanToUse ? (0, $d3a61c536a2d1d8c$export$db0cad9e44f67af8)(spanToUse).name : (0, $9f9f083568f3177b$export$c7be4b0125a10cba)().getScopeData().transactionName;
    const name = cachedContext?.elementName || (0, $1rNqq.htmlTreeAsString)(entry.target);
    $7f13dacc81ea33ad$export$f4adb23e57c1dac6({
        name: name,
        op: `ui.interaction.${interactionType}`,
        origin: "auto.http.browser.inp",
        metricName: "inp",
        value: inpValue,
        attributes: {
            [(0, $c30a0c8ed977cb48$export$fea48ba9f4550879)]: entry.duration,
            // oxlint-disable-next-line typescript-eslint/no-deprecated
            [(0, $5Qfaf.SENTRY_TRANSACTION)]: routeName,
            [(0, $5Qfaf.SENTRY_SEGMENT_NAME)]: routeName
        },
        startTime: startTime,
        endTime: startTime + duration,
        parentSpan: spanToUse
    });
}


const $4f3a3d9dedad9829$export$8748555bacc7091c = "WebVitals";
const $4f3a3d9dedad9829$export$1ab4995602e8adaa = (0, $gaxBK.defineIntegration)((options = {})=>{
    const ignored = new Set(options.ignore ?? []);
    return {
        name: $4f3a3d9dedad9829$export$8748555bacc7091c,
        setup (client) {
            const spanStreamingEnabled = (0, $gaxBK.hasSpanStreamingEnabled)(client);
            const { enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans } = options._experiments ?? {};
            const recordClsStandaloneSpans = spanStreamingEnabled || ignored.has("cls") ? void 0 : enableStandaloneClsSpans || false;
            const recordLcpStandaloneSpans = spanStreamingEnabled || ignored.has("lcp") ? void 0 : enableStandaloneLcpSpans || false;
            const finalizeWebVitals = (0, $0069c1a6632705ed$export$7c69f0412d101b88)({
                recordClsStandaloneSpans: recordClsStandaloneSpans,
                recordLcpStandaloneSpans: recordLcpStandaloneSpans,
                client: client
            });
            const pageloadSpans = /* @__PURE__ */ new WeakSet();
            client.on("afterStartPageLoadSpan", (span)=>{
                pageloadSpans.add(span);
            });
            client.on("spanEnd", (span)=>{
                if (!pageloadSpans.delete(span)) return;
                finalizeWebVitals();
                (0, $0069c1a6632705ed$export$d14e394b690acc17)(span, {
                    // CLS/LCP are recorded as pageload span measurements only when they're neither
                    // tracked as standalone spans nor handled by span streaming (and not ignored).
                    recordClsOnPageloadSpan: recordClsStandaloneSpans === false,
                    recordLcpOnPageloadSpan: recordLcpStandaloneSpans === false,
                    spanStreamingEnabled: spanStreamingEnabled
                });
            });
            if (spanStreamingEnabled) {
                if (!ignored.has("lcp")) (0, $7f13dacc81ea33ad$export$73747c030e2325c0)(client);
                if (!ignored.has("cls")) (0, $7f13dacc81ea33ad$export$f2ca9ed704743eb2)(client);
                if (!ignored.has("inp")) (0, $7f13dacc81ea33ad$export$4a8cbc644515d57b)();
            } else if (!ignored.has("inp")) (0, $a30de91624a38c7a$export$f17d06681a4744a3)();
        },
        afterAllSetup () {
            if (!ignored.has("inp")) (0, $a30de91624a38c7a$export$e4e04d43e223cce2)();
        }
    };
});



var $gaxBK = parcelRequire("gaxBK");

var $f67fK = parcelRequire("f67fK");

var $bHKc9 = parcelRequire("bHKc9");
function $3ff6a7b60227b43c$export$6f18f55521af71a1() {
    if ((0, $bHKc9.WINDOW).document) (0, $bHKc9.WINDOW).document.addEventListener("visibilitychange", ()=>{
        const activeSpan = (0, $gaxBK.getActiveSpan)();
        if (!activeSpan) return;
        const rootSpan = (0, $gaxBK.getRootSpan)(activeSpan);
        if ((0, $bHKc9.WINDOW).document.hidden && rootSpan) {
            const cancelledStatus = "cancelled";
            const { op: op, status: status } = (0, $gaxBK.spanToJSON)(rootSpan);
            if (0, $f67fK.DEBUG_BUILD) (0, $gaxBK.debug).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            if (!status) rootSpan.setStatus({
                code: (0, $gaxBK.SPAN_STATUS_ERROR),
                message: cancelledStatus
            });
            rootSpan.setAttribute("sentry.cancellation_reason", "document.hidden");
            rootSpan.end();
        }
    });
    else (0, $f67fK.DEBUG_BUILD) && (0, $gaxBK.debug).warn("[Tracing] Could not set up background tab detection due to lack of global document");
}



var $gaxBK = parcelRequire("gaxBK");

var $f67fK = parcelRequire("f67fK");

var $bHKc9 = parcelRequire("bHKc9");









const $9a79b1ae877f2696$export$c8d616af96ac729f = 3600;
const $9a79b1ae877f2696$export$16b6aa13b3c0f075 = "sentry_previous_trace";
const $9a79b1ae877f2696$export$237518aee8726f02 = "sentry.previous_trace";
function $9a79b1ae877f2696$export$830d9ee659c6e4c4(client, { linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling }) {
    const useSessionStorage = linkPreviousTrace === "session-storage";
    let inMemoryPreviousTraceInfo = useSessionStorage ? $9a79b1ae877f2696$export$ef546bba8a402d99() : void 0;
    client.on("spanStart", (span)=>{
        if ((0, $gaxBK.getRootSpan)(span) !== span) return;
        const oldPropagationContext = (0, $gaxBK.getCurrentScope)().getPropagationContext();
        inMemoryPreviousTraceInfo = $9a79b1ae877f2696$export$ae31cf84cbfc630e(inMemoryPreviousTraceInfo, span, oldPropagationContext);
        if (useSessionStorage) $9a79b1ae877f2696$export$e3dcc2666496dd96(inMemoryPreviousTraceInfo);
    });
    let isFirstTraceOnPageload = true;
    if (consistentTraceSampling) client.on("beforeSampling", (mutableSamplingContextData)=>{
        if (!inMemoryPreviousTraceInfo) return;
        const scope = (0, $gaxBK.getCurrentScope)();
        const currentPropagationContext = scope.getPropagationContext();
        if (isFirstTraceOnPageload && currentPropagationContext.parentSpanId) {
            isFirstTraceOnPageload = false;
            return;
        }
        scope.setPropagationContext({
            ...currentPropagationContext,
            dsc: {
                ...currentPropagationContext.dsc,
                sample_rate: String(inMemoryPreviousTraceInfo.sampleRate),
                sampled: String($9a79b1ae877f2696$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext))
            },
            sampleRand: inMemoryPreviousTraceInfo.sampleRand
        });
        mutableSamplingContextData.parentSampled = $9a79b1ae877f2696$export$f394c5f143a7b597(inMemoryPreviousTraceInfo.spanContext);
        mutableSamplingContextData.parentSampleRate = inMemoryPreviousTraceInfo.sampleRate;
        mutableSamplingContextData.spanAttributes = {
            ...mutableSamplingContextData.spanAttributes,
            [(0, $gaxBK.SEMANTIC_ATTRIBUTE_SENTRY_PREVIOUS_TRACE_SAMPLE_RATE)]: inMemoryPreviousTraceInfo.sampleRate
        };
    });
}
function $9a79b1ae877f2696$export$ae31cf84cbfc630e(previousTraceInfo, span, oldPropagationContext) {
    const spanJson = (0, $gaxBK.spanToJSON)(span);
    function getSampleRate() {
        try {
            const oldSampleRate = Number(spanJson.data?.[0, $gaxBK.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ?? oldPropagationContext.dsc?.sample_rate);
            return Number.isNaN(oldSampleRate) ? 0 : oldSampleRate;
        } catch  {
            return 0;
        }
    }
    const updatedPreviousTraceInfo = {
        spanContext: span.spanContext(),
        startTimestamp: spanJson.start_timestamp,
        sampleRate: getSampleRate(),
        sampleRand: oldPropagationContext.sampleRand
    };
    if (!previousTraceInfo) return updatedPreviousTraceInfo;
    const previousTraceSpanCtx = previousTraceInfo.spanContext;
    if (previousTraceSpanCtx.traceId === spanJson.trace_id) return previousTraceInfo;
    if (Date.now() / 1e3 - previousTraceInfo.startTimestamp <= $9a79b1ae877f2696$export$c8d616af96ac729f) {
        if (0, $f67fK.DEBUG_BUILD) (0, $gaxBK.debug).log(`Adding previous_trace \`${JSON.stringify(previousTraceSpanCtx)}\` link to span \`${JSON.stringify({
            op: spanJson.op,
            ...span.spanContext()
        })}\``);
        span.addLink({
            context: previousTraceSpanCtx,
            attributes: {
                [(0, $gaxBK.SEMANTIC_LINK_ATTRIBUTE_LINK_TYPE)]: "previous_trace"
            }
        });
        span.setAttribute($9a79b1ae877f2696$export$237518aee8726f02, `${previousTraceSpanCtx.traceId}-${previousTraceSpanCtx.spanId}-${$9a79b1ae877f2696$export$f394c5f143a7b597(previousTraceSpanCtx) ? 1 : 0}`);
    }
    return updatedPreviousTraceInfo;
}
function $9a79b1ae877f2696$export$e3dcc2666496dd96(previousTraceInfo) {
    try {
        (0, $bHKc9.WINDOW).sessionStorage.setItem($9a79b1ae877f2696$export$16b6aa13b3c0f075, JSON.stringify(previousTraceInfo));
    } catch (e) {
        (0, $f67fK.DEBUG_BUILD) && (0, $gaxBK.debug).warn("Could not store previous trace in sessionStorage", e);
    }
}
function $9a79b1ae877f2696$export$ef546bba8a402d99() {
    try {
        const previousTraceInfo = (0, $bHKc9.WINDOW).sessionStorage?.getItem($9a79b1ae877f2696$export$16b6aa13b3c0f075);
        return JSON.parse(previousTraceInfo);
    } catch  {
        return void 0;
    }
}
function $9a79b1ae877f2696$export$f394c5f143a7b597(ctx) {
    return ctx.traceFlags === 1;
}



var $gaxBK = parcelRequire("gaxBK");

var $7HchG = parcelRequire("7HchG");
var $w8bd7 = parcelRequire("w8bd7");

var $9yfTK = parcelRequire("9yfTK");
const $49f3defd27f25702$export$363d064b9116000e = /* @__PURE__ */ Symbol.for("sentry__originalRequestBody");
function $49f3defd27f25702$export$2f1b0f57f243f270(formData) {
    return new URLSearchParams(formData).toString();
}
function $49f3defd27f25702$export$945a2d5364608d5(body, _debug = (0, $w8bd7.debug)) {
    try {
        if (typeof body === "string") return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $49f3defd27f25702$export$2f1b0f57f243f270(body)
        ];
        if (!body) return [
            void 0
        ];
    } catch (error) {
        (0, $9yfTK.DEBUG_BUILD) && _debug.error(error, "Failed to serialize body", body);
        return [
            void 0,
            "BODY_PARSE_ERROR"
        ];
    }
    (0, $9yfTK.DEBUG_BUILD) && _debug.log("Skipping network body because of body type", body);
    return [
        void 0,
        "UNPARSEABLE_BODY_TYPE"
    ];
}
function $49f3defd27f25702$export$ad44edf8012ec314(fetchArgs = []) {
    if (fetchArgs.length >= 2 && fetchArgs[1] && typeof fetchArgs[1] === "object" && "body" in fetchArgs[1]) return fetchArgs[1].body;
    if (fetchArgs.length >= 1 && fetchArgs[0] instanceof Request) {
        const request = fetchArgs[0];
        const originalBody = request[$49f3defd27f25702$export$363d064b9116000e];
        if (originalBody !== void 0) return originalBody;
        return void 0;
    }
    return void 0;
}
function $49f3defd27f25702$export$ce71c337afb62ea(xhr) {
    let headers;
    try {
        headers = xhr.getAllResponseHeaders();
    } catch (error) {
        (0, $9yfTK.DEBUG_BUILD) && (0, $w8bd7.debug).error(error, "Failed to get xhr response headers", xhr);
        return {};
    }
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (value) acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}



var $bHKc9 = parcelRequire("bHKc9");
function $1bd7c09a78118afb$export$8193ac587e359dc0(baggageHeader) {
    return baggageHeader.split(",").some((value)=>value.trim().startsWith("sentry-"));
}
function $1bd7c09a78118afb$export$f2a087db7564c909(url) {
    try {
        const parsed = new URL(url, (0, $bHKc9.WINDOW).location.origin);
        return parsed.href;
    } catch  {
        return void 0;
    }
}
function $1bd7c09a78118afb$export$5803eedf1027ce61(entry) {
    return entry.entryType === "resource" && "initiatorType" in entry && typeof entry.nextHopProtocol === "string" && (entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest");
}
function $1bd7c09a78118afb$export$9dc5b8b2fb320da0(headers) {
    try {
        return new Headers(headers);
    } catch  {
        return void 0;
    }
}


const $1d934d71ce654618$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true,
    trackFetchStreamPerformance: false
};
function $1d934d71ce654618$export$864489cb3478db3e(client, _options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$1d934d71ce654618$export$cc17fb3c0bc95cd7,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === "function" ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$1d934d71ce654618$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    const propagateTraceparent = client.getOptions().propagateTraceparent;
    if (traceFetch) (0, $gaxBK.addFetchInstrumentationHandler)((handlerData)=>{
        const createdSpan = (0, $gaxBK.instrumentFetchRequest)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, {
            propagateTraceparent: propagateTraceparent,
            onRequestSpanEnd: onRequestSpanEnd
        });
        if (createdSpan) {
            const fullUrl = (0, $1bd7c09a78118afb$export$f2a087db7564c909)(handlerData.fetchData.url);
            const host = fullUrl ? (0, $gaxBK.parseUrl)(fullUrl).host : void 0;
            const sanitizedFullUrl = fullUrl ? (0, $gaxBK.stripDataUrlContent)(fullUrl) : void 0;
            createdSpan.setAttributes({
                "http.url": sanitizedFullUrl,
                // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
                // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
                "url.full": sanitizedFullUrl,
                "server.address": host
            });
            if (enableHTTPTimings) $1d934d71ce654618$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart?.(createdSpan, {
                headers: handlerData.headers
            });
        }
    });
    if (traceXHR) (0, $7HchG.addXhrInstrumentationHandler)((handlerData)=>{
        const createdSpan = $1d934d71ce654618$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans, propagateTraceparent, onRequestSpanEnd);
        if (createdSpan) {
            if (enableHTTPTimings) $1d934d71ce654618$var$addHTTPTimings(createdSpan, client);
            onRequestSpanStart?.(createdSpan, {
                headers: (0, $1bd7c09a78118afb$export$9dc5b8b2fb320da0)(handlerData.xhr.__sentry_xhr_v3__?.request_headers)
            });
        }
    });
}
const $1d934d71ce654618$var$HTTP_TIMING_WAIT_MS = 300;
function $1d934d71ce654618$var$addHTTPTimings(span, client) {
    const { url: url } = (0, $gaxBK.spanToJSON)(span).data;
    if (!url || typeof url !== "string") return;
    let onEntryFound = ()=>void setTimeout(unsubscribePerformanceObsever);
    if ((0, $gaxBK.hasSpanStreamingEnabled)(client)) {
        const originalEnd = span.end.bind(span);
        span.end = (endTimestamp)=>{
            const capturedEndTimestamp = endTimestamp ?? (0, $gaxBK.timestampInSeconds)();
            let isEnded = false;
            const endSpanAndCleanup = ()=>{
                if (isEnded) return;
                isEnded = true;
                setTimeout(unsubscribePerformanceObsever);
                originalEnd(capturedEndTimestamp);
                clearTimeout(fallbackTimeout);
            };
            onEntryFound = endSpanAndCleanup;
            const fallbackTimeout = setTimeout(endSpanAndCleanup, $1d934d71ce654618$var$HTTP_TIMING_WAIT_MS);
        };
    }
    const unsubscribePerformanceObsever = (0, $e40b9efaa71f0411$export$69816c1a049f8db6)("resource", ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ((0, $1bd7c09a78118afb$export$5803eedf1027ce61)(entry) && entry.name.endsWith(url)) {
                span.setAttributes((0, $0c308a4211d266ec$export$ec50b091612e7e00)(entry));
                onEntryFound();
            }
        });
    });
}
function $1d934d71ce654618$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    const href = (0, $gaxBK.getLocationHref)();
    if (!href) {
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $gaxBK.stringMatchesSomePattern)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch  {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $gaxBK.stringMatchesSomePattern)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $gaxBK.stringMatchesSomePattern)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
function $1d934d71ce654618$var$xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeaders2, spans, propagateTraceparent, onRequestSpanEnd) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr?.[0, $7HchG.SENTRY_XHR_DATA_KEY];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return void 0;
    const { url: url, method: method } = sentryXhrData;
    const shouldCreateSpanResult = (0, $gaxBK.hasSpansEnabled)() && shouldCreateSpan(url);
    if (handlerData.endTimestamp) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span2 = spans[spanId];
        if (span2) {
            if (shouldCreateSpanResult && sentryXhrData.status_code !== void 0) {
                (0, $gaxBK.setHttpStatus)(span2, sentryXhrData.status_code);
                span2.end();
                onRequestSpanEnd?.(span2, {
                    headers: (0, $1bd7c09a78118afb$export$9dc5b8b2fb320da0)((0, $49f3defd27f25702$export$ce71c337afb62ea)(xhr)),
                    error: handlerData.error
                });
            }
            delete spans[spanId];
        }
        return void 0;
    }
    const fullUrl = (0, $1bd7c09a78118afb$export$f2a087db7564c909)(url);
    const parsedUrl = fullUrl ? (0, $gaxBK.parseUrl)(fullUrl) : (0, $gaxBK.parseUrl)(url);
    const sanitizedFullUrl = fullUrl ? (0, $gaxBK.stripDataUrlContent)(fullUrl) : void 0;
    const urlForSpanName = (0, $gaxBK.stripDataUrlContent)((0, $gaxBK.stripUrlQueryAndFragment)(url));
    const client = (0, $gaxBK.getClient)();
    const hasParent = !!(0, $gaxBK.getActiveSpan)();
    const shouldEmitSpan = hasParent || !!client && (0, $gaxBK.hasSpanStreamingEnabled)(client);
    const span = shouldCreateSpanResult && shouldEmitSpan ? (0, $gaxBK.startInactiveSpan)({
        name: `${method} ${urlForSpanName}`,
        attributes: {
            url: (0, $gaxBK.stripDataUrlContent)(url),
            type: "xhr",
            "http.method": method,
            "http.url": sanitizedFullUrl,
            // `url.full` must match `http.url`. Setting it here ensures parentless `http.client`
            // segment spans don't get `url.full` backfilled with the host page URL (see httpContextIntegration).
            "url.full": sanitizedFullUrl,
            "server.address": parsedUrl?.host,
            [(0, $gaxBK.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.http.browser",
            [(0, $gaxBK.SEMANTIC_ATTRIBUTE_SENTRY_OP)]: "http.client",
            ...parsedUrl?.search && {
                "http.query": parsedUrl?.search
            },
            ...parsedUrl?.hash && {
                "http.fragment": parsedUrl?.hash
            }
        }
    }) : new (0, $gaxBK.SentryNonRecordingSpan)();
    const spanForTraceHeaders = (0, $gaxBK.spanIsIgnored)(span) && hasParent ? void 0 : span;
    if (shouldCreateSpanResult && !shouldEmitSpan) client?.recordDroppedEvent("no_parent_span", "span");
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    if (shouldAttachHeaders2(url)) $1d934d71ce654618$var$addTracingHeadersToXhrRequest(xhr, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $gaxBK.hasSpansEnabled)() && shouldEmitSpan ? spanForTraceHeaders : void 0, propagateTraceparent);
    if (client) client.emit("beforeOutgoingRequestSpan", span, handlerData);
    return span;
}
function $1d934d71ce654618$var$addTracingHeadersToXhrRequest(xhr, span, propagateTraceparent) {
    const { "sentry-trace": sentryTrace, baggage: baggage, traceparent: traceparent } = (0, $gaxBK.getTraceData)({
        span: span,
        propagateTraceparent: propagateTraceparent
    });
    if (sentryTrace) $1d934d71ce654618$var$setHeaderOnXhr(xhr, sentryTrace, baggage, traceparent);
}
function $1d934d71ce654618$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader, traceparentHeader) {
    const originalHeaders = xhr.__sentry_xhr_v3__?.request_headers;
    if (originalHeaders?.["sentry-trace"] || !xhr.setRequestHeader) return;
    try {
        xhr.setRequestHeader("sentry-trace", sentryTraceHeader);
        if (traceparentHeader && !originalHeaders?.["traceparent"]) xhr.setRequestHeader("traceparent", traceparentHeader);
        if (sentryBaggageHeader) {
            const originalBaggageHeader = originalHeaders?.["baggage"];
            if (!originalBaggageHeader || !(0, $1bd7c09a78118afb$export$8193ac587e359dc0)(originalBaggageHeader)) xhr.setRequestHeader("baggage", sentryBaggageHeader);
        }
    } catch  {}
}



var $5Qfaf = parcelRequire("5Qfaf");
const $716ac108ec783b6b$export$bbd2089f30bd3708 = "BrowserTracing";
const $716ac108ec783b6b$var$BOT_USER_AGENT_RE = /Googlebot|Google-InspectionTool|Storebot-Google|Bingbot|Slurp|DuckDuckBot|Baiduspider|YandexBot|Facebot|facebookexternalhit|LinkedInBot|Twitterbot|Applebot/i;
function $716ac108ec783b6b$export$e189d11d152c4191() {
    const nav = (0, $bHKc9.WINDOW).navigator;
    if (!nav?.userAgent) return false;
    return $716ac108ec783b6b$var$BOT_USER_AGENT_RE.test(nav.userAgent);
}
const $716ac108ec783b6b$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $gaxBK.TRACING_DEFAULTS),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableLongAnimationFrame: true,
    enableInp: true,
    ignoreResourceSpans: [],
    ignorePerformanceApiSpans: [],
    detectRedirects: true,
    linkPreviousTrace: "in-memory",
    consistentTraceSampling: false,
    enableReportPageLoaded: false,
    _experiments: {},
    ...(0, $1d934d71ce654618$export$cc17fb3c0bc95cd7)
};
const $716ac108ec783b6b$export$b4109253475213e9 = (options = {})=>{
    if ("enableElementTiming" in options) (0, $gaxBK.consoleSandbox)(()=>{
        console.warn("[Sentry] `enableElementTiming` is deprecated and no longer has any effect. Use the standalone `elementTimingIntegration` instead.");
    });
    const latestRoute = {
        name: void 0,
        source: void 0
    };
    const optionalWindowDocument = (0, $bHKc9.WINDOW).document;
    const { enableInp: enableInp, enableLongTask: enableLongTask, enableLongAnimationFrame: enableLongAnimationFrame, _experiments: { enableInteractions: enableInteractions, enableStandaloneClsSpans: enableStandaloneClsSpans, enableStandaloneLcpSpans: enableStandaloneLcpSpans }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, trackFetchStreamPerformance: // eslint-disable-next-line typescript/no-deprecated
    trackFetchStreamPerformance, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, ignoreResourceSpans: ignoreResourceSpans, ignorePerformanceApiSpans: ignorePerformanceApiSpans, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation, detectRedirects: detectRedirects, linkPreviousTrace: linkPreviousTrace, consistentTraceSampling: consistentTraceSampling, enableReportPageLoaded: enableReportPageLoaded, onRequestSpanStart: onRequestSpanStart, onRequestSpanEnd: onRequestSpanEnd } = {
        ...$716ac108ec783b6b$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ...options
    };
    const _isBot = $716ac108ec783b6b$export$e189d11d152c4191();
    let lastInteractionTimestamp;
    let _pageloadSpan;
    function _createRouteSpan(client, startSpanOptions, makeActive = true, url) {
        const isPageloadSpan = startSpanOptions.op === "pageload";
        const initialSpanName = startSpanOptions.name;
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const urlObject = (0, $gaxBK.parseStringToURLObject)(url || (0, $gaxBK.getLocationHref)());
        const attributes = {
            ...urlObject?.pathname && {
                [(0, $5Qfaf.URL_PATH)]: urlObject.pathname
            },
            ...urlObject && !(0, $gaxBK.isURLObjectRelative)(urlObject) && {
                [(0, $5Qfaf.URL_FULL)]: urlObject.href
            },
            ...finalStartSpanOptions.attributes
        };
        if (initialSpanName !== finalStartSpanOptions.name) attributes[0, $gaxBK.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] = "custom";
        finalStartSpanOptions.attributes = attributes;
        if (!makeActive) {
            const now = (0, $gaxBK.dateTimestampInSeconds)();
            (0, $gaxBK.startInactiveSpan)({
                ...finalStartSpanOptions,
                startTime: now
            }).end(now);
            return;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $gaxBK.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
        const idleSpan = (0, $gaxBK.startIdleSpan)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadSpan,
            beforeSpanEnd: (span)=>{
                (0, $0069c1a6632705ed$export$5f8fa6b3467a7443)(span, {
                    ignoreResourceSpans: ignoreResourceSpans,
                    ignorePerformanceApiSpans: ignorePerformanceApiSpans,
                    spanStreamingEnabled: (0, $gaxBK.hasSpanStreamingEnabled)(client)
                });
                $716ac108ec783b6b$var$setActiveIdleSpan(client, void 0);
                const scope = (0, $gaxBK.getCurrentScope)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    traceId: idleSpan.spanContext().traceId,
                    sampled: (0, $gaxBK.spanIsSampled)(idleSpan),
                    dsc: (0, $gaxBK.getDynamicSamplingContextFromSpan)(span)
                });
                if (isPageloadSpan) _pageloadSpan = void 0;
            },
            trimIdleSpanEndTimestamp: !enableReportPageLoaded
        });
        if (isPageloadSpan && enableReportPageLoaded) _pageloadSpan = idleSpan;
        $716ac108ec783b6b$var$setActiveIdleSpan(client, idleSpan);
        function emitFinish() {
            if (optionalWindowDocument && [
                "interactive",
                "complete"
            ].includes(optionalWindowDocument.readyState)) {
                client.emit("idleSpanEnableAutoFinish", idleSpan);
                optionalWindowDocument.removeEventListener("readystatechange", emitFinish);
            }
        }
        if (isPageloadSpan && !enableReportPageLoaded && optionalWindowDocument) {
            optionalWindowDocument.addEventListener("readystatechange", emitFinish);
            emitFinish();
        }
    }
    return {
        name: $716ac108ec783b6b$export$bbd2089f30bd3708,
        setup (client) {
            if (_isBot) {
                (0, $f67fK.DEBUG_BUILD) && (0, $gaxBK.debug).log("[Tracing] Skipping browserTracingIntegration setup for bot user agent.");
                return;
            }
            (0, $gaxBK.registerSpanErrorInstrumentation)();
            if (enableLongAnimationFrame && (0, $gaxBK.GLOBAL_OBJ).PerformanceObserver && PerformanceObserver.supportedEntryTypes?.includes("long-animation-frame")) (0, $0069c1a6632705ed$export$5b823ab2ccbc801d)();
            else if (enableLongTask) (0, $0069c1a6632705ed$export$f396d19077034ad2)();
            if (enableInteractions) (0, $0069c1a6632705ed$export$e27543e0976315e4)();
            if (detectRedirects && optionalWindowDocument) {
                const interactionHandler = ()=>{
                    lastInteractionTimestamp = (0, $gaxBK.timestampInSeconds)();
                };
                addEventListener("click", interactionHandler, {
                    capture: true
                });
                addEventListener("keydown", interactionHandler, {
                    capture: true,
                    passive: true
                });
            }
            function maybeEndActiveSpan() {
                const activeSpan = $716ac108ec783b6b$var$getActiveIdleSpan(client);
                if (activeSpan && !(0, $gaxBK.spanToJSON)(activeSpan).timestamp) {
                    (0, $f67fK.DEBUG_BUILD) && (0, $gaxBK.debug).log(`[Tracing] Finishing current active span with op: ${(0, $gaxBK.spanToJSON)(activeSpan).op}`);
                    activeSpan.setAttribute((0, $gaxBK.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "cancelled");
                    activeSpan.end();
                }
            }
            client.on("startNavigationSpan", (startSpanOptions, navigationOptions)=>{
                if ((0, $gaxBK.getClient)() !== client) return;
                if (navigationOptions?.isRedirect) {
                    (0, $f67fK.DEBUG_BUILD) && (0, $gaxBK.debug).warn("[Tracing] Detected redirect, navigation span will not be the root span, but a child span.");
                    _createRouteSpan(client, {
                        op: "navigation.redirect",
                        ...startSpanOptions
                    }, false, navigationOptions.url);
                    return;
                }
                lastInteractionTimestamp = void 0;
                maybeEndActiveSpan();
                (0, $gaxBK.getIsolationScope)().setPropagationContext({
                    traceId: (0, $gaxBK.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $gaxBK.hasSpansEnabled)() ? void 0 : (0, $gaxBK.generateSpanId)()
                });
                const scope = (0, $gaxBK.getCurrentScope)();
                scope.setPropagationContext({
                    traceId: (0, $gaxBK.generateTraceId)(),
                    sampleRand: Math.random(),
                    propagationSpanId: (0, $gaxBK.hasSpansEnabled)() ? void 0 : (0, $gaxBK.generateSpanId)()
                });
                scope.setSDKProcessingMetadata({
                    normalizedRequest: void 0
                });
                _createRouteSpan(client, {
                    op: "navigation",
                    ...startSpanOptions,
                    // Navigation starts a new trace and is NOT parented under any active interaction (e.g. ui.action.click)
                    parentSpan: null,
                    forceTransaction: true
                }, true, navigationOptions?.url);
            });
            client.on("startPageLoadSpan", (startSpanOptions, traceOptions = {})=>{
                if ((0, $gaxBK.getClient)() !== client) return;
                maybeEndActiveSpan();
                const sentryTrace = traceOptions.sentryTrace || $716ac108ec783b6b$export$f147b32b03c9cf11("sentry-trace") || $716ac108ec783b6b$export$5bb9693b37f7c2ae("sentry-trace");
                const baggage = traceOptions.baggage || $716ac108ec783b6b$export$f147b32b03c9cf11("baggage") || $716ac108ec783b6b$export$5bb9693b37f7c2ae("baggage");
                const propagationContext = (0, $gaxBK.propagationContextFromHeaders)(sentryTrace, baggage);
                const scope = (0, $gaxBK.getCurrentScope)();
                scope.setPropagationContext(propagationContext);
                if (!(0, $gaxBK.hasSpansEnabled)()) scope.getPropagationContext().propagationSpanId = (0, $gaxBK.generateSpanId)();
                scope.setSDKProcessingMetadata({
                    normalizedRequest: (0, $bHKc9.getHttpRequestData)()
                });
                _createRouteSpan(client, {
                    op: "pageload",
                    ...startSpanOptions
                });
            });
            client.on("endPageloadSpan", ()=>{
                if (enableReportPageLoaded && _pageloadSpan) {
                    _pageloadSpan.setAttribute((0, $gaxBK.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "reportPageLoaded");
                    _pageloadSpan.end();
                }
            });
        },
        afterAllSetup (client) {
            if (_isBot) return;
            if (client.addIntegration && !client.getIntegrationByName?.((0, $4f3a3d9dedad9829$export$8748555bacc7091c))) client.addIntegration((0, $4f3a3d9dedad9829$export$1ab4995602e8adaa)({
                ignore: enableInp ? [] : [
                    "inp"
                ],
                _experiments: {
                    enableStandaloneClsSpans: enableStandaloneClsSpans,
                    enableStandaloneLcpSpans: enableStandaloneLcpSpans
                }
            }));
            let startingUrl = (0, $gaxBK.getLocationHref)();
            if (linkPreviousTrace !== "off") (0, $9a79b1ae877f2696$export$830d9ee659c6e4c4)(client, {
                linkPreviousTrace: linkPreviousTrace,
                consistentTraceSampling: consistentTraceSampling
            });
            if ((0, $bHKc9.WINDOW).location) {
                if (instrumentPageLoad) {
                    const origin = (0, $gaxBK.browserPerformanceTimeOrigin)();
                    $716ac108ec783b6b$export$aa44a07f82af519f(client, {
                        name: (0, $bHKc9.WINDOW).location.pathname,
                        // pageload should always start at timeOrigin (and needs to be in s, not ms)
                        startTime: origin ? origin / 1e3 : void 0,
                        attributes: {
                            [(0, $gaxBK.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                            [(0, $gaxBK.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.pageload.browser"
                        }
                    });
                }
                if (instrumentNavigation) (0, $e3Llk.addHistoryInstrumentationHandler)(({ to: to, from: from })=>{
                    if (from === void 0 && startingUrl?.indexOf(to) !== -1) {
                        startingUrl = void 0;
                        return;
                    }
                    startingUrl = void 0;
                    const parsed = (0, $gaxBK.parseStringToURLObject)(to);
                    const activeSpan = $716ac108ec783b6b$var$getActiveIdleSpan(client);
                    const navigationIsRedirect = activeSpan && detectRedirects && $716ac108ec783b6b$var$isRedirect(activeSpan, lastInteractionTimestamp);
                    $716ac108ec783b6b$export$7d159749bd9969ad(client, {
                        name: parsed?.pathname || (0, $bHKc9.WINDOW).location.pathname,
                        attributes: {
                            [(0, $gaxBK.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: "url",
                            [(0, $gaxBK.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN)]: "auto.navigation.browser"
                        }
                    }, {
                        url: to,
                        isRedirect: navigationIsRedirect
                    });
                });
            }
            if (markBackgroundSpan) (0, $3ff6a7b60227b43c$export$6f18f55521af71a1)();
            if (enableInteractions) $716ac108ec783b6b$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            (0, $1d934d71ce654618$export$864489cb3478db3e)(client, {
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings,
                onRequestSpanStart: onRequestSpanStart,
                onRequestSpanEnd: onRequestSpanEnd
            });
            if (trackFetchStreamPerformance) client.addIntegration((0, $42bebb1373a50467$export$b49e0d1a48dc8754)());
        }
    };
};
function $716ac108ec783b6b$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit("startPageLoadSpan", spanOptions, traceOptions);
    (0, $gaxBK.getCurrentScope)().setTransactionName(spanOptions.name);
    const pageloadSpan = $716ac108ec783b6b$var$getActiveIdleSpan(client);
    if (pageloadSpan) client.emit("afterStartPageLoadSpan", pageloadSpan);
    return pageloadSpan;
}
function $716ac108ec783b6b$export$7d159749bd9969ad(client, spanOptions, options) {
    const { url: url, isRedirect: isRedirect2 } = options || {};
    client.emit("beforeStartNavigationSpan", spanOptions, {
        isRedirect: isRedirect2,
        url: url
    });
    client.emit("startNavigationSpan", spanOptions, {
        isRedirect: isRedirect2,
        url: url
    });
    const scope = (0, $gaxBK.getCurrentScope)();
    scope.setTransactionName(spanOptions.name);
    if (url && !isRedirect2) scope.setSDKProcessingMetadata({
        normalizedRequest: {
            ...(0, $bHKc9.getHttpRequestData)(),
            url: url
        }
    });
    return $716ac108ec783b6b$var$getActiveIdleSpan(client);
}
function $716ac108ec783b6b$export$f147b32b03c9cf11(metaName) {
    const optionalWindowDocument = (0, $bHKc9.WINDOW).document;
    const metaTag = optionalWindowDocument?.querySelector(`meta[name=${metaName}]`);
    return metaTag?.getAttribute("content") || void 0;
}
function $716ac108ec783b6b$export$5bb9693b37f7c2ae(name) {
    const navigation = (0, $bHKc9.WINDOW).performance?.getEntriesByType?.("navigation")[0];
    const entry = navigation?.serverTiming?.find((entry2)=>entry2.name === name);
    return entry?.description;
}
function $716ac108ec783b6b$var$registerInteractionListener(client, idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    const optionalWindowDocument = (0, $bHKc9.WINDOW).document;
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = "ui.action.click";
        const activeIdleSpan = $716ac108ec783b6b$var$getActiveIdleSpan(client);
        if (activeIdleSpan) {
            const currentRootSpanOp = (0, $gaxBK.spanToJSON)(activeIdleSpan).op;
            if ([
                "navigation",
                "pageload"
            ].includes(currentRootSpanOp)) {
                (0, $f67fK.DEBUG_BUILD) && (0, $gaxBK.debug).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return void 0;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $gaxBK.SEMANTIC_ATTRIBUTE_SENTRY_IDLE_SPAN_FINISH_REASON), "interactionInterrupted");
            inflightInteractionSpan.end();
            inflightInteractionSpan = void 0;
        }
        if (!latestRoute.name) {
            (0, $f67fK.DEBUG_BUILD) && (0, $gaxBK.debug).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return void 0;
        }
        inflightInteractionSpan = (0, $gaxBK.startIdleSpan)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $gaxBK.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE)]: latestRoute.source || "url"
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if (optionalWindowDocument) addEventListener("click", registerInteractionTransaction, {
        capture: true
    });
}
const $716ac108ec783b6b$var$ACTIVE_IDLE_SPAN_PROPERTY = "_sentry_idleSpan";
function $716ac108ec783b6b$var$getActiveIdleSpan(client) {
    return client[$716ac108ec783b6b$var$ACTIVE_IDLE_SPAN_PROPERTY];
}
function $716ac108ec783b6b$var$setActiveIdleSpan(client, span) {
    (0, $gaxBK.addNonEnumerableProperty)(client, $716ac108ec783b6b$var$ACTIVE_IDLE_SPAN_PROPERTY, span);
}
const $716ac108ec783b6b$var$REDIRECT_THRESHOLD = 1.5;
function $716ac108ec783b6b$var$isRedirect(activeSpan, lastInteractionTimestamp) {
    const spanData = (0, $gaxBK.spanToJSON)(activeSpan);
    const now = (0, $gaxBK.dateTimestampInSeconds)();
    const startTimestamp = spanData.start_timestamp;
    if (now - startTimestamp > $716ac108ec783b6b$var$REDIRECT_THRESHOLD) return false;
    if (lastInteractionTimestamp && now - lastInteractionTimestamp <= $716ac108ec783b6b$var$REDIRECT_THRESHOLD) return false;
    return true;
}


var $gaxBK = parcelRequire("gaxBK");
var $gaxBK = parcelRequire("gaxBK");

var $7HchG = parcelRequire("7HchG");

var $f67fK = parcelRequire("f67fK");
const $7fa23103a286c875$var$INTEGRATION_NAME = "HttpClient";
const $7fa23103a286c875$var$_httpClientIntegration = (options = {})=>{
    const _options = {
        failedRequestStatusCodes: [
            [
                500,
                599
            ]
        ],
        failedRequestTargets: [
            /.*/
        ],
        ...options
    };
    return {
        name: $7fa23103a286c875$var$INTEGRATION_NAME,
        setup (client) {
            $7fa23103a286c875$var$_wrapFetch(client, _options);
            $7fa23103a286c875$var$_wrapXHR(client, _options);
        }
    };
};
const $7fa23103a286c875$export$8a3b7aeb379b3907 = (0, $gaxBK.defineIntegration)($7fa23103a286c875$var$_httpClientIntegration);
function $7fa23103a286c875$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error) {
    if ($7fa23103a286c875$var$_shouldCaptureResponse(options, response.status, response.url)) {
        const request = $7fa23103a286c875$var$_getRequest(requestInfo, requestInit);
        let requestHeaders, responseHeaders, requestCookies, responseCookies;
        const dc = $7fa23103a286c875$var$_getDataCollectionSettings();
        if (dc.requestHeaders !== false) requestHeaders = (0, $gaxBK._INTERNAL_filterKeyValueData)($7fa23103a286c875$var$_extractFetchHeaders(request.headers), dc.requestHeaders);
        if (dc.responseHeaders !== false) responseHeaders = (0, $gaxBK._INTERNAL_filterKeyValueData)($7fa23103a286c875$var$_extractFetchHeaders(response.headers), dc.responseHeaders);
        if (dc.cookies !== false) {
            const reqCookieStr = request.headers.get("Cookie") || void 0;
            if (reqCookieStr) {
                const filtered = (0, $gaxBK._INTERNAL_filterCookies)(reqCookieStr, dc.cookies);
                if (typeof filtered === "object") requestCookies = filtered;
            }
            const resCookieStr = response.headers.get("Set-Cookie") || void 0;
            if (resCookieStr) {
                const filtered = (0, $gaxBK._INTERNAL_filterCookies)(resCookieStr, dc.cookies);
                if (typeof filtered === "object") responseCookies = filtered;
            }
        }
        const event = $7fa23103a286c875$var$_createEvent({
            url: request.url,
            method: request.method,
            status: response.status,
            requestHeaders: requestHeaders,
            responseHeaders: responseHeaders,
            requestCookies: requestCookies,
            responseCookies: responseCookies,
            error: error,
            type: "fetch"
        });
        (0, $gaxBK.captureEvent)(event);
    }
}
function $7fa23103a286c875$var$_xhrResponseHandler(options, xhr, method, headers, error) {
    if ($7fa23103a286c875$var$_shouldCaptureResponse(options, xhr.status, xhr.responseURL)) {
        let requestHeaders, responseCookies, responseHeaders;
        const dc = $7fa23103a286c875$var$_getDataCollectionSettings();
        if (dc.cookies !== false) try {
            const cookieString = xhr.getResponseHeader("Set-Cookie") || xhr.getResponseHeader("set-cookie") || void 0;
            if (cookieString) {
                const filtered = (0, $gaxBK._INTERNAL_filterCookies)(cookieString, dc.cookies);
                if (typeof filtered === "object") responseCookies = filtered;
            }
        } catch  {}
        if (dc.responseHeaders !== false) try {
            responseHeaders = (0, $gaxBK._INTERNAL_filterKeyValueData)($7fa23103a286c875$var$_getXHRResponseHeaders(xhr), dc.responseHeaders);
        } catch  {}
        if (dc.requestHeaders !== false) requestHeaders = (0, $gaxBK._INTERNAL_filterKeyValueData)(headers, dc.requestHeaders);
        const event = $7fa23103a286c875$var$_createEvent({
            url: xhr.responseURL,
            method: method,
            status: xhr.status,
            requestHeaders: requestHeaders,
            responseHeaders: // Can't access request cookies from XHR
            responseHeaders,
            responseCookies: responseCookies,
            error: error,
            type: "xhr"
        });
        (0, $gaxBK.captureEvent)(event);
    }
}
function $7fa23103a286c875$var$_getResponseSizeFromHeaders(headers) {
    if (headers) {
        const contentLength = headers["Content-Length"] || headers["content-length"];
        if (contentLength) return parseInt(contentLength, 10);
    }
    return void 0;
}
function $7fa23103a286c875$var$_extractFetchHeaders(headers) {
    const result = {};
    headers.forEach((value, key)=>{
        result[key] = value;
    });
    return result;
}
function $7fa23103a286c875$var$_getXHRResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split("\r\n").reduce((acc, line)=>{
        const [key, value] = line.split(": ");
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
function $7fa23103a286c875$var$_isInGivenRequestTargets(failedRequestTargets, target) {
    return failedRequestTargets.some((givenRequestTarget)=>{
        if (typeof givenRequestTarget === "string") return target.includes(givenRequestTarget);
        return givenRequestTarget.test(target);
    });
}
function $7fa23103a286c875$var$_isInGivenStatusRanges(failedRequestStatusCodes, status) {
    return failedRequestStatusCodes.some((range)=>{
        if (typeof range === "number") return range === status;
        return status >= range[0] && status <= range[1];
    });
}
function $7fa23103a286c875$var$_wrapFetch(client, options) {
    if (!(0, $gaxBK.supportsNativeFetch)()) return;
    (0, $gaxBK.addFetchInstrumentationHandler)((handlerData)=>{
        if ((0, $gaxBK.getClient)() !== client) return;
        const { response: response, args: args, error: error, virtualError: virtualError } = handlerData;
        const [requestInfo, requestInit] = args;
        if (!response) return;
        $7fa23103a286c875$var$_fetchResponseHandler(options, requestInfo, response, requestInit, error || virtualError);
    }, false);
}
function $7fa23103a286c875$var$_wrapXHR(client, options) {
    if (!("XMLHttpRequest" in (0, $gaxBK.GLOBAL_OBJ))) return;
    (0, $7HchG.addXhrInstrumentationHandler)((handlerData)=>{
        if ((0, $gaxBK.getClient)() !== client) return;
        const { error: error, virtualError: virtualError } = handlerData;
        const xhr = handlerData.xhr;
        const sentryXhrData = xhr[0, $7HchG.SENTRY_XHR_DATA_KEY];
        if (!sentryXhrData) return;
        const { method: method, request_headers: headers } = sentryXhrData;
        try {
            $7fa23103a286c875$var$_xhrResponseHandler(options, xhr, method, headers, error || virtualError);
        } catch (e) {
            (0, $f67fK.DEBUG_BUILD) && (0, $gaxBK.debug).warn("Error while extracting response event form XHR response", e);
        }
    });
}
function $7fa23103a286c875$var$_shouldCaptureResponse(options, status, url) {
    return $7fa23103a286c875$var$_isInGivenStatusRanges(options.failedRequestStatusCodes, status) && $7fa23103a286c875$var$_isInGivenRequestTargets(options.failedRequestTargets, url) && !(0, $gaxBK.isSentryRequestUrl)(url, (0, $gaxBK.getClient)());
}
function $7fa23103a286c875$var$_createEvent(data) {
    const client = (0, $gaxBK.getClient)();
    const virtualStackTrace = client && data.error && data.error instanceof Error ? data.error.stack : void 0;
    const stack = virtualStackTrace && client ? client.getOptions().stackParser(virtualStackTrace, 0, 1) : void 0;
    const message = `HTTP Client Error with status code: ${data.status}`;
    const event = {
        message: message,
        exception: {
            values: [
                {
                    type: "Error",
                    value: message,
                    stacktrace: stack ? {
                        frames: stack
                    } : void 0
                }
            ]
        },
        request: {
            url: data.url,
            method: data.method,
            headers: data.requestHeaders,
            cookies: data.requestCookies
        },
        contexts: {
            response: {
                status_code: data.status,
                headers: data.responseHeaders,
                cookies: data.responseCookies,
                body_size: $7fa23103a286c875$var$_getResponseSizeFromHeaders(data.responseHeaders)
            }
        }
    };
    (0, $gaxBK.addExceptionMechanism)(event, {
        type: `auto.http.client.${data.type}`,
        handled: false
    });
    return event;
}
function $7fa23103a286c875$var$_getRequest(requestInfo, requestInit) {
    if (!requestInit && requestInfo instanceof Request) return requestInfo;
    if (requestInfo instanceof Request && requestInfo.bodyUsed) return requestInfo;
    return new Request(requestInfo, requestInit);
}
function $7fa23103a286c875$var$_getDataCollectionSettings() {
    const client = (0, $gaxBK.getClient)();
    if (!client) return {
        cookies: false,
        requestHeaders: false,
        responseHeaders: false
    };
    const options = client.getOptions();
    if (options.dataCollection == null) {
        const enabled = Boolean(options.sendDefaultPii);
        return {
            cookies: enabled,
            requestHeaders: enabled,
            responseHeaders: enabled
        };
    }
    const { cookies: cookies, httpHeaders: httpHeaders } = client.getDataCollectionOptions();
    return {
        cookies: cookies,
        requestHeaders: httpHeaders.request,
        responseHeaders: httpHeaders.response
    };
}


var $7llDh = parcelRequire("7llDh");
var $5da41ed4d29a4a37$exports = {};
$5da41ed4d29a4a37$exports = JSON.parse("{\"name\":\"xiframe\",\"version\":\"2.0.0\",\"type\":\"module\",\"private\":true,\"description\":\"allows a customer to launch a Frame session using their SEL Cloud credentials\",\"browserslist\":\"defaults\",\"engines\":{\"node\":\">=24\",\"npm\":\">=11\"},\"targets\":{\"default\":{\"source\":[\"src/index.html\",\"src/test.html\",\"src/clear.html\"],\"context\":\"browser\",\"distDir\":\"dist\",\"outputFormat\":\"esmodule\"}},\"scripts\":{\"start\":\"parcel\",\"dev\":\"parcel serve\",\"prebuild\":\"rimraf dist\",\"build\":\"parcel build --no-cache\",\"build:pr\":\"parcel build --no-cache --no-source-maps\",\"test\":\"jest\",\"test:ci\":\"jest --ci --verbose false\",\"typecheck\":\"tsc --noEmit -p tsconfig.test.json\",\"format\":\"prettier --write \\\"src/**/*.{js,ts,html,css,json}\\\" \\\"tests/**/*.{js,ts}\\\"\",\"format:check\":\"prettier --check \\\"src/**/*.{js,ts,html,css,json}\\\" \\\"tests/**/*.{js,ts}\\\"\",\"lint\":\"eslint src/scripts tests\",\"lint:fix\":\"eslint src/scripts tests --fix\",\"cm\":\"cz\",\"preserve\":\"npm run build\",\"serve\":\"npx http-serve -c0 dist\",\"sentry:sourcemaps\":\"sentry-cli sourcemaps inject --org enercalc-llc --project cloud-login ./dist && sentry-cli sourcemaps upload --org enercalc-llc --project cloud-login ./dist\",\"prepare\":\"husky\"},\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/enercalc/XiFrameLauncher.git\"},\"keywords\":[],\"author\":\"ENERCALC, LLC <devops@enercalc.com>\",\"license\":\"ISC\",\"homepage\":\"https://github.com/enercalc/XiFrameLauncher\",\"devDependencies\":{\"@babel/preset-typescript\":\"^7.28.5\",\"@eslint/js\":\"^10.0.1\",\"@futureportal/parcel-transformer-package-version\":\"^1.0.0\",\"@parcel/babel-plugin-transform-runtime\":\"^2.16.4\",\"@parcel/babel-preset-env\":\"^2.16.4\",\"@sentry/cli\":\"^3.6.2\",\"@types/crypto-js\":\"^4.2.2\",\"axios-mock-adapter\":\"^2.1.0\",\"babel-plugin-transform-remove-console\":\"^6.9.4\",\"buffer\":\"^6.0.3\",\"crypto-browserify\":\"^3.12.1\",\"cz-conventional-changelog\":\"^3.3.0\",\"eslint\":\"^10.8.0\",\"eslint-config-prettier\":\"^10.1.8\",\"eslint-plugin-jest\":\"^29.16.0\",\"events\":\"^3.3.0\",\"husky\":\"^9.1.7\",\"jest\":\"^29.7.0\",\"jest-environment-jsdom\":\"^29.7.0\",\"lint-staged\":\"^17.0.8\",\"parcel\":\"^2.16.4\",\"prettier\":\"^3.9.6\",\"process\":\"^0.11.10\",\"rimraf\":\"^6.1.3\",\"sharp\":\"^0.33.5\",\"stream-browserify\":\"^3.0.0\",\"typescript\":\"^5.9.3\",\"typescript-eslint\":\"^8.65.0\"},\"dependencies\":{\"@fra.me/terminal-factory\":\"^7.13.0\",\"@sentry/browser\":\"^10.67.0\",\"axios\":\"^1.18.1\",\"crypto-js\":\"^4.2.0\"},\"optionalDependencies\":{\"@parcel/watcher-linux-x64-glibc\":\"^2.6.0\"},\"lint-staged\":{\"src/**/*.{js,ts,html,css,json}\":\"prettier --write\",\"tests/**/*.{js,ts}\":\"prettier --write\"},\"config\":{\"commitizen\":{\"path\":\"./node_modules/cz-conventional-changelog\"}},\"@parcel/transformer-js\":{\"inlineEnvironment\":[\"GIT_SHA\",\"SENTRY_*\",\"CODEBUILD_RESOLVED_SOURCE_VERSION\"]}}");


var $165c87bc1a8ac848$exports = {};
$165c87bc1a8ac848$exports = JSON.parse("{\"notices\":[]}");



var $bAPCA = parcelRequire("bAPCA");

var $b5JSv = parcelRequire("b5JSv");
/**
 * App
 * Copyright 2025 ENERCALC, LLC
 * All rights reserved.
 *
 * Production entry for `index.html`. Initializes Sentry with the full
 * production options, builds the production {@link AppConfig}, and delegates all
 * orchestration to the shared `bootstrap` in `app-core.ts`.
 *
 * @author: ENERCALC, LLC
 * @version: 1.0.0
 */ /** @type {BrowserOptions} */ const $3e9c84597101687b$var$sentryOptions = {
    dsn: (0, $bAPCA.SENTRY_DSN),
    sendDefaultPii: true,
    integrations: [
        $716ac108ec783b6b$export$b4109253475213e9(),
        $gaxBK.captureConsoleIntegration({
            levels: [
                "error"
            ]
        }),
        $7fa23103a286c875$export$8a3b7aeb379b3907({
            failedRequestStatusCodes: [
                400,
                401,
                403,
                404,
                500,
                502,
                503,
                504,
                599
            ],
            failedRequestTargets: [
                "https://eneractivtest.com/.*"
            ]
        })
    ],
    tracesSampleRate: 0.5,
    tracePropagationTargets: [
        /^https:\/\/eneractivtest\.com/
    ],
    environment: undefined,
    release: "34d8daf3b326216eea586ca414488940d0761d70"
};
$7llDh.init($3e9c84597101687b$var$sentryOptions);
const $3e9c84597101687b$var$config = {
    awsRegionNames: (0, $bAPCA.AwsRegionNames),
    apiEndpoints: (0, $bAPCA.ApiEndpoints),
    cookieNames: (0, $bAPCA.CookieNames),
    frameAccountConfigs: (0, $bAPCA.FrameAccountConfigs),
    storageKeys: (0, $bAPCA.StorageKeys),
    notificationBanner: true,
    notices: (0, (/*@__PURE__*/$parcel$interopDefault($165c87bc1a8ac848$exports)))
};
(0, $b5JSv.bootstrap)($3e9c84597101687b$var$config);


//# sourceMappingURL=src691146790.d8cf3a05.js.map
